<template>
  <div class="vx-row jrb" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
    <Transition name="baikei-transition">
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-01' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-01.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-02' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb">
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-02_01.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-02_02.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-03' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb" >
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-03_01.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-03_02.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-03_03.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-03_04.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-03_05.jpg" width="100%" />
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 mb-base" v-if="jrb == 'jrb-04' && isOpenPreview && isShowComment" >
      <vx-card :title="jrb">
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-04_01.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-04_02.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-04_03.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-04_04.jpg" width="100%" />
        <img src="@/assets/images/jusetsu/screen-edit/jrb/M007-08/M007-08_jrb-04_05.jpg" width="100%" />
      </vx-card>
    </div>
    </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make" :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <vx-card class=" preview-edit-screen">
      <!-- 5 -->
      <table class="table-out" :id="`${arrayCommentId[0]}`">
        <tr>
          <th class="part-parent-name">
            5．宅地造成または建物建築の工事完了時における形状・構造等（対象不動産が未完成物件または新規物件の時）
          </th>
        </tr>
        <tr>
          <td>
            <radio-box @input="lostFocus" class="ml-5" v-model="kanryojikeijo_kozoto_umusentaku" vs-name="kanryojikeijo_kozoto_umusentaku" vs-value="1">別紙にて説明します。</radio-box>
            <radio-box @input="lostFocus" class="ml-20" v-model="kanryojikeijo_kozoto_umusentaku" vs-name="kanryojikeijo_kozoto_umusentaku" vs-value="0">未完成物件または新規物件に該当しないので、説明を省略します。</radio-box>
            <div v-if="formValidation.kanryojikeijo_kozoto_umusentaku.isWarning" class="text-warning ml-5" >
              {{formValidation.kanryojikeijo_kozoto_umusentaku.warningMsg}}
            </div>
          </td>
        </tr>
      </table>

        <!-- 6 -->
      <div v-if="jrb == 'jrb-03' || jrb =='jrb-04' ">
      <table class="table-out">
        <tr class="part-parent-name">
              <div class="p-2">【6.一棟の建物またはその敷地に関する権利及びこれらの管理・使用に関する事項】</div>
        </tr>
        <tr :id="`${arrayCommentId[1]}`">
          <div class="p-2 part-parent-name" >
            <span class="ml-2">(１）敷地に関する権利の種類および内容 </span>
          </div>
        </tr>
        <tr>
            <!-- (１）敷地に関する権利の種類および内容  -->
            <table>
              <tr>
                <th class="w-1/4" rowspan="3">敷地面積 </th>
                <th style="border-right: 0px;">
                    <span class="ml-6 m-auto" style="float:right;">実測面積： </span>
                </th>
                <th style="border-left: 0px;">
                  <div class="flex">
                    <div>
                      <vs-input @blur="shikichi_jissoku_menseki=formatNumber(shikichi_jissoku_menseki); lostFocus, focusOut()" @focus="onFocus('shikichi_jissoku_menseki')" :maxlength="handleMaxLength(10, shikichi_jissoku_menseki)" v-model="shikichi_jissoku_menseki"/>
                      <span class="tooltip-custom" :class="addPadding('shikichi_jissoku_menseki')">{{showMaxlength(10, shikichi_jissoku_menseki, 'shikichi_jissoku_menseki', true)}}</span>
                    </div>
                    <span class="ml-6 m-auto">㎡</span>
                  </div>
                </th>
              </tr>
              <tr>
                <th style="border-right: 0px;">
                  <span class="ml-6 m-auto" style="float:right;">登記簿面積： </span>
                </th>
                <th style="border-left: 0px;">
                  <div class="flex">
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('shikichi_tokibomenseki')" maxlength="16" v-model="shikichi_tokibomenseki" name="shikichi_tokibomenseki" />
                      <span class="tooltip-custom" :class="addPadding('shikichi_tokibomenseki')">{{showMaxlength(16, shikichi_tokibomenseki, 'shikichi_tokibomenseki')}}</span>
                    </div>
                    <span class="ml-6 m-auto">㎡</span>
                    <vs-button class="ml-4 m-auto btn-positive" @click="hanei_menseki" color="positive" type="filled" text-color="#7367F0" >面積反映</vs-button >
                  </div>
                  <div v-if="formValidation.shikichi_tokibomenseki.isWarning" class="text-warning">
                    {{formValidation.shikichi_tokibomenseki.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th style="border-right: 0px;">
                  <span class="ml-6 m-auto" style="float:right;">建築確認の対象面積： </span>
                </th>
                <th style="border-left: 0px;">
                  <div class="flex">
                  <div>
                    <vs-input @blur="shikichi_kenchiku_kakunin_menseki=formatNumber(shikichi_kenchiku_kakunin_menseki); lostFocus, focusOut()" @focus="onFocus('shikichi_kenchiku_kakunin_menseki')" :maxlength="handleMaxLength(10, shikichi_kenchiku_kakunin_menseki)" v-model="shikichi_kenchiku_kakunin_menseki" name="shikichi_kenchiku_kakunin_menseki" />
                    <span class="tooltip-custom" :class="addPadding('shikichi_kenchiku_kakunin_menseki')">{{showMaxlength(10, shikichi_kenchiku_kakunin_menseki, 'shikichi_kenchiku_kakunin_menseki', true)}}</span>
                  </div>
                    <span class="ml-6 m-auto">㎡</span>
                  </div>
                  <div v-if="formValidation.shikichi_kenchiku_kakunin_menseki.isWarning" class="text-warning mt-8px">
                    {{formValidation.shikichi_kenchiku_kakunin_menseki.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th>権利の種類</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox class="" v-model="kenrishurui_shoyuken"> １.所有権・</vs-checkbox>
                    <vs-checkbox class="" v-model="kenrishurui_shakuchiken" @change="change_check_kenrishurui_shakuchiken"> ２.借地権（</vs-checkbox>
                    <vs-checkbox class="" v-model="kenrishurui_chijoken" :disabled= "!kenrishurui_shakuchiken" > 地上権・</vs-checkbox>
                    <vs-checkbox class="" v-model="kenrishurui_chinshaku" :disabled= "!kenrishurui_shakuchiken"> 賃借権）</vs-checkbox>
                  </div>
                </th>
              </tr>
              <tr>
                <th>借地権の場合</th>
                <th colspan="2">
                  <div class="flex">
                    <span class="m-auto-top-bottom ml-2">対象面積：</span>
                    <div>
                      <vs-input @blur="shikichi_taisho_menseki=formatNumber(shikichi_taisho_menseki); lostFocus, focusOut()" @focus="onFocus('shikichi_taisho_menseki')" :maxlength="handleMaxLength(10, shikichi_taisho_menseki)" class="ml-6" v-model="shikichi_taisho_menseki"/>
                      <span class="tooltip-custom ml-6" :class="addPadding('shikichi_taisho_menseki')">{{showMaxlength(10, shikichi_taisho_menseki, 'shikichi_taisho_menseki', true)}}</span>
                    </div>
                    <span class="m-auto-top-bottom ml-6">㎡</span>
                    <span class="m-auto-top-bottom ml-6"> (  </span>
                    <radio-box @input="lostFocus" v-model="shikichi_tokibo_jissoku_kubun" vs-name="shikichi_tokibo_jissoku_kubun" vs-value="0" class="ml-1 m-auto-top-bottom">登記簿・</radio-box>
                    <radio-box @input="lostFocus" v-model="shikichi_tokibo_jissoku_kubun" vs-name="shikichi_tokibo_jissoku_kubun" vs-value="1" class="ml-2 m-auto-top-bottom"> 実測 )</radio-box>
                  </div>
                </th>
              </tr>
              <tr>
                <td>借地権の存続期間</td>
                <td colspan="2">
                  <DatePickerCustom class="ml-2" v-model="shikichi_shakuchiken_sonzokukikan_nengappi"
                                    @lost-focus="lostFocus"
                                    name = "shikichi_shakuchiken_sonzokukikan_nengappi"
                                    :date="shikichi_shakuchiken_sonzokukikan_nengappi"
                                    :checkboxvalue="shikichi_shakuchiken_sonzokukikan_nengappi_checkbox"
                                    v-on:change-checkbox="shikichi_shakuchiken_sonzokukikan_nengappi_checkbox = $event"
                                    format="yyyy-MM-dd" separate="-"/>
                  <div class="text-warning" v-if="formValidation.shikichi_shakuchiken_sonzokukikan_nengappi.isWarning" style="margin-left: 10px">
                    {{formValidation.shikichi_shakuchiken_sonzokukikan_nengappi.warningMsg}}</div>
                  <div class="text-danger" v-if="formValidation.shikichi_shakuchiken_sonzokukikan_nengappi.isError" style="margin-left: 10px">
                    {{formValidation.shikichi_shakuchiken_sonzokukikan_nengappi.errorMsg}}
                  </div>
                </td>
              </tr>
              <tr>
                <th>区分所有者の負担額（地代）</th>
                <th colspan="2">
                  <div class="flex">
                    <span class="ml-2 m-auto-top-bottom">月額：</span>
                    <div>
                      <vs-input @blur="shikichi_kingaku=formatIntegerAdvanced(shikichi_kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus('shikichi_kingaku')" :maxlength="handleMaxLength(12, shikichi_kingaku)" class="ml-4" v-model="shikichi_kingaku"/>
                      <span class="tooltip-custom ml-4" :class="addPadding('shikichi_kingaku')">{{showMaxlength(12, shikichi_kingaku, 'shikichi_kingaku', true)}}</span>
                    </div>
                    <span  class="ml-6 m-auto font-light">円</span>
                  </div>
                </th>
              </tr>
              <tr>
                <th>「以下余白」の表示</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox v-model="shikichi_biko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </th>
              </tr>
              <tr>
                <th>黒点／ナンバリング表示</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox v-model="shikichi_biko_numbering" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </th>
              </tr>
            </table>
            <table :id="`${arrayCommentId[2]}`">
              <draggable v-model="shikichi_biko_inputs" handle=".handle">
                <table class="w-full" v-for="(shikichi_biko_t, index) in shikichi_biko_inputs" :key="`shikichi_biko-${index}`">
                  <tr>
                    <td class="w-1/4">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="shikichi_biko_t.checkboxDelete" >備考 {{index + 1}} </vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td colspan="2">
                      <div class="flex items-center">
                        <BunshoTemplate v-model="shikichi_biko_t.naiyo" :screen="bunshoScreen(1)" />
                        <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                      </div>
                      <div class="ml-2 mr-5">
                          <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`shikichi_biko_t.naiyo.${index}`)" class="mt-2 mb-0" rows="5" maxlength="3000" v-model="shikichi_biko_t.naiyo"/>
                          <span class="tooltip-custom" :class="addPadding(`shikichi_biko_t.naiyo.${index}`)">{{showMaxlength(3000 ,shikichi_biko_t.naiyo ,`shikichi_biko_t.naiyo.${index}`)}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
            </table>
            <div class="flex justify-end mt-2 mr-8" >
                <vs-button class="ml-4 btn-positive" @click="add_biko(shikichi_biko_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('shikichi_biko_inputs', shikichi_biko_inputs )" class="ml-4 btn-positive">項目削除 </vs-button>
            </div>
            <!-- （2）共用部分に関する規約等の定め -->
            <div class="flex mtb-10 p-2 part-parent-name"  :id="`${arrayCommentId[3]}`">
              <span>（2）共用部分に関する規約等の定め（</span>
              <radio-box @input="lostFocus" v-model="kyoyobubun_kyoyo_bubun" vs-name="kyoyobubun_kyoyo_bubun" vs-value="1"> 有・</radio-box>
              <radio-box @input="lostFocus" v-model="kyoyobubun_kyoyo_bubun" vs-name="kyoyobubun_kyoyo_bubun" vs-value="0"> 無）</radio-box>
            </div>
            <div v-if="formValidation.kyoyobubun_kyoyo_bubun.isWarning" class="text-warning" style="margin-left: 256px;">
              {{formValidation.kyoyobubun_kyoyo_bubun.warningMsg}}
            </div>
            <table>
              <tr>
                <th class="w-1/4">共用部分の範囲 </th>
                <th >
                  <div class="flex">
                    <span class="ml-2">共用の玄関・廊下・階段・外壁・建物躯体・配線（主線）・配管（主管）等 </span><br>
                  </div>
                  <div>
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('kyoyobubun_hani')" maxlength="35" class="m-2 mr-4" v-model="kyoyobubun_hani" name="kyoyobubun_hani" />
                    <span class="tooltip-custom" :class="addPadding('kyoyobubun_hani')">{{showMaxlength(35, kyoyobubun_hani ,'kyoyobubun_hani')}}</span>
                  </div>
                  <div v-if="formValidation.kyoyobubun_hani.isWarning" class="text-warning" style="margin-left: 5px;">
                    {{formValidation.kyoyobubun_hani.warningMsg}}
                  </div>
                  <div class="flex ml-2">
                    <span class="m-auto-top-bottom">管理規約</span>
                    <div class="ml-6 w-36">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kyoyobubun_kanri_kiyaku')" maxlength="11" v-model="kyoyobubun_kanri_kiyaku" name="kyoyobubun_kanri_kiyaku" />
                      <span class="tooltip-custom" :class="addPadding('kyoyobubun_kanri_kiyaku')">{{showMaxlength(11, kyoyobubun_kanri_kiyaku, 'kyoyobubun_kanri_kiyaku')}}</span>
                    </div>
                    <span class="m-auto font-light ml-3">条</span>
                  </div>
                  <div v-if="formValidation.kyoyobubun_kanri_kiyaku.isWarning" class="text-warning" style="margin-left: 75px;">
                    {{formValidation.kyoyobubun_kanri_kiyaku.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th>共用部分の持分の割合</th>
                <td>
                  <radio-box @input="lostFocus" class="ml-2" v-model="kyoyobubun_kubun_sentaku" vs-name="kyoyobubun_kubun_sentaku" vs-value="0" > 1. 専有部分の床面積の割合による </radio-box>
                  <div class="flex pt-2 ml-2">
                    <radio-box @input="lostFocus" v-model="kyoyobubun_kubun_sentaku" vs-name="kyoyobubun_kubun_sentaku" vs-value="1"> 2.</radio-box>
                    <div class="ml-2 w-4/5 ">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kyoyobubun_kubun_kisai')" maxlength="8" v-model="kyoyobubun_kubun_kisai" name="kyoyobubun_kubun_kisai" />
                      <span class="tooltip-custom" :class="addPadding('kyoyobubun_kubun_kisai')">{{showMaxlength(8, kyoyobubun_kubun_kisai, 'kyoyobubun_kubun_kisai')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.kyoyobubun_kubun_kisai.isWarning" class="text-warning" style="margin-left: 50px">
                      {{formValidation.kyoyobubun_kubun_kisai.warningMsg}}
                    </div>
                  <div v-if="formValidation.kyoyobubun_kubun_sentaku.isWarning" class="text-warning" style="margin-left: 5px;">
                    {{formValidation.kyoyobubun_kubun_sentaku.warningMsg}}
                  </div>
                  <div class="flex mt-2 ml-2">
                    <span class="m-auto-top-bottom">管理規約</span>
                    <div class="ml-6 w-36">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kyoyobubun_mochibunwariai_jorei')" maxlength="11" v-model="kyoyobubun_mochibunwariai_jorei" name="kyoyobubun_mochibunwariai_jorei" />
                      <span class="tooltip-custom" :class="addPadding('kyoyobubun_mochibunwariai_jorei')">{{showMaxlength(11, kyoyobubun_mochibunwariai_jorei, 'kyoyobubun_mochibunwariai_jorei')}}</span>
                    </div>
                    <span class="m-auto font-light ml-3">条</span>
                  </div>
                   <div v-if="formValidation.kyoyobubun_mochibunwariai_jorei.isWarning" class="text-warning" style="margin-left: 75px;">
                    {{formValidation.kyoyobubun_mochibunwariai_jorei.warningMsg}}
                  </div>
                </td>
              </tr>
              <tr>
                <th>「以下余白」の表示</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox v-model="kyoyobubun_biko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </th>
              </tr>
              <tr>
                <th>黒点／ナンバリング表示</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox v-model="kyoyobubun_biko_numbering" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </th>
              </tr>
            </table>
            <table :id="`${arrayCommentId[4]}`">
              <draggable v-model="kyoyobubun_biko_inputs" handle=".handle">
                <table class="w-full" v-for="(kyoyobubun_biko_t, index) in kyoyobubun_biko_inputs" :key="`kyoyobubun_biko-${index}`">
                  <tr>
                    <td class="w-1/4">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="kyoyobubun_biko_t.checkboxDelete">備考 {{index + 1}} </vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                        <div class="flex items-center">
                          <BunshoTemplate v-model="kyoyobubun_biko_t.naiyo" :screen="bunshoScreen(2)" />
                          <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                        </div>
                        <div class="ml-2 mr-5">
                            <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`kyoyobubun_biko_t.naiyo.${index}`)" maxlength="3000" class="mt-2 mb-0" rows="5" v-model="kyoyobubun_biko_t.naiyo"/>
                            <span class="tooltip-custom" :class="addPadding(`kyoyobubun_biko_t.naiyo.${index}`)">{{showMaxlength(3000 ,kyoyobubun_biko_t.naiyo , `kyoyobubun_biko_t.naiyo.${index}`)}}</span>
                        </div>
                    </td>
                  </tr>
                </table>
              </draggable>
            </table>
            <div class="flex justify-end mt-2 mr-8" >
                <vs-button class="ml-4" @click="add_biko(kyoyobubun_biko_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('kyoyobubun_biko_inputs', kyoyobubun_biko_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
            </div>
            <!-- （３）専有部分の用途その他の利用の制限に関する規約等の定め -->
            <div class="flex mtb-10 p-2 part-parent-name" :id="`${arrayCommentId[5]}`">
              <span>（３）専有部分の用途その他の利用の制限に関する規約等の定め（別添管理規約・使用細則に記載されています。）</span>
            </div>
            <table>
              <tr>
                <th class="text-center" style="width: 30%">
                  用途制限 <br>
                  <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="yotoseigen_seigen_naiyo=hanyo._1; lostFocus()">用途制限</vs-button>
                </th>
                <th>
                  <radio-box @input="lostFocus" class="ml-2" v-model="yotoseigen_yotoseigen" vs-name="yotoseigen_yotoseigen" vs-value="1"> 有・</radio-box>
                  <radio-box @input="lostFocus" v-model="yotoseigen_yotoseigen" vs-name="yotoseigen_yotoseigen" vs-value="0"> 無</radio-box> <br>
                  <div v-if="formValidation.yotoseigen_yotoseigen.isWarning" class="text-warning ml-2">
                    {{formValidation.yotoseigen_yotoseigen.warningMsg}}
                  </div>
                  <div class="flex-row">
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('yotoseigen_seigen_naiyo')" class="ml-2 mt-1 mr-4 mb-1"
                                 v-model="yotoseigen_seigen_naiyo"
                                 name="yotoseigen_seigen_naiyo"
                                 maxlength="132"/>
                    <span class="tooltip-custom" :class="addPadding('yotoseigen_seigen_naiyo')">{{showMaxlength(132 ,yotoseigen_seigen_naiyo ,'yotoseigen_seigen_naiyo' )}}</span>
                    <div v-if="formValidation.yotoseigen_seigen_naiyo.isWarning" class="text-warning" style="margin-left: 5px">
                      {{formValidation.yotoseigen_seigen_naiyo.warningMsg}}
                    </div>
                  </div>
                  <div class="flex ml-2">
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom">管理規約</span>
                        <div class="w-24 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('yotoseigen_kanrikiyaku')" v-model="yotoseigen_kanrikiyaku" name="yotoseigen_kanrikiyaku" maxlength="4"/>
                          <span class="tooltip-custom" :class="addPadding('yotoseigen_kanrikiyaku')">{{showMaxlength(4, yotoseigen_kanrikiyaku, 'yotoseigen_kanrikiyaku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3 mr-5">条</span>
                      </div>
                      <div v-if="formValidation.yotoseigen_kanrikiyaku.isWarning" class="text-warning" style="margin-left: 70px">
                      {{formValidation.yotoseigen_kanrikiyaku.warningMsg}}
                      </div>
                    </div>
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom ml-5">使用細則</span>
                        <div class="w-24 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('yotoseigen_shiyosaisoku')"  v-model="yotoseigen_shiyosaisoku" name="yotoseigen_shiyosaisoku" maxlength="4"/>
                          <span class="tooltip-custom" :class="addPadding('yotoseigen_shiyosaisoku')">{{showMaxlength(4, yotoseigen_shiyosaisoku, 'yotoseigen_shiyosaisoku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3">条</span>
                      </div>
                      <div v-if="formValidation.yotoseigen_shiyosaisoku.isWarning" class="text-warning" style="margin-left: 87px">
                        {{formValidation.yotoseigen_shiyosaisoku.warningMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="text-center">
                  ペットの飼育制限 <br>
                  <vs-button class="my-1 btn-positive" color="positive" type="filled" text-color="#7367F0" @click="pettoseigen_seigen_naiyo = hanyo._2; lostFocus()">ペット飼育 禁止</vs-button>
                  <vs-button class="my-1 btn-positive ml-2" color="positive" type="filled" text-color="#7367F0" @click="pettoseigen_seigen_naiyo = hanyo._3; lostFocus()">ペット飼育 可能</vs-button>
                </th>
                <th>
                  <div class="flex">
                    <radio-box @input="lostFocus" class="ml-2" v-model="pettoseigen_yotoseigen" vs-name="pettoseigen_yotoseigen" vs-value="1"> 有・</radio-box>
                    <radio-box @input="lostFocus" v-model="pettoseigen_yotoseigen" vs-name="pettoseigen_yotoseigen" vs-value="0"> 無</radio-box> <br>
                  </div>
                  <div v-if="formValidation.pettoseigen_yotoseigen.isWarning" class="text-warning ml-2 mt-1">
                    {{formValidation.pettoseigen_yotoseigen.warningMsg}}
                  </div>
                  <div class="ml-2 mt-1 mr-4 mb-1">
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('pettoseigen_seigen_naiyo')" maxlength="132" v-model="pettoseigen_seigen_naiyo" name="pettoseigen_seigen_naiyo"/>
                    <span class="tooltip-custom -mt-4" :class="addPadding('pettoseigen_seigen_naiyo')">{{showMaxlength( 132,pettoseigen_seigen_naiyo , 'pettoseigen_seigen_naiyo')}}</span>
                  </div>
                  <div v-if="formValidation.pettoseigen_seigen_naiyo.isWarning" class="text-warning"  style="margin-left: 5px">
                    {{formValidation.pettoseigen_seigen_naiyo.warningMsg}}
                  </div>
                  <div class="flex ml-2">
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom">管理規約</span>
                        <div class="w-24 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('pettoseigen_kanrikiyaku')"  v-model="pettoseigen_kanrikiyaku" name="pettoseigen_kanrikiyaku" maxlength="4"/>
                          <span class="tooltip-custom" :class="addPadding('pettoseigen_kanrikiyaku')">{{showMaxlength(4, pettoseigen_kanrikiyaku, 'pettoseigen_kanrikiyaku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3 mr-5">条</span>
                      </div>
                      <div v-if="formValidation.pettoseigen_kanrikiyaku.isWarning" class="text-warning" style="margin-left: 70px">
                        {{formValidation.pettoseigen_kanrikiyaku.warningMsg}}
                      </div>
                    </div>
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom ml-5">使用細則</span>
                        <div class="w-24 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('pettoseigen_shiyosaisoku')" v-model="pettoseigen_shiyosaisoku" name="pettoseigen_shiyosaisoku" maxlength="4" />
                          <span class="tooltip-custom" :class="addPadding('pettoseigen_shiyosaisoku')">{{showMaxlength(4, pettoseigen_shiyosaisoku, 'pettoseigen_shiyosaisoku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3">条</span>
                      </div>
                      <div v-if="formValidation.pettoseigen_shiyosaisoku.isWarning" class="text-warning" style="margin-left: 87px">
                        {{formValidation.pettoseigen_shiyosaisoku.warningMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="text-center">
                  フローリングの制限 <br>
                  <vs-button class="my-1 btn-positive mr-7px" color="positive" type="filled" text-color="#7367F0" @click="furoringuseigen_seigen_naiyo = hanyo._4; lostFocus()">フローリング 禁止</vs-button>
                  <vs-button class="my-1 btn-positive" color="positive" type="filled" text-color="#7367F0" @click="furoringuseigen_seigen_naiyo = hanyo._5; lostFocus()">フローリング  制限つき 可</vs-button>
                  <vs-button class="my-1 btn-positive" color="positive" type="filled" text-color="#7367F0" @click="furoringuseigen_seigen_naiyo = hanyo._6; lostFocus()">フローリング 届出要</vs-button>
                </th>
                <th>
                  <radio-box @input="lostFocus" class="ml-2" v-model="furoringuseigen_yotoseigen" vs-name="furoringuseigen_yotoseigen" vs-value="1"> 有・</radio-box>
                  <radio-box @input="lostFocus" v-model="furoringuseigen_yotoseigen" vs-name="furoringuseigen_yotoseigen" vs-value="0"> 無</radio-box> <br>
                   <div v-if="formValidation.furoringuseigen_yotoseigen.isWarning" class="text-warning ml-2">
                    {{formValidation.furoringuseigen_yotoseigen.warningMsg}}
                  </div>
                  <div class="ml-2 mt-1 mr-4 mb-1">
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('furoringuseigen_seigen_naiyo')"  v-model="furoringuseigen_seigen_naiyo" name="furoringuseigen_seigen_naiyo" maxlength="132"/>
                    <span class="tooltip-custom -mt-4" :class="addPadding('furoringuseigen_seigen_naiyo')">{{showMaxlength(132, furoringuseigen_seigen_naiyo, 'furoringuseigen_seigen_naiyo')}}</span>
                  </div>
                   <div v-if="formValidation.furoringuseigen_seigen_naiyo.isWarning" class="text-warning" style="margin-left: 5px;">
                    {{formValidation.furoringuseigen_seigen_naiyo.warningMsg}}
                  </div>
                  <div class="flex ml-2">
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom">管理規約</span>
                        <div  class="w-24 ml-6">  
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('furoringuseigen_kanrikiyaku')" maxlength="4" v-model="furoringuseigen_kanrikiyaku" name="furoringuseigen_kanrikiyaku"/>
                          <span class="tooltip-custom" :class="addPadding('furoringuseigen_kanrikiyaku')">{{showMaxlength(4, furoringuseigen_kanrikiyaku, 'furoringuseigen_kanrikiyaku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3 mr-5">条</span>
                      </div>
                       <div v-if="formValidation.furoringuseigen_kanrikiyaku.isWarning" class="text-warning" style="margin-left: 70px">
                        {{formValidation.furoringuseigen_kanrikiyaku.warningMsg}}
                      </div>
                    </div>
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom ml-5">使用細則</span>
                        <div  class="w-24 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('furoringuseigen_shiyosaisoku')" v-model="furoringuseigen_shiyosaisoku" name="furoringuseigen_shiyosaisoku" maxlength="4"/>
                          <span class="tooltip-custom" :class="addPadding('furoringuseigen_shiyosaisoku')">{{showMaxlength(4, furoringuseigen_shiyosaisoku, 'furoringuseigen_shiyosaisoku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3">条</span>
                      </div>
                       <div v-if="formValidation.furoringuseigen_shiyosaisoku.isWarning" class="text-warning" style="margin-left: 87px">
                        {{formValidation.furoringuseigen_shiyosaisoku.warningMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="text-center">
                  楽器の使用制限 <br>
                  <vs-button class="my-1 btn-positive" color="positive" type="filled" text-color="#7367F0" @click="gakkishiyo_seigen_naiyo = hanyo._7; lostFocus()">楽器の使用制限</vs-button>
                </th>
                <th>
                  <radio-box @input="lostFocus" class="ml-2" v-model="gakkishiyo_yotoseigen" vs-name="gakkishiyo_yotoseigen" vs-value="1"> 有・</radio-box>
                  <radio-box @input="lostFocus" v-model="gakkishiyo_yotoseigen" vs-name="gakkishiyo_yotoseigen" vs-value="0"> 無</radio-box> <br>
                  <div v-if="formValidation.gakkishiyo_yotoseigen.isWarning" class="text-warning ml-2">
                    {{formValidation.gakkishiyo_yotoseigen.warningMsg}}
                  </div>
                  <div class="ml-2 mt-1 mr-4 mb-1">
                   <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('gakkishiyo_seigen_naiyo')" v-model="gakkishiyo_seigen_naiyo" name="gakkishiyo_seigen_naiyo" maxlength="132"/>
                   <span class="tooltip-custom -mt-4" :class="addPadding('gakkishiyo_seigen_naiyo')">{{showMaxlength( 132, gakkishiyo_seigen_naiyo, 'gakkishiyo_seigen_naiyo' )}}</span>
                  </div>
                  <div v-if="formValidation.gakkishiyo_seigen_naiyo.isWarning" class="text-warning" style="margin-left: 5px;">
                    {{formValidation.gakkishiyo_seigen_naiyo.warningMsg}}
                  </div>
                  <div class="flex ml-2">
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom">管理規約</span>
                        <div class="w-24 ml-6">
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('gakkishiyo_kanrikiyaku')" v-model="gakkishiyo_kanrikiyaku" name="gakkishiyo_kanrikiyaku" maxlength="4"/>
                          <span class="tooltip-custom" :class="addPadding('gakkishiyo_kanrikiyaku')">{{showMaxlength(4, gakkishiyo_kanrikiyaku, 'gakkishiyo_kanrikiyaku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3 mr-5">条</span>
                      </div>
                      <div v-if="formValidation.gakkishiyo_kanrikiyaku.isWarning" class="text-warning" style="margin-left: 70px">
                        {{formValidation.gakkishiyo_kanrikiyaku.warningMsg}}
                      </div>
                    </div>
                    <div class="flex-row">
                      <div class="flex">
                        <span class="m-auto-top-bottom ml-5">使用細則</span>
                        <div class="w-24 ml-6" >
                          <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('gakkishiyo_shiyosaisoku')" v-model="gakkishiyo_shiyosaisoku"  name="gakkishiyo_shiyosaisoku" maxlength="4"/>
                          <span class="tooltip-custom" :class="addPadding('gakkishiyo_shiyosaisoku')">{{showMaxlength(4, gakkishiyo_shiyosaisoku, 'gakkishiyo_shiyosaisoku')}}</span>
                        </div>
                        <span class="m-auto font-light ml-3">条</span>
                      </div>
                      <div v-if="formValidation.gakkishiyo_shiyosaisoku.isWarning" class="text-warning" style="margin-left: 87px">
                        {{formValidation.gakkishiyo_shiyosaisoku.warningMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th>「以下余白」の表示</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox v-model="senyububun_biko1_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </th>
              </tr>
              <tr>
                <th>黒点／ナンバリング表示</th>
                <th colspan="2">
                  <div class="flex">
                    <vs-checkbox v-model="senyububun_biko1_numbering" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </th>
              </tr>
            </table>
            <table :id="`${arrayCommentId[6]}`">
              <draggable v-model="senyububun_biko1_inputs" handle=".handle">
                <table class="w-full" v-for="(senyububun_biko1_t, index) in senyububun_biko1_inputs" :key="`senyububun_biko1-${index}`">
                  <tr>
                    <td class="w-30">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="senyububun_biko1_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="flex items-center">
                        <BunshoTemplate v-model="senyububun_biko1_t.naiyo" :screen="bunshoScreen(3)" />
                        <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                      </div>
                      <div class="ml-2 mr-5">
                        <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`senyububun_biko1_t.naiyo.${index}`)" class="mt-4 mb-0" rows="5" v-model="senyububun_biko1_t.naiyo" maxlength="3000" />
                        <span class="tooltip-custom" :class="addPadding(`senyububun_biko1_t.naiyo.${index}`)">{{showMaxlength( 3000, senyububun_biko1_t.naiyo, `senyububun_biko1_t.naiyo.${index}`)}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
            </table>
            <div class="flex justify-end mt-2 mr-8" >
                <vs-button class="ml-4" @click="add_biko(senyububun_biko1_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('senyububun_biko1_inputs', senyububun_biko1_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
            </div>
            <!--（４）専用使用権に関する規約等の定め-->
            <div style="border: 1px solid #B8C2CC;" class="flex mtb-10 part-parent-name p-2" :id="`${arrayCommentId[7]}`">
              <span>【(4)専用使用権に関する規約等の定め】</span>
            </div>
              <div class="flex ml-2 mb-3">
                <div class="flex-row">
                  <div class="flex">
                    <span class="m-auto-top-bottom">別添管理規約</span>
                    <div class="w-36 ml-6">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('hosoku_kanrikiyaku')" v-model="hosoku_kanrikiyaku" name="hosoku_kanrikiyaku" maxlength="8"/>
                      <span class="tooltip-custom" :class="addPadding('hosoku_kanrikiyaku')">{{showMaxlength(8, hosoku_kanrikiyaku, 'hosoku_kanrikiyaku')}}</span>
                    </div>
                    <span class="m-auto font-light ml-3 mr-5">条</span>
                  </div>
                  <div class="text-warning mt-1" v-if="formValidation.hosoku_kanrikiyaku.isWarning" style="margin-left: 106px;">
                    {{formValidation.hosoku_kanrikiyaku.warningMsg}}
                  </div>
                </div>
                <div class="flex-row ml-4">
                  <div class="flex">
                    <span class="m-auto-top-bottom">使用細則</span>
                    <div class="w-36 ml-6">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('hosoku_shiyosaisoku')" v-model="hosoku_shiyosaisoku" name="hosoku_shiyosaisoku" maxlength="8"/>
                      <span class="tooltip-custom" :class="addPadding('hosoku_shiyosaisoku')">{{showMaxlength(8, hosoku_shiyosaisoku, 'hosoku_shiyosaisoku')}}</span>
                    </div>
                    <span class="m-auto font-light ml-3">条</span>
                  </div>
                  <div class="text-warning mt-1" v-if="formValidation.hosoku_shiyosaisoku.isWarning" style="margin-left: 76px;">
                    {{formValidation.hosoku_shiyosaisoku.warningMsg}}
                  </div>
                </div>
              </div>
             <!-- ①一棟の建物およびその敷地の専用使用権について -->
            <div class="part-parent-name p-2">
              <span>①一棟の建物およびその敷地の専用使用権について</span>
            </div>
            <table>
              <tr>
                <th colspan="2" >名称</th>
                <th>専用使用をなしうる者</th>
                <th colspan="2">専用使用料の有無とその帰属先</th>
                <th>備考</th>
              </tr>
              <tr>
                <th style="width: 20%;">バルコニー</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="barukoni_umusentaku" vs-name="barukoni_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="barukoni_umusentaku" vs-name="barukoni_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.barukoni_umusentaku.isWarning" class="text-warning">
                    {{formValidation.barukoni_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('barukoni_kubun_shoyusha')" style="width: auto;" v-model="barukoni_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('barukoni_kubun_shoyusha')">{{showMaxlength(26, barukoni_kubun_shoyusha, 'barukoni_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="barukoni_kizokusaki_umusentaku" vs-name="barukoni_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="barukoni_kizokusaki_umusentaku" vs-name="barukoni_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.barukoni_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.barukoni_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="barukoni_senyoshiyoryo_kizokusaki_kubun" vs-name="barukoni_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex;">
                    <radio-box @input="lostFocus" v-model="barukoni_senyoshiyoryo_kizokusaki_kubun" vs-name="barukoni_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('barukoni_sakikubun_setsumei')" style="width: auto;" v-model="barukoni_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('barukoni_sakikubun_setsumei')">{{showMaxlength(18, barukoni_sakikubun_setsumei, 'barukoni_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.barukoni_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.barukoni_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('barukoni_biko')" class="mb-2" v-model="barukoni_biko" maxlength="14"></vs-input>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('barukoni_biko2')" class="mb-0" v-model="barukoni_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('barukoni_biko2')">{{showMaxlength(14, barukoni_biko2, 'barukoni_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('barukoni_biko')" class="mb-0" v-model="barukoni_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('barukoni_biko')">{{showMaxlength(28, barukoni_biko, 'barukoni_biko')}}</span>
                </th>
              </tr>
              <tr>
                <th style="width: 20%;">玄関扉、窓枠、窓ガラス</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="madonado_umusentaku" vs-name="madonado_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="madonado_umusentaku" vs-name="madonado_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.madonado_umusentaku.isWarning" class="text-warning">
                    {{formValidation.madonado_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('madonado_kubun_shoyusha')" style="width: auto;" v-model="madonado_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('madonado_kubun_shoyusha')">{{showMaxlength(26, madonado_kubun_shoyusha, 'madonado_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="madonado_kizokusaki_umusentaku" vs-name="madonado_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="madonado_kizokusaki_umusentaku" vs-name="madonado_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.madonado_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.madonado_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="madonado_senyoshiyoryo_kizokusaki_kubun" vs-name="madonado_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex;">
                    <radio-box @input="lostFocus" v-model="madonado_senyoshiyoryo_kizokusaki_kubun" vs-name="madonado_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('madonado_sakikubun_setsumei')" style="width: auto;" v-model="madonado_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('madonado_sakikubun_setsumei')">{{showMaxlength(18, madonado_sakikubun_setsumei, 'madonado_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.madonado_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.madonado_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('madonado_biko')" class="mb-2" v-model="madonado_biko" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('madonado_biko')">{{showMaxlength(14, madonado_biko, 'madonado_biko')}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('madonado_biko2')" class="mb-0" v-model="madonado_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('madonado_biko2')">{{showMaxlength(14, madonado_biko2, 'madonado_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('madonado_biko')" class="mb-0" v-model="madonado_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('madonado_biko')">{{showMaxlength(28, madonado_biko, 'madonado_biko')}}</span>
                </th>
              </tr>
              <tr>
                <th style="width: 20%;">専用庭</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="senyotei_umusentaku" vs-name="senyotei_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="senyotei_umusentaku" vs-name="senyotei_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.senyotei_umusentaku.isWarning" class="text-warning">
                    {{formValidation.senyotei_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('senyotei_kubun_shoyusha')" style="width: auto;" v-model="senyotei_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('senyotei_kubun_shoyusha')">{{showMaxlength(26, senyotei_kubun_shoyusha, 'senyotei_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="senyotei_kizokusaki_umusentaku" vs-name="senyotei_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="senyotei_kizokusaki_umusentaku" vs-name="senyotei_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.senyotei_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.senyotei_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="senyotei_senyoshiyoryo_kizokusaki_kubun" vs-name="senyotei_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex">
                    <radio-box @input="lostFocus" v-model="senyotei_senyoshiyoryo_kizokusaki_kubun" vs-name="senyotei_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('senyotei_sakikubun_setsumei')" style="width: auto;" v-model="senyotei_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('senyotei_sakikubun_setsumei')">{{showMaxlength(18, senyotei_sakikubun_setsumei, 'senyotei_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.senyotei_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.senyotei_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('senyotei_biko')" class="mb-2" v-model="senyotei_biko" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('senyotei_biko')">{{showMaxlength(14, senyotei_biko, 'senyotei_biko')}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('senyotei_biko2')" class="mb-0" v-model="senyotei_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('senyotei_biko2')">{{showMaxlength(14, senyotei_biko2, 'senyotei_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('senyotei_biko')" class="mb-0" v-model="senyotei_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('senyotei_biko')">{{showMaxlength(28, senyotei_biko, 'senyotei_biko')}}</span>
                </th>
              </tr>
              <tr>
                <th style="width: 20%;">ルーフバルコニー</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="rufubarukoni_umusentaku" vs-name="rufubarukoni_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="rufubarukoni_umusentaku" vs-name="rufubarukoni_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.rufubarukoni_umusentaku.isWarning" class="text-warning">
                    {{formValidation.rufubarukoni_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('rufubarukoni_kubun_shoyusha')" style="width: auto;" v-model="rufubarukoni_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('rufubarukoni_kubun_shoyusha')">{{showMaxlength(26, rufubarukoni_kubun_shoyusha, 'rufubarukoni_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="rufubarukoni_kizokusaki_umusentaku" vs-name="rufubarukoni_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="rufubarukoni_kizokusaki_umusentaku" vs-name="rufubarukoni_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.rufubarukoni_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.rufubarukoni_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="rufubarukoni_senyoshiyoryo_kizokusaki_kubun" vs-name="rufubarukoni_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex">
                    <radio-box @input="lostFocus" v-model="rufubarukoni_senyoshiyoryo_kizokusaki_kubun" vs-name="rufubarukoni_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('rufubarukoni_sakikubun_setsumei')" style="width: auto;" v-model="rufubarukoni_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('rufubarukoni_sakikubun_setsumei')">{{showMaxlength(18, rufubarukoni_sakikubun_setsumei, 'rufubarukoni_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.rufubarukoni_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.rufubarukoni_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('rufubarukoni_biko')" class="mb-2" v-model="rufubarukoni_biko" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('rufubarukoni_biko')">{{showMaxlength(14, rufubarukoni_biko, 'rufubarukoni_biko')}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('rufubarukoni_biko2')" class="mb-0" v-model="rufubarukoni_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('rufubarukoni_biko2')">{{showMaxlength(14, rufubarukoni_biko2, 'rufubarukoni_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('rufubarukoni_biko')" class="mb-0" v-model="rufubarukoni_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('rufubarukoni_biko')">{{showMaxlength(28, rufubarukoni_biko, 'rufubarukoni_biko')}}</span>
                </th>
              </tr>
              <tr>
                <th style="width: 20%;">トランクルーム</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="torankurumu_umusentaku" vs-name="torankurumu_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="torankurumu_umusentaku" vs-name="torankurumu_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.torankurumu_umusentaku.isWarning" class="text-warning">
                    {{formValidation.torankurumu_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('torankurumu_kubun_shoyusha')" style="width: auto;" v-model="torankurumu_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('torankurumu_kubun_shoyusha')">{{showMaxlength(26, torankurumu_kubun_shoyusha, 'torankurumu_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="torankurumu_kizokusaki_umusentaku" vs-name="torankurumu_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="torankurumu_kizokusaki_umusentaku" vs-name="torankurumu_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.torankurumu_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.torankurumu_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="torankurumu_senyoshiyoryo_kizokusaki_kubun" vs-name="torankurumu_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex">
                    <radio-box @input="lostFocus" v-model="torankurumu_senyoshiyoryo_kizokusaki_kubun" vs-name="torankurumu_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('torankurumu_sakikubun_setsumei')" style="width: auto;" v-model="torankurumu_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('torankurumu_sakikubun_setsumei')">{{showMaxlength(18, torankurumu_sakikubun_setsumei, 'torankurumu_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.torankurumu_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.torankurumu_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('torankurumu_biko')" class="mb-2" v-model="torankurumu_biko" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('torankurumu_biko')">{{showMaxlength(14, torankurumu_biko, 'torankurumu_biko')}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('torankurumu_biko2')" class="mb-0" v-model="torankurumu_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('torankurumu_biko2')">{{showMaxlength(14, torankurumu_biko2, 'torankurumu_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('torankurumu_biko')" class="mb-0" v-model="torankurumu_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('torankurumu_biko')">{{showMaxlength(28, torankurumu_biko, 'torankurumu_biko')}}</span>
                </th>
              </tr>
              <tr>
                <th style="width: 20%;">駐車場</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="chushajo_umusentaku" vs-name="chushajo_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="chushajo_umusentaku" vs-name="chushajo_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.chushajo_umusentaku.isWarning" class="text-warning">
                    {{formValidation.chushajo_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('chushajo_kubun_shoyusha')" style="width: auto;" v-model="chushajo_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('chushajo_kubun_shoyusha')">{{showMaxlength(26, chushajo_kubun_shoyusha, 'chushajo_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="chushajo_kizokusaki_umusentaku" vs-name="chushajo_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="chushajo_kizokusaki_umusentaku" vs-name="chushajo_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.chushajo_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.chushajo_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="chushajo_senyoshiyoryo_kizokusaki_kubun" vs-name="chushajo_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex">
                    <radio-box @input="lostFocus" v-model="chushajo_senyoshiyoryo_kizokusaki_kubun" vs-name="chushajo_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('chushajo_sakikubun_setsumei')" style="width: auto;" v-model="chushajo_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('chushajo_sakikubun_setsumei')">{{showMaxlength(18, chushajo_sakikubun_setsumei, 'chushajo_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.chushajo_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.chushajo_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('chushajo_biko')" class="mb-2" v-model="chushajo_biko" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('chushajo_biko')">{{showMaxlength(14, chushajo_biko, 'chushajo_biko')}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('chushajo_biko2')" class="mb-0" v-model="chushajo_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('chushajo_biko2')">{{showMaxlength(14, chushajo_biko2, 'chushajo_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('chushajo_biko')" class="mb-0" v-model="chushajo_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('chushajo_biko')">{{showMaxlength(28, chushajo_biko, 'chushajo_biko')}}</span>
                </th>
              </tr>
              <tr>
                <th style="width: 20%;">駐輪場</th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="churinjo_umusentaku" vs-name="churinjo_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="churinjo_umusentaku" vs-name="churinjo_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.churinjo_umusentaku.isWarning" class="text-warning">
                    {{formValidation.churinjo_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者 <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('churinjo_kubun_shoyusha')" style="width: auto;" v-model="churinjo_kubun_shoyusha" maxlength="26"/>
                  <span class="tooltip-custom" :class="addPadding('churinjo_kubun_shoyusha')">{{showMaxlength(26, churinjo_kubun_shoyusha, 'churinjo_kubun_shoyusha')}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="churinjo_kizokusaki_umusentaku" vs-name="churinjo_kizokusaki_umusentaku" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="churinjo_kizokusaki_umusentaku" vs-name="churinjo_kizokusaki_umusentaku" vs-value="0"> 無</radio-box>
                  <div v-if="formValidation.churinjo_kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{formValidation.churinjo_kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="churinjo_senyoshiyoryo_kizokusaki_kubun" vs-name="churinjo_senyoshiyoryo_kizokusaki_kubun" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex">
                    <radio-box @input="lostFocus" v-model="churinjo_senyoshiyoryo_kizokusaki_kubun" vs-name="churinjo_senyoshiyoryo_kizokusaki_kubun" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('churinjo_sakikubun_setsumei')" style="width: auto;" v-model="churinjo_sakikubun_setsumei" maxlength="18"/>
                      <span class="tooltip-custom" :class="addPadding('churinjo_sakikubun_setsumei')">{{showMaxlength(18, churinjo_sakikubun_setsumei, 'churinjo_sakikubun_setsumei')}}</span>
                    </div>
                  </div>
                  <div v-if="formValidation.churinjo_senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{formValidation.churinjo_senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('churinjo_biko')" class="mb-2" v-model="churinjo_biko" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('churinjo_biko')">{{showMaxlength(14, churinjo_biko, 'churinjo_biko')}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('churinjo_biko2')" class="mb-0" v-model="churinjo_biko2" maxlength="14"></vs-input>
                  <span class="tooltip-custom" :class="addPadding('churinjo_biko2')">{{showMaxlength(14, churinjo_biko2, 'churinjo_biko2')}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus('churinjo_biko')" class="mb-0" v-model="churinjo_biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding('churinjo_biko')">{{showMaxlength(28, churinjo_biko, 'churinjo_biko')}}</span>
                </th>
              </tr>
              <!-- arrays  -->
              <tr v-for="(senyoshiyoken_t, index) in senyoshiyoken_inputs" :key="`senyoshiyoken-${index}`">
                <th style="width: 20%;">
                  <div class="flex">
                    <vs-checkbox v-model="senyoshiyoken_t.checkboxDelete"></vs-checkbox>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_t.meisho.${index}`)" maxlength="16" style="width: auto;" v-model="senyoshiyoken_t.meisho" />
                      <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_t.meisho.${index}`)">{{showMaxlength(16, senyoshiyoken_t.meisho, `senyoshiyoken_t.meisho.${index}`)}}</span>
                    </div>
                  </div>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="senyoshiyoken_t.umusentaku" :vs-name="`senyoshiyoken_t.umusentaku-${index}`" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="senyoshiyoken_t.umusentaku" :vs-name="`senyoshiyoken_t.umusentaku-${index}`" vs-value="0"> 無</radio-box>
                  <div v-if="senyoshiyokenFormValidation[index] &&!senyoshiyokenFormValidation[index].umusentaku.isWarning" class="text-warning">
                    {{senyoshiyokenFormValidation[index].umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 20%;">区分所有者<br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_t.kubun_shoyusha.${index}`)" maxlength="26" style="width: auto;" v-model="senyoshiyoken_t.kubun_shoyusha" />
                  <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_t.kubun_shoyusha.${index}`)">{{showMaxlength(26, senyoshiyoken_t.kubun_shoyusha, `senyoshiyoken_t.kubun_shoyusha.${index}`)}}</span>
                </th>
                <th style="width: 10%;">
                  <radio-box @input="lostFocus" v-model="senyoshiyoken_t.kizokusaki_umusentaku" :vs-name="`senyoshiyoken_t.kizokusaki_umusentaku-${index}`" vs-value="1"> 有</radio-box><br>
                  <radio-box @input="lostFocus" v-model="senyoshiyoken_t.kizokusaki_umusentaku" :vs-name="`senyoshiyoken_t.kizokusaki_umusentaku-${index}`" vs-value="0"> 無</radio-box>
                  <div v-if="senyoshiyokenFormValidation[index] &&!senyoshiyokenFormValidation[index].kizokusaki_umusentaku.isWarning" class="text-warning">
                    {{senyoshiyokenFormValidation[index].kizokusaki_umusentaku.warningMsg}}
                  </div>
                </th>
                <th style="width: 23%;">
                  <radio-box @input="lostFocus" v-model="senyoshiyoken_t.senyoshiyoryo_kizokusaki_kubun" :vs-name="`senyoshiyoken_t.senyoshiyoryo_kizokusaki_kubun-${index}`" vs-value="1"> 管理組合</radio-box><br>
                  <div style="display: flex">
                    <radio-box @input="lostFocus" v-model="senyoshiyoken_t.senyoshiyoryo_kizokusaki_kubun" :vs-name="`senyoshiyoken_t.senyoshiyoryo_kizokusaki_kubun-${index}`" vs-value="0"></radio-box>
                    <div>
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_t.sakikubun_setsumei.${index}`)" maxlength="18" style="width: auto;" v-model="senyoshiyoken_t.sakikubun_setsumei" />
                      <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_t.sakikubun_setsumei.${index}`)">{{showMaxlength(18, senyoshiyoken_t.sakikubun_setsumei, `senyoshiyoken_t.sakikubun_setsumei.${index}`)}}</span>
                    </div>
                  </div>
                   <div v-if="senyoshiyokenFormValidation[index] &&!senyoshiyokenFormValidation[index].senyoshiyoryo_kizokusaki_kubun.isWarning" class="text-warning">
                    {{senyoshiyokenFormValidation[index].senyoshiyoryo_kizokusaki_kubun.warningMsg}}
                  </div>
                </th>
                <th style="width: 27%;">
                  <!-- <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_t.biko.${index}`)" maxlength="14" class="mb-2" v-model="senyoshiyoken_t.biko"></vs-input>
                  <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_t.biko.${index}`)">{{showMaxlength(14, senyoshiyoken_t.biko, `senyoshiyoken_t.biko.${index}`)}}</span>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_t.biko2.${index}`)" maxlength="14" class="mb-0" v-model="senyoshiyoken_t.biko2"></vs-input>
                  <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_t.biko2.${index}`)">{{showMaxlength(14, senyoshiyoken_t.biko2, `senyoshiyoken_t.biko2.${index}`)}}</span> -->
                  <vs-textarea  @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_t.biko.${index}`)" class="mb-0" v-model="senyoshiyoken_t.biko" maxlength="28"/>
                  <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_t.biko.${index}`)">{{showMaxlength(28, senyoshiyoken_t.biko, `senyoshiyoken_t.biko.${index}`)}}</span>
                </th>
              </tr>
              <tr>
                <th colspan="6">
                  <div class="flex justify-end mr-8" >
                    <vs-button class="ml-4" :disabled="senyoshiyoken_inputs.length >= 26"  @click="add_senyoshiyoken_inputs">項目追加 </vs-button>
                    <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('senyoshiyoken_inputs', senyoshiyoken_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
                  </div>
                </th>
              </tr>
              <tr>
                <td class="w-1/5" colspan="2">
                    <div class="grid">
                        <span>「以下余白」の表示</span>
                    </div>
                </td>
                <td colspan="4">
                    <div class="flex items-center">
                      <vs-checkbox v-model="senyoshiyoken_biko1_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">末尾に「以下余白」を表示する</span>
                    </div>
                </td>
              </tr>
              <tr>
                <td class="w-1/5" colspan="2">
                    <div class="grid">
                        <span>黒点／ナンバリング表示</span>
                    </div>
                </td>
                <td colspan="4">
                    <div class="flex items-center">
                      <vs-checkbox v-model="senyoshiyoken_biko1_numbering" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">黒点／ナンバリングを表示する</span>
                    </div>
                </td>
              </tr>
            </table>
            <table :id="`${arrayCommentId[8]}`">
              <draggable v-model="senyoshiyoken_biko1_inputs" handle=".handle">
                <table class="w-full" v-for="(senyoshiyoken_biko1_t, index) in senyoshiyoken_biko1_inputs" :key="`senyoshiyoken_biko1-${index}`">
                  <tr>
                    <td class="w-30" colspan="2">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="senyoshiyoken_biko1_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td colspan="4">
                      <div class="flex items-center">
                        <BunshoTemplate v-model="senyoshiyoken_biko1_t.naiyo" :screen="bunshoScreen(4)" />
                        <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                      </div>
                      <div class="ml-2 mr-5">
                          <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`senyoshiyoken_biko1_t.naiyo.${index}`)" maxlength="3000" class="mt-2 mb-0" rows="5" v-model="senyoshiyoken_biko1_t.naiyo"/>
                          <span class="tooltip-custom" :class="addPadding(`senyoshiyoken_biko1_t.naiyo.${index}`)">{{showMaxlength( 3000,senyoshiyoken_biko1_t.naiyo ,`senyoshiyoken_biko1_t.naiyo.${index}` )}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
            </table>
            <div class="flex justify-end mt-2 mr-8 mb-2" >
                <vs-button class="ml-4" @click="add_biko(senyoshiyoken_biko1_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('senyoshiyoken_biko1_inputs', senyoshiyoken_biko1_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
            </div>
             <!--②対象不動産に付随する専用使用権について -->
            <div class="flex part-parent-name p-2" :id="`${arrayCommentId[9]}`">
              <span>②対象不動産に付随する専用使用権について</span>
            </div>
            <table>
              <tr>
                <th class="text-center" style="width: 25%;"> 名称</th>
                <th class="text-center">
                  使用部分、面積、期間、料金等
                </th>
              </tr>
              <tr>
                <th class="text-center"> バルコニー<br>
                  <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="fuzuisenyo_barukoni_naiyo = hanyo._8">定型文</vs-button>
                </th>
                <th>
                  <div class="w-full ml-2 mr-4">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('fuzuisenyo_barukoni_naiyo')" maxlength="42" v-model="fuzuisenyo_barukoni_naiyo" name="fuzuisenyo_barukoni_naiyo" />
                    <span class="tooltip-custom" :class="addPadding('fuzuisenyo_barukoni_naiyo')">{{showMaxlength(42, fuzuisenyo_barukoni_naiyo, 'fuzuisenyo_barukoni_naiyo')}}</span>
                  </div>
                  <div v-if="formValidation.fuzuisenyo_barukoni_naiyo.isWarning" class="text-warning ml-3 mt-2">
                    {{formValidation.fuzuisenyo_barukoni_naiyo.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th class="text-center"> 玄関扉、窓枠、窓ガラス<br>
                  <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="fuzuisenyo_madonado_naiyo = hanyo._9">定型文</vs-button>
                </th>
                <th>
                  <div class="w-full ml-2 mr-4">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('fuzuisenyo_madonado_naiyo')" maxlength="42"  v-model="fuzuisenyo_madonado_naiyo" name="fuzuisenyo_madonado_naiyo"/>
                    <span class="tooltip-custom" :class="addPadding('fuzuisenyo_madonado_naiyo')">{{showMaxlength(42, fuzuisenyo_madonado_naiyo, 'fuzuisenyo_madonado_naiyo')}}</span>
                  </div>
                  <div v-if="formValidation.fuzuisenyo_madonado_naiyo.isWarning" class="text-warning ml-3 mt-2">
                    {{formValidation.fuzuisenyo_madonado_naiyo.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr v-for="(fuzuisenyo_shiyoken_t, index) in fuzuisenyo_shiyoken_inputs" :key="`fuzuisenyo_shiyoken-${index}`">
                <th>
                  <div class="flex">
                    <vs-checkbox v-model="fuzuisenyo_shiyoken_t.checkboxDelete" > </vs-checkbox>
                    <div class="w-full mx-2">
                      <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`fuzuisenyo_shiyoken_t.meisho.${index}`)" maxlength="12" v-model="fuzuisenyo_shiyoken_t.meisho" />
                      <span class="tooltip-custom" :class="addPadding(`fuzuisenyo_shiyoken_t.meisho.${index}`)">{{showMaxlength(12, fuzuisenyo_shiyoken_t.meisho, `fuzuisenyo_shiyoken_t.meisho.${index}`)}}</span>
                    </div>
                  </div>
                </th>
                <th>
                  <div class="w-full ml-2 mr-4">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus(`fuzuisenyo_shiyoken_t.naiyo.${index}`)" maxlength="42" v-model="fuzuisenyo_shiyoken_t.naiyo" :name="`fuzuisenyo_shiyoken_t.naiyo-${index}`"/>
                    <span class="tooltip-custom" :class="addPadding(`fuzuisenyo_shiyoken_t.naiyo.${index}`)">{{showMaxlength(42, fuzuisenyo_shiyoken_t.naiyo, `fuzuisenyo_shiyoken_t.naiyo.${index}`)}}</span>
                  </div>
                  <div v-if="fuzuisenyoShiyokenFormValidation[index] && !fuzuisenyoShiyokenFormValidation[index].naiyo.isWarning" class="text-warning ml-3">
                    {{fuzuisenyoShiyokenFormValidation[index].naiyo.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <div class="flex justify-end mr-8" >
                      <vs-button class="ml-4" :disabled="fuzuisenyo_shiyoken_inputs.length >= 10" @click="add_biko(fuzuisenyo_shiyoken_inputs)">項目追加 </vs-button>
                      <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('fuzuisenyo_shiyoken_inputs', fuzuisenyo_shiyoken_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
                  </div>
                </th>
              </tr>
              <tr>
                <td class="w-1/5">
                  <div class="grid">
                    <span>「以下余白」の表示</span>
                  </div>
                </td>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="senyububun_biko2_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-1/5">
                  <div class="grid">
                    <span>黒点／ナンバリング表示</span>
                  </div>
                </td>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="senyububun_biko2_numbering" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <table :id="`${arrayCommentId[10]}`">
              <draggable v-model="senyububun_biko2_inputs" handle=".handle">
                <table class="w-full" v-for="(senyububun_biko2_t, index) in senyububun_biko2_inputs" :key="`senyububun_biko2-${index}`">
                  <tr>
                    <td class="w-1/4">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="senyububun_biko2_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                        <div class="flex items-center">
                          <BunshoTemplate v-model="senyububun_biko2_t.naiyo" :screen="bunshoScreen(5)" />
                          <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                        </div>
                        <div class="ml-2 mr-5">
                            <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`senyububun_biko2_t.naiyo.${index}`)" maxlength="3000" class="mt-4 mb-0" rows="5" v-model="senyububun_biko2_t.naiyo" />
                            <span class="tooltip-custom" :class="addPadding(`senyububun_biko2_t.naiyo.${index}`)">{{showMaxlength( 3000,senyububun_biko2_t.naiyo , `senyububun_biko2_t.naiyo.${index}`)}}</span>
                        </div>
                    </td>
                  </tr>
                </table>
              </draggable>
            </table>
            <div class="flex justify-end mt-2 mr-8" >
                <vs-button class="ml-4" @click="add_biko(senyububun_biko2_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('senyububun_biko2_inputs', senyububun_biko2_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
            </div>

            <!--（５）所有者が負担すべき費用を特定のもののみに減免する旨の規約等の定め-->
            <div class="flex mtb-10 part-parent-name p-2" :id="`${arrayCommentId[11]}`">
              <span>（５）所有者が負担すべき費用を特定の者のみに減免する旨の規約等の定め</span>
            </div>
            <table>
              <tr>
                <th class="w-1/4">
                  規約等の定め
                </th>
                <th>
                  <radio-box @input="lostFocus" v-model="genmenkiyaku_umusentaku" vs-name="genmenkiyaku_umusentaku" vs-value="1" class="ml-2 m-auto">有</radio-box>
                  <radio-box @input="lostFocus" v-model="genmenkiyaku_umusentaku" vs-name="genmenkiyaku_umusentaku" vs-value="0" class="ml-6 m-auto">無</radio-box>
                  <div v-if="formValidation.genmenkiyaku_umusentaku.isWarning" class="text-warning ml-2">
                    {{formValidation.genmenkiyaku_umusentaku.warningMsg}}
                  </div>
                  <div class="flex">
                    <span class="m-auto-top-bottom ml-2"> 別添管理規約</span>
                    <div class="ml-6">
                      <!-- <vs-input @blur="lostFocus" @keypress="checkNumberByte(futangenmen_kanri_kiyakumei, 44, $event)" style="width: 24rem;"
                      @input="futangenmen_kanri_kiyakumei = cutByte(futangenmen_kanri_kiyakumei, 44)" v-model="futangenmen_kanri_kiyakumei"/> -->
                      <vs-input @blur="lostFocus, focusOut()" style="width: 24rem;" @focus="onFocus(`futangenmen_kanri_kiyakumei`)" maxlength="22" v-model="futangenmen_kanri_kiyakumei"/>
                      <span class="tooltip-custom" :class="addPadding(`futangenmen_kanri_kiyakumei`)">{{showMaxlength( 22, futangenmen_kanri_kiyakumei , `futangenmen_kanri_kiyakumei`)}}</span>
                    </div>
                    <!-- <vs-input @blur="lostFocus" maxlength="3" class="ml-4 w-1/6" v-model="futangenmen_kanri_kiyakujo_bango"/> -->
                    <span class="m-auto-top-bottom ml-2"> 条に記載されています。</span>
                  </div>
                </th>
              </tr>
              <tr>
                <th>
                  規約等の定めの概要
                </th>
                <th>
                  <div>
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('genmenkiyaku_kiyaku_sadame_gaiyo')" maxlength="99" class="mb-0 ml-2 mr-4" v-model="genmenkiyaku_kiyaku_sadame_gaiyo"></vs-textarea>
                    <span class="tooltip-custom" :class="addPadding('genmenkiyaku_kiyaku_sadame_gaiyo')">{{showMaxlength( 99, genmenkiyaku_kiyaku_sadame_gaiyo , 'genmenkiyaku_kiyaku_sadame_gaiyo' )}}</span>
                  </div>
                </th>
              </tr>
            </table>
            <!--（６）計画修繕積立金等に関する事項-->
            <div class="flex mtb-10 part-parent-name p-2" :id="`${arrayCommentId[12]}`">
              <span>（６）計画修繕積立金等に関する事項</span>
            </div>
            <table>
              <tr>
                <th class="w-1/4">
                  計画修繕積立金制度：
                </th>
                <th>
                  <radio-box @input="lostFocus" v-model="shuzentsumitatekin_umusentaku" vs-name="shuzentsumitatekin_umusentaku" vs-value="1" class="ml-2 m-auto">有</radio-box>
                  <radio-box @input="lostFocus" v-model="shuzentsumitatekin_umusentaku" vs-name="shuzentsumitatekin_umusentaku" vs-value="0" class="ml-6 m-auto">無</radio-box>
                  <div v-if="formValidation.shuzentsumitatekin_umusentaku.isWarning" class="text-warning ml-2">
                    {{formValidation.shuzentsumitatekin_umusentaku.warningMsg}}
                  </div>
                  <div class="flex">
                    <span class="m-auto-top-bottom ml-2"> 別添管理規約</span>
                    <div class="ml-6">
                      <!-- <vs-input @blur="lostFocus" @keypress="checkNumberByte(shuzentsumitatekin_kanrikiyaku_joreimei, 24, $event)" style="width: 14rem"
                      @input="shuzentsumitatekin_kanrikiyaku_joreimei= cutByte(shuzentsumitatekin_kanrikiyaku_joreimei, 23)" v-model="shuzentsumitatekin_kanrikiyaku_joreimei" name="shuzentsumitatekin_kanrikiyaku_joreimei"/> -->
                      <vs-input @blur="lostFocus, focusOut()" style="width: 14rem;" @focus="onFocus(`shuzentsumitatekin_kanrikiyaku_joreimei`)" maxlength="12" v-model="shuzentsumitatekin_kanrikiyaku_joreimei"/>
                      <span class="tooltip-custom" :class="addPadding(`shuzentsumitatekin_kanrikiyaku_joreimei`)">{{showMaxlength( 12, shuzentsumitatekin_kanrikiyaku_joreimei , `shuzentsumitatekin_kanrikiyaku_joreimei`)}}</span>
                    </div>
                    <!-- <vs-input @blur="lostFocus" maxlength="3" class="ml-4 w-1/6" v-model="shuzentsumitatekin_kanrikiyaku_joreibango" name="shuzentsumitatekin_kanrikiyaku_joreibango"/> -->
                    <span class="m-auto-top-bottom ml-2"> 条に記載されています。</span>
                  </div>
                  <div v-if="formValidation.shuzentsumitatekin_kanrikiyaku_joreimei.isWarning" class="text-warning" style="margin-left: 100px;">
                    {{formValidation.shuzentsumitatekin_kanrikiyaku_joreimei.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th>
                  修繕積立金
                </th>
                <td>
                  <div class="flex">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">月額：</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex"> 
                          <div class="ml-4">
                            <vs-input @blur="shuzentsumitatekin_kingaku=formatIntegerAdvanced(shuzentsumitatekin_kingaku, true, 10); lostFocus, focusOut()" @focus="onFocus('shuzentsumitatekin_kingaku')" :maxlength="handleMaxLength(10, shuzentsumitatekin_kingaku)" v-model="shuzentsumitatekin_kingaku" name="shuzentsumitatekin_kingaku"/>
                            <span class="tooltip-custom" :class="addPadding('shuzentsumitatekin_kingaku')">{{showMaxlength(10, shuzentsumitatekin_kingaku, 'shuzentsumitatekin_kingaku', true)}}</span>
                          </div>
                          <span class="ml-6 m-auto font-light">円</span>
                        </div>
                        <div v-if="formValidation.shuzentsumitatekin_kingaku.isWarning" class="text-warning" style="margin-left: 15px">
                          {{formValidation.shuzentsumitatekin_kingaku.warningMsg}}
                        </div>
                      </div>
                        <DatePickerCustom class="mt-2 mb-2 ml-4" 
                                        @lost-focus="lostFocus"
                                        v-model="shuzentsumitatekin_shuzen_tsumitatekin_nengappi"
                                        name="shuzentsumitatekin_shuzen_tsumitatekin_nengappi"
                                        :date="shuzentsumitatekin_shuzen_tsumitatekin_nengappi"
                                        :checkboxvalue="shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox"
                                        v-on:change-checkbox="shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-"/>
                      <div v-if="formValidation.shuzentsumitatekin_shuzen_tsumitatekin_nengappi.isWarning" class="text-warning ml-4">
                        {{formValidation.shuzentsumitatekin_shuzen_tsumitatekin_nengappi.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.shuzentsumitatekin_shuzen_tsumitatekin_nengappi.isError">
                        {{formValidation.shuzentsumitatekin_shuzen_tsumitatekin_nengappi.errorMsg}}
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <span class="ml-2 m-auto w-20" style="width: 50px;">補足</span>
                    <vs-textarea maxlength="25" @blur="lostFocus, focusOut()" @focus="onFocus('shuzentsumitatekin_hosoku')" v-model="shuzentsumitatekin_hosoku"></vs-textarea>
                    <span class="tooltip-custom ml-16 mt-20" :class="addPadding('shuzentsumitatekin_hosoku')">{{showMaxlength( 25, shuzentsumitatekin_hosoku, 'shuzentsumitatekin_hosoku')}}</span>
                  </div>
                  <div class="flex">
                    <span class="ml-2">当該専有部分に係る滞納の有無：</span>
                    <radio-box @input="lostFocus" v-model="shuzentsumitatekin_taino_umu" vs-name="shuzentsumitatekin_taino_umu" vs-value="1" class="ml-6 m-auto-top-bottom">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="shuzentsumitatekin_taino_umu" vs-name="shuzentsumitatekin_taino_umu" vs-value="0" class="ml-6 m-auto-top-bottom">無</radio-box>
                  </div>
                  <div v-if="formValidation.shuzentsumitatekin_taino_umu.isWarning" class="text-warning" style="margin-left: 200px;">
                    {{formValidation.shuzentsumitatekin_taino_umu.warningMsg}}
                  </div>
                  <div class="flex mt-2">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">滞納額</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex">
                          <div  class="ml-4">
                            <vs-input @blur="shuzentsumitatekin_tainokingaku=formatIntegerAdvanced(shuzentsumitatekin_tainokingaku, true, 9); lostFocus, focusOut()" @focus="onFocus('shuzentsumitatekin_tainokingaku')" :maxlength="handleMaxLength(9, shuzentsumitatekin_tainokingaku)" v-model="shuzentsumitatekin_tainokingaku" name="shuzentsumitatekin_tainokingaku" />
                            <span class="tooltip-custom" :class="addPadding('shuzentsumitatekin_tainokingaku')">{{showMaxlength(9, shuzentsumitatekin_tainokingaku, 'shuzentsumitatekin_tainokingaku', true)}}</span>
                          </div>
                          <span class="ml-6 m-auto-top-bottom font-light">円</span>
                        </div>
                        <div v-if="formValidation.shuzentsumitatekin_tainokingaku.isWarning" class="text-warning" style="margin-left: 15px">
                          {{formValidation.shuzentsumitatekin_tainokingaku.warningMsg}}
                        </div>
                      </div> 
                        <DatePickerCustom class="mt-2 ml-4"
                                        @lost-focus="lostFocus"
                                        v-model="shuzentsumitatekin_taino_nengappi"
                                        name="shuzentsumitatekin_taino_nengappi"
                                        :date="shuzentsumitatekin_taino_nengappi"
                                        :checkboxvalue="shuzentsumitatekin_taino_nengappi_checkbox"
                                        v-on:change-checkbox="shuzentsumitatekin_taino_nengappi_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-" />
                      <div v-if="formValidation.shuzentsumitatekin_taino_nengappi.isWarning" class="text-warning ml-4">
                        {{formValidation.shuzentsumitatekin_taino_nengappi.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.shuzentsumitatekin_taino_nengappi.isError">
                        {{formValidation.shuzentsumitatekin_taino_nengappi.errorMsg}}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  すでに積立てられている額
                </th>
                <th>
                  <div class="flex mt-2">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">金額：</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex"> 
                          <div class="ml-4">
                            <vs-input @blur="shuzentsumitatekin_tsumitategaku_kingaku=formatIntegerAdvanced(shuzentsumitatekin_tsumitategaku_kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus('shuzentsumitatekin_tsumitategaku_kingaku')" :maxlength="handleMaxLength(12, shuzentsumitatekin_tsumitategaku_kingaku)" v-model="shuzentsumitatekin_tsumitategaku_kingaku" name="shuzentsumitatekin_tsumitategaku_kingaku" />
                            <span class="tooltip-custom" :class="addPadding('shuzentsumitatekin_tsumitategaku_kingaku')">{{showMaxlength(12, shuzentsumitatekin_tsumitategaku_kingaku, 'shuzentsumitatekin_tsumitategaku_kingaku', true)}}</span>
                          </div>
                          <span  class="ml-6 m-auto font-light">円</span>
                        </div>
                        <div v-if="formValidation.shuzentsumitatekin_tsumitategaku_kingaku.isWarning" class="text-warning ml-4">
                          {{formValidation.shuzentsumitatekin_tsumitategaku_kingaku.warningMsg}}
                        </div>
                      </div> 
                      <DatePickerCustom class="mt-2 mb-2 ml-4"
                                        @lost-focus="lostFocus"
                                        v-model="shuzentsumitatekin_tsumitategaku_nengappi"
                                        name="shuzentsumitatekin_tsumitategaku_nengappi"
                                        :date="shuzentsumitatekin_tsumitategaku_nengappi"
                                        :checkboxvalue="shuzentsumitatekin_tsumitategaku_nengappi_checkbox"
                                        v-on:change-checkbox="shuzentsumitatekin_tsumitategaku_nengappi_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-"/>
                      <div v-if="formValidation.shuzentsumitatekin_tsumitategaku_nengappi.isWarning" class="text-warning ml-4">
                        {{formValidation.shuzentsumitatekin_tsumitategaku_nengappi.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.shuzentsumitatekin_tsumitategaku_nengappi.isError">
                        {{formValidation.shuzentsumitatekin_tsumitategaku_nengappi.errorMsg}}
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <span class="ml-2">一棟の建物（団地）に係る滞納に関する情報の開示：</span>
                    <radio-box @input="lostFocus" v-model="shuzentsumitatekin_tsumitategaku_umusentaku" name="shuzentsumitatekin_tsumitategaku_umusentaku" vs-name="shuzentsumitatekin_tsumitategaku_umusentaku" vs-value="1" class="ml-6 m-auto-top-bottom">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="shuzentsumitatekin_tsumitategaku_umusentaku" name="shuzentsumitatekin_tsumitategaku_umusentaku" vs-name="shuzentsumitatekin_tsumitategaku_umusentaku" vs-value="0" class="ml-6 m-auto-top-bottom">無</radio-box>
                  </div>
                  <div v-if="formValidation.shuzentsumitatekin_tsumitategaku_umusentaku.isWarning" class="text-warning" style="margin-left: 200px;">
                    {{formValidation.shuzentsumitatekin_tsumitategaku_umusentaku.warningMsg}}
                  </div>
                  <div class="flex mt-2">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">滞納額</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex">
                          <div class="ml-4">
                            <vs-input @blur="shuzentsumitatekin_tsumitategaku_tainogaku_kingaku=formatIntegerAdvanced(shuzentsumitatekin_tsumitategaku_tainogaku_kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus('shuzentsumitatekin_tsumitategaku_tainogaku_kingaku')" :maxlength="handleMaxLength(12, shuzentsumitatekin_tsumitategaku_tainogaku_kingaku)" v-model="shuzentsumitatekin_tsumitategaku_tainogaku_kingaku" name="shuzentsumitatekin_tsumitategaku_tainogaku_kingaku" />
                            <span class="tooltip-custom" :class="addPadding('shuzentsumitatekin_tsumitategaku_tainogaku_kingaku')">{{showMaxlength(12, shuzentsumitatekin_tsumitategaku_tainogaku_kingaku, 'shuzentsumitatekin_tsumitategaku_tainogaku_kingaku', true)}}</span>
                          </div>
                          <span class="ml-6 m-auto-top-bottom font-light">円</span>
                        </div>
                        <div v-if="formValidation.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku.isWarning" class="text-warning ,ml-4">
                          {{formValidation.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku.warningMsg}}
                        </div>
                      </div> 
                      <DatePickerCustom class="mt-2 mb-2 ml-4"
                                        @lost-focus="lostFocus"
                                        v-model="shuzentsumitatekin_tsumitategaku_nengappi2"
                                        name="shuzentsumitatekin_tsumitategaku_nengappi2"
                                        :date="shuzentsumitatekin_tsumitategaku_nengappi2"
                                        :checkboxvalue="shuzentsumitatekin_tsumitategaku_nengappi2_checkbox"
                                        v-on:change-checkbox="shuzentsumitatekin_tsumitategaku_nengappi2_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-"/>
                      <div v-if="formValidation.shuzentsumitatekin_tsumitategaku_nengappi2.isWarning" class="text-warning ml-4" >
                        {{formValidation.shuzentsumitatekin_tsumitategaku_nengappi2.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.shuzentsumitatekin_tsumitategaku_nengappi2.isError" >
                        {{formValidation.shuzentsumitatekin_tsumitategaku_nengappi2.errorMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </table>
             <!--（７）通常の管理費用の額-->
            <div class="flex part-parent-name p-2" :id="`${arrayCommentId[13]}`">
              <span>（７）通常の管理費用の額</span>
            </div>
            <table>
              <tr>
                <th rowspan="2" class="w-1/4">
                  通常の管理費
                </th>
                 <th>
                  <div class="flex">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">月額：</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex">
                          <div class="ml-4 ">
                            <vs-input @blur="kanrihi_kingaku=formatIntegerAdvanced(kanrihi_kingaku, true, 10); lostFocus, focusOut()" @focus="onFocus('kanrihi_kingaku')" :maxlength="handleMaxLength(10, kanrihi_kingaku)" v-model="kanrihi_kingaku" name="kanrihi_kingaku" />
                            <span class="tooltip-custom" :class="addPadding('kanrihi_kingaku')">{{showMaxlength(10, kanrihi_kingaku, 'kanrihi_kingaku', true)}}</span>
                          </div>
                          <span class="ml-6 m-auto font-light">円</span>
                        </div>
                        <div v-if="formValidation.kanrihi_kingaku.isWarning" class="text-warning ml-4 mt-8px">
                          {{formValidation.kanrihi_kingaku.warningMsg}}
                        </div>
                      </div> 
                      <DatePickerCustom class="mt-2 mb-2 ml-4" 
                                        @lost-focus="lostFocus"
                                        v-model="kanrihi_nengappi"
                                        name="kanrihi_nengappi"
                                        :date="kanrihi_nengappi"
                                        :checkboxvalue="kanrihi_nengappi_checkbox"
                                        v-on:change-checkbox="kanrihi_nengappi_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-"/>
                      <div v-if="formValidation.kanrihi_nengappi.isWarning" class="text-warning ml-4">
                        {{formValidation.kanrihi_nengappi.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.kanrihi_nengappi.isError">
                        {{formValidation.kanrihi_nengappi.errorMsg}}
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <span class="ml-2 m-auto w-20" style="width: 50px;">補足</span>
                    <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('kanrihi_hosoku')" class="mr-4" v-model="kanrihi_hosoku" maxlength="22"></vs-textarea>
                    <span class="tooltip-custom ml-16 mt-20" :class="addPadding('kanrihi_hosoku')">{{showMaxlength(22 , kanrihi_hosoku,'kanrihi_hosoku' )}}</span>
                  </div>
                  <div class="flex">
                    <span class="ml-2">当該専有部分に係る滞納の有無：</span>
                    <radio-box @input="lostFocus" v-model="kanrihi_tainoumu" vs-name="kanrihi_tainoumu" vs-value="1" class="ml-6 m-auto-top-bottom">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kanrihi_tainoumu" vs-name="kanrihi_tainoumu" vs-value="0" class="ml-6 m-auto-top-bottom">無</radio-box>
                  </div>
                   <div v-if="formValidation.kanrihi_tainoumu.isWarning" class="text-warning mt-1"  style="margin-left: 210px;">
                    {{formValidation.kanrihi_tainoumu.warningMsg}}
                  </div>
                  <div class="flex mt-2">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">滞納額</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex">
                          <div class="ml-4 ">
                            <vs-input @blur="kanrihi_tainokingaku=formatIntegerAdvanced(kanrihi_tainokingaku, true, 9); lostFocus, focusOut()" @focus="onFocus('kanrihi_tainokingaku')" :maxlength="handleMaxLength(9, kanrihi_tainokingaku)" v-model="kanrihi_tainokingaku" name="kanrihi_tainokingaku" />
                            <span class="tooltip-custom" :class="addPadding('kanrihi_tainokingaku')">{{showMaxlength(9, kanrihi_tainokingaku, 'kanrihi_tainokingaku', true)}}</span>
                          </div>
                          <span class="ml-6 m-auto-top-bottom font-light">円</span>
                        </div>
                        <div v-if="formValidation.kanrihi_tainokingaku.isWarning" class="text-warning ml-4">
                          {{formValidation.kanrihi_tainokingaku.warningMsg}}
                        </div>
                      </div> 
                      <DatePickerCustom class="mt-2 ml-4"
                                        @lost-focus="lostFocus"
                                        v-model="kanrihi_taino_nengappi"
                                        name="kanrihi_taino_nengappi"
                                        :date="kanrihi_taino_nengappi"
                                        :checkboxvalue="kanrihi_taino_nengappi_checkbox"
                                        v-on:change-checkbox="kanrihi_taino_nengappi_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-"/>
                      <div v-if="formValidation.kanrihi_taino_nengappi.isWarning" class="text-warning ml-4">
                        {{formValidation.kanrihi_taino_nengappi.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.kanrihi_taino_nengappi.isError">
                        {{formValidation.kanrihi_taino_nengappi.errorMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th>
                  <div class="flex">
                    <span>一棟の建物（団地）に係る滞納に関する情報の開示：</span>
                    <radio-box @input="lostFocus" v-model="kanrihi_taino_johokaiji_umu" vs-name="kanrihi_taino_johokaiji_umu" vs-value="1" class="ml-4 ">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kanrihi_taino_johokaiji_umu" vs-name="kanrihi_taino_johokaiji_umu" vs-value="0" class="ml-4">無</radio-box>
                  </div>
                  <div v-if="formValidation.kanrihi_taino_johokaiji_umu.isWarning" class="text-warning mt-1" style="margin-left: 304px;">
                    {{formValidation.kanrihi_taino_johokaiji_umu.warningMsg}}
                  </div>
                  <div class="flex mt-2">
                    <span class="ml-2 mt-3" style="white-space: nowrap; width: 3%;">滞納額</span>
                    <div style="width: 97%;">
                      <div>
                        <div class="flex">
                          <div class="ml-4 ">
                            <vs-input @blur="kanrihi_taino_johokaiji_tainogaku=formatIntegerAdvanced(kanrihi_taino_johokaiji_tainogaku, true, 12); lostFocus, focusOut()" @focus="onFocus('kanrihi_taino_johokaiji_tainogaku')" :maxlength="handleMaxLength(12, kanrihi_taino_johokaiji_tainogaku)" v-model="kanrihi_taino_johokaiji_tainogaku" name="kanrihi_taino_johokaiji_tainogaku"/>
                            <span class="tooltip-custom" :class="addPadding('kanrihi_taino_johokaiji_tainogaku')">{{showMaxlength(12, kanrihi_taino_johokaiji_tainogaku, 'kanrihi_taino_johokaiji_tainogaku', true)}}</span>
                          </div>
                          <span class="ml-6 m-auto-top-bottom font-light">円</span>
                        </div>
                        <div v-if="formValidation.kanrihi_taino_johokaiji_tainogaku.isWarning" class="text-warning ml-4">
                          {{formValidation.kanrihi_taino_johokaiji_tainogaku.warningMsg}}
                        </div>
                      </div> 
                      <DatePickerCustom class="mt-2 ml-4"
                                        v-model="kanrihi_taino_johokaiji_taino_nengappi"
                                        name="kanrihi_taino_johokaiji_taino_nengappi"
                                        :date="kanrihi_taino_johokaiji_taino_nengappi"
                                        :checkboxvalue="kanrihi_taino_johokaiji_taino_nengappi_checkbox"
                                        v-on:change-checkbox="kanrihi_taino_johokaiji_taino_nengappi_checkbox = $event"
                                        format="yyyy-MM-dd" separate="-"
                                        @lost-focus="lostFocus"/>
                      <div v-if="formValidation.kanrihi_taino_johokaiji_taino_nengappi.isWarning" class="text-warning ml-4">
                        {{formValidation.kanrihi_taino_johokaiji_taino_nengappi.warningMsg}}
                      </div>
                      <div class="text-danger ml-4" v-if="formValidation.kanrihi_taino_johokaiji_taino_nengappi.isError">
                        {{formValidation.kanrihi_taino_johokaiji_taino_nengappi.errorMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </table>
             <!--（８）管理組合の名称および管理の委託先-->
            <div class="flex part-parent-name p-2" :id="`${arrayCommentId[14]}`">
              <span>（８）管理組合の名称および管理の委託先</span>
            </div>
            <table>
              <tr>
                <th class="w-1/4" style="border-right: none; border-bottom: none;">
                  <span>管理組合の名称</span>
                </th>
                <th class="pb-0" style="border-left: none; border-bottom: none;">
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kanrikumiai_meisho')" maxlength="43" class="mb-0" v-model="kanrikumiai_meisho" name="kanrikumiai_meisho" />
                  <span class="tooltip-custom" :class="addPadding('kanrikumiai_meisho')">{{showMaxlength(43, kanrikumiai_meisho, 'kanrikumiai_meisho')}}</span>
                  <div v-if="formValidation.kanrikumiai_meisho.isWarning" class="text-warning mt-8px">
                    {{formValidation.kanrikumiai_meisho.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th style="border-top: none; border-right: none;">
                  <span>管理の形態</span>
                </th>
                <th style="border-left: none; border-top: none;">
                  <radio-box @input="lostFocus" v-model="kanri_keitai" name="kanri_keitai" vs-name="kanri_keitai" vs-value="0" class="ml-2 m-auto">１．全部委託管理</radio-box>
                  <radio-box @input="lostFocus" v-model="kanri_keitai" name="kanri_keitai" vs-name="kanri_keitai" vs-value="1" class="ml-2 m-auto">２．一部委託管理</radio-box>
                  <radio-box @input="lostFocus" v-model="kanri_keitai" name="kanri_keitai" vs-name="kanri_keitai" vs-value="2" class="ml-2 m-auto">３．自主管理</radio-box>
                  <div v-if="formValidation.kanri_keitai.isWarning" class="text-warning ml-2">
                    {{formValidation.kanri_keitai.warningMsg}}
                  </div>
                </th>
              </tr>
              <tr>
                <th>管理委託先 <br>
                  <vs-button class="btn-positive hidden" color="positive" type="filled" text-color="#7367F0" @click="activeItakuDialog = true; selected_sentaku = null">設定</vs-button>
                </th>
                <th>
                  <span class="ml-2">名称 </span> <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kanriitakusaki_meisho')" maxlength="26" class="ml-4 my-2 w-5/6" v-model="kanriitakusaki_meisho" name="kanriitakusaki_meisho" />
                  <span class="tooltip-custom" :class="addPadding('kanriitakusaki_meisho')">{{showMaxlength(26, kanriitakusaki_meisho, 'kanriitakusaki_meisho')}}</span>
                  <div v-if="formValidation.kanriitakusaki_meisho.isWarning" class="text-warning" style="margin-left: 15px;">
                    {{formValidation.kanriitakusaki_meisho.warningMsg}}
                  </div>
                  <span class="ml-2">電話 </span> <br>
                  <vs-input class="ml-4 my-2 w-5/6" @blur="kanriitakusaki_tenwabango=formatPhone(kanriitakusaki_tenwabango);lostFocus, focusOut()" @focus="onFocus('kanriitakusaki_tenwabango')" maxlength="21" v-model="kanriitakusaki_tenwabango" name="kanriitakusaki_tenwabango"/>
                  <span class="tooltip-custom" :class="addPadding('kanriitakusaki_tenwabango')">{{showMaxlength(21, kanriitakusaki_tenwabango, 'kanriitakusaki_tenwabango')}}</span>
                  <div v-if="formValidation.kanriitakusaki_tenwabango.isWarning" class="text-warning" style="margin-left: 15px;">
                    {{formValidation.kanriitakusaki_tenwabango.warningMsg}}
                  </div>
                  <span class="ml-2">所在 </span> <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kanriitakusaki_shozai')" maxlength="43" class="ml-4 my-2 w-5/6" v-model="kanriitakusaki_shozai" name="kanriitakusaki_shozai" />
                  <span class="tooltip-custom" :class="addPadding('kanriitakusaki_shozai')">{{showMaxlength(43, kanriitakusaki_shozai, 'kanriitakusaki_shozai')}}</span>
                  <div v-if="formValidation.kanriitakusaki_shozai.isWarning" class="text-warning" style="margin-left: 15px;">
                    {{formValidation.kanriitakusaki_shozai.warningMsg}}
                  </div>
                  <span class="ml-2">マンション管理適正化法による登録番号 </span> <br>
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kanriitakusaki_manshonkanritekiseikaho_toroku_bango')" maxlength="23" class="ml-4 mt-2 w-5/6" v-model="kanriitakusaki_manshonkanritekiseikaho_toroku_bango"
                   name="kanriitakusaki_manshonkanritekiseikaho_toroku_bango" />
                   <span class="tooltip-custom" :class="addPadding('kanriitakusaki_manshonkanritekiseikaho_toroku_bango')">{{showMaxlength(23, kanriitakusaki_manshonkanritekiseikaho_toroku_bango, 'kanriitakusaki_manshonkanritekiseikaho_toroku_bango')}}</span>
                  <div v-if="formValidation.kanriitakusaki_manshonkanritekiseikaho_toroku_bango.isWarning" class="text-warning mt-8px" style="margin-left: 15px;">
                    {{formValidation.kanriitakusaki_manshonkanritekiseikaho_toroku_bango.warningMsg}}
                  </div>
                </th>
              </tr>
            </table>
             <!--（９）建物の維持修繕の実施状況の記録-->
            <div class="flex part-parent-name p-2" :id="`${arrayCommentId[15]}`">
              <span>（９）建物の維持修繕の実施状況の記録</span>
            </div>
            <table>
              <tr>
                <th class="w-1/4">
                  共用部分
                </th>
                <th>
                  <div class="flex" style="align-items: center;">
                    <div class="flex-row" >
                      <div class="flex">
                        <radio-box @input="lostFocus" v-model="kyoyobubun_umusentaku" vs-name="kyoyobubun_umusentaku" vs-value="1" class="ml-2 m-auto">有・</radio-box>
                        <radio-box @input="lostFocus" v-model="kyoyobubun_umusentaku" vs-name="kyoyobubun_umusentaku" vs-value="0" class="ml-4 m-auto mr-4">無</radio-box>
                      </div>
                      <div v-if="formValidation.kyoyobubun_umusentaku.isWarning" class="text-warning ml-2" style="margin-top: 4px">
                        {{formValidation.kyoyobubun_umusentaku.warningMsg}}
                      </div>
                    </div>
                    <div class="flex-row w-4/5">
                      <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('kyoyobubun_jisshijokyo')" class="w-full mb-0 mr-4" v-model="kyoyobubun_jisshijokyo" maxlength="76" name="kyoyobubun_jisshijokyo" > </vs-textarea>
                      <span class="tooltip-custom" :class="addPadding('kyoyobubun_jisshijokyo')">{{showMaxlength( 76,kyoyobubun_jisshijokyo , 'kyoyobubun_jisshijokyo')}}</span>
                      <div v-if="formValidation.kyoyobubun_jisshijokyo.isWarning" class="text-warning">
                        {{formValidation.kyoyobubun_jisshijokyo.warningMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th>
                  専有部分
                </th>
                <th>
                  <div class="flex" style="align-items: center;">
                    <div class="flex-row" >
                      <div class="flex">
                        <radio-box @input="lostFocus" v-model="senyububun_umusentaku" vs-name="senyububun_umusentaku" vs-value="1" class="ml-2 m-auto">有・</radio-box>
                        <radio-box @input="lostFocus" v-model="senyububun_umusentaku" vs-name="senyububun_umusentaku" vs-value="0" class="ml-4 m-auto mr-4">無</radio-box>
                      </div>
                      <div v-if="formValidation.senyububun_umusentaku.isWarning" class="text-warning ml-2" style="margin-top: 4px">
                        {{formValidation.senyububun_umusentaku.warningMsg}}
                      </div>
                    </div>
                    <div class="flex-row w-4/5">
                      <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus('senyububun_jisshijokyo')" class="mb-0 mr-4" v-model="senyububun_jisshijokyo" maxlength="76" name="senyububun_jisshijokyo" > </vs-textarea>
                      <span class="tooltip-custom" :class="addPadding('senyububun_jisshijokyo')">{{showMaxlength(76 ,senyububun_jisshijokyo ,'senyububun_jisshijokyo' )}}</span>
                      <div v-if="formValidation.senyububun_jisshijokyo.isWarning" class="text-warning">
                        {{formValidation.senyububun_jisshijokyo.warningMsg}}
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </table>
             <!--（１０）その他-->
            <div class="flex part-parent-name p-2" :id="`${arrayCommentId[16]}`">
              <span>（１０）その他</span>
            </div>
            <table>
              <tr>
                <td class="w-1/4">
                    <div class="grid">
                        <span class="text-left">「以下余白」の表示</span>
                    </div>
                </td>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="sonohoka_biko_matsubi_ikayohaku_hyoji2" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">末尾に「以下余白」を表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="w-1/4">
                    <div class="grid">
                        <span class="text-left">黒点／ナンバリング表示</span>
                    </div>
                </td>
                <td>
                  <div class="flex items-center">
                    <vs-checkbox v-model="sonohoka_biko_numbering2" class="inline-flex"></vs-checkbox>
                    <span class="ml-2">黒点／ナンバリングを表示する</span>
                  </div>
                </td>
              </tr>
            </table>
            <draggable v-model="sonohoka_biko_inputs" handle=".handle">
              <table class="w-full" v-for="(sonohoka_biko_t, index) in sonohoka_biko_inputs" :key="`sonohoka_biko-${index}`">
                <tr>
                  <td class="w-1/4">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="sonohoka_biko_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                  </td>
                  <td>
                    <div class="flex items-center">
                      <BunshoTemplate v-model="sonohoka_biko_t.naiyo" :screen="bunshoScreen(6)" />
                      <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                    </div>
                    <div class="mr-5">
                        <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`sonohoka_biko_t.naiyo.${index}`)" class="mt-2 mb-0" rows="5" maxlength="3000" v-model="sonohoka_biko_t.naiyo"/>
                        <span class="tooltip-custom" :class="addPadding(`sonohoka_biko_t.naiyo.${index}`)">{{showMaxlength(3000 , sonohoka_biko_t.naiyo, `sonohoka_biko_t.naiyo.${index}`)}}</span>
                    </div>
                  </td>
                </tr>
              </table>
            </draggable>
            <div class="flex justify-end mr-8 my-2" >
                <vs-button class="ml-4" @click="add_biko(sonohoka_biko_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('sonohoka_biko_inputs', sonohoka_biko_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
            </div>
        </tr>
      </table>
      </div>
      <div v-if="jrb == 'jrb-02' || jrb =='jrb-03' || jrb =='jrb-04'  ">
        <!-- 7 -->
        <table class="table-out">
          <tr :id="`${arrayCommentId[17]}`">
            <div class="flex part-parent-name p-2">
              <span>{{ jrb == 'jrb-02' ? '6' : '7'}}．建物状況調査の結果の概要（既存の住宅のとき）（</span>
              <div>
                <radio-box @input="lostFocus" v-model="jokyochosa_gaito_umu" vs-name="jokyochosa_gaito_umu" vs-value="1" class="ml-1 m-auto-top-bottom">該当する・</radio-box>
                <radio-box @input="lostFocus" v-model="jokyochosa_gaito_umu" vs-name="jokyochosa_gaito_umu" vs-value="0" class="ml-4 m-auto-top-bottom">該当しないので、説明を省略します。）</radio-box>
                <div v-if="formValidation.jokyochosa_gaito_umu.isWarning" class="text-warning">
                  {{formValidation.jokyochosa_gaito_umu.warningMsg}}
                </div>
              </div>
            </div>
          </tr>
          <tr class="pr-2">
            <th style="border-top: none;" class="p-0">
              <table >
                <tr>
                  <th colspan="2">
                    <div class="flex">
                      <span>建物状況調査の実施の有無（１年以内に実施している場合）(</span>
                      <div>
                        <radio-box @input="lostFocus" v-model="jokyochosa_jisshi_umu" vs-name="jokyochosa_jisshi_umu" vs-value="1" class="ml-1 m-auto-top-bottom">有・</radio-box>
                        <radio-box @input="lostFocus" v-model="jokyochosa_jisshi_umu" vs-name="jokyochosa_jisshi_umu" vs-value="0" class="ml-4 m-auto-top-bottom">無 )</radio-box>
                        <div v-if="formValidation.jokyochosa_jisshi_umu.isWarning" class="text-warning">
                          {{formValidation.jokyochosa_jisshi_umu.warningMsg}}
                        </div>
                      </div>
                    </div>
                    <div>
                      <span>
                        ※鉄筋コンクリート造または鉄骨鉄筋コンクリート造の共同住宅等にあっては、2年以内に実施している場合
                      </span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <td class="w-1/4">
                    <div class="grid">
                        <span class="text-left">「以下余白」の表示</span>
                    </div>
                  </td>
                  <td>
                    <div class="flex items-center">
                      <vs-checkbox v-model="jokyochosa_naiyo_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">末尾に「以下余白」を表示する</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="w-1/4">
                    <div class="grid">
                        <span class="text-left">黒点／ナンバリング表示</span>
                    </div>
                  </td>
                  <td>
                    <div class="flex items-center">
                      <vs-checkbox v-model="jokyochosa_naiyo_numbering" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">黒点／ナンバリングを表示する</span>
                    </div>
                  </td>
                </tr>
              </table>
              <draggable v-model="jokyochosa_naiyo_inputs" handle=".handle">
                <table class="w-full" v-for="(jokyochosa_naiyo_t, index) in jokyochosa_naiyo_inputs" :key="`jokyochosa_naiyo-${index}`" :id="`${arrayCommentId[18]}`">
                  <tr>
                    <td class="w-1/4" >
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="jokyochosa_naiyo_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="flex items-center">
                        <BunshoTemplate v-model="jokyochosa_naiyo_t.naiyo" :screen="bunshoScreen(7)" />
                        <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                      </div>
                      <div class="mr-5">
                        <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`jokyochosa_naiyo_t.naiyo.${index}`)" class="mt-2 mb-0" rows="5" maxlength="3000" v-model="jokyochosa_naiyo_t.naiyo"/>
                        <span class="tooltip-custom" :class="addPadding(`jokyochosa_naiyo_t.naiyo.${index}`)">{{showMaxlength(3000 ,jokyochosa_naiyo_t.naiyo , `jokyochosa_naiyo_t.naiyo.${index}`)}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
              <div class="flex justify-end my-2 mr-8" >
                <vs-button class="ml-4" @click="add_biko(jokyochosa_naiyo_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('jokyochosa_naiyo_inputs', jokyochosa_naiyo_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
              </div>
            </th>
          </tr>
        </table>
        <!-- 8 -->
        <table  class="table-out">
          <tr :id="`${arrayCommentId[19]}`">
            <div class="flex part-parent-name p-2">
              <span>{{ jrb == 'jrb-02' ? '7' : '8'}}．建物の建築および維持保全の状況に関する書類（原本）の保存の状況・耐震診断の内容</span>
            </div>
          </tr>
          <tr>
            <th style="border-top: none; border-bottom: none;">
              <table>
                <tr>
                  <th class="col-title text-center" rowspan="15" style="width:5%;">
                    建<br>物<br>の<br>建<br>築<br>お<br>よ<br>び<br>維<br>持<br>保<br>全<br>の<br>状<br>況
                  </th>
                  <th colspan="2">
                    <div class="flex">
                      <span class="m-auto-top-bottom"> 既存の建物に </span>
                      <radio-box @input="resetDataOnChange('tatemono_ijihozen_gaitokubun'); lostFocus()"
                                v-model="tatemono_ijihozen_gaitokubun"
                                vs-name="tatemono_ijihozen_gaitokubun"
                                vs-value="1" class="ml-2 m-auto-top-bottom"
                                @change="handleCheck('tatemono_ijihozen_gaitokubun')"
                                >該当する・</radio-box>
                      <radio-box @input="resetDataOnChange('tatemono_ijihozen_gaitokubun'); lostFocus()"
                                v-model="tatemono_ijihozen_gaitokubun"
                                vs-name="tatemono_ijihozen_gaitokubun"
                                @change="handleCheck('tatemono_ijihozen_gaitokubun')"
                                vs-value="0" class="ml-2 m-auto-top-bottom">該当しないので、説明を省略します。</radio-box>
                    </div>
                    <div v-if="formValidation.tatemono_ijihozen_gaitokubun.isWarning" class="text-warning mt-1" style="margin-left: 80px;">
                      {{formValidation.tatemono_ijihozen_gaitokubun.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th style="width: 70%;">
                    書類の種類等（※「該当しない」と「該当するか否か不明」の場合には説明を省略します）
                  </th>
                  <th style="width: 25%;">
                    保存の状況
                  </th>
                </tr>
                <tr>
                  <th style="width: 70%;">
                    ①確認の申請書および添付図書（新築時のもの）
                  </th>
                  <th style="width: 25%;">
                    <radio-box @input="lostFocus" v-model="kakunin_shinseisho_hozonumu1"
                              vs-name="kakunin_shinseisho_hozonumu1"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kakunin_shinseisho_hozonumu1"
                              vs-name="kakunin_shinseisho_hozonumu1"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kakunin_shinseisho_hozonumu1.isWarning" class="text-warning ml-2">
                      {{formValidation.kakunin_shinseisho_hozonumu1.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ②確認済証（新築時のもの）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kakuninzumisho_hozonumu2"
                              vs-name="kakuninzumisho_hozonumu2"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kakuninzumisho_hozonumu2"
                              vs-name="kakuninzumisho_hozonumu2"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kakuninzumisho_hozonumu2.isWarning" class="text-warning ml-2">
                      {{formValidation.kakuninzumisho_hozonumu2.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ③検査済証（新築時のもの）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kensazumisho_hozonumu3"
                              vs-name="kensazumisho_hozonumu3"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kensazumisho_hozonumu3"
                              vs-name="kensazumisho_hozonumu3"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kensazumisho_hozonumu3.isWarning" class="text-warning ml-2">
                      {{formValidation.kensazumisho_hozonumu3.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="2">
                    <div class="flex">
                      <span class="m-auto-top-bottom">増改築等を行なった建物に</span>
                      <radio-box @input="resetDataOnChange('zokaichiku_sentaku'); lostFocus()"
                                v-model="zokaichiku_sentaku"
                                vs-name="zokaichiku_sentaku" vs-value="0" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当する・</radio-box>
                      <radio-box @input="resetDataOnChange('zokaichiku_sentaku'); lostFocus()"
                                v-model="zokaichiku_sentaku"
                                @change="handleCheck('zokaichiku_sentaku')"
                                vs-name="zokaichiku_sentaku" vs-value="1" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当しない・</radio-box>
                      <radio-box @input="resetDataOnChange('zokaichiku_sentaku'); lostFocus()"
                                v-model="zokaichiku_sentaku"
                                @change="handleCheck('zokaichiku_sentaku')"
                                vs-name="zokaichiku_sentaku"
                                vs-value="2" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当するか否か不明</radio-box>
                    </div>
                    <div v-if="formValidation.zokaichiku_sentaku.isWarning" class="text-warning" style="margin-left: 150px;">
                      {{formValidation.zokaichiku_sentaku.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ④確認の申請書および添付図書（増改築当時のもの）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kakunin_shinseisho_hozonumu4"
                              vs-name="kakunin_shinseisho_hozonumu4"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="zokaichiku_sentaku == 1 || zokaichiku_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kakunin_shinseisho_hozonumu4"
                              vs-name="kakunin_shinseisho_hozonumu4"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="zokaichiku_sentaku == 1 || zokaichiku_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kakunin_shinseisho_hozonumu4.isWarning" class="text-warning ml-2">
                      {{formValidation.kakunin_shinseisho_hozonumu4.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑤確認済証（増改築当時のもの）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kakuninzumisho_hozonumu5"
                              vs-name="kakuninzumisho_hozonumu5"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="zokaichiku_sentaku == 1 || zokaichiku_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kakuninzumisho_hozonumu5"
                              vs-name="kakuninzumisho_hozonumu5"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="zokaichiku_sentaku == 1 || zokaichiku_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kakuninzumisho_hozonumu5.isWarning" class="text-warning ml-2">
                      {{formValidation.kakuninzumisho_hozonumu5.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑥検査済証（増改築当時のもの）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kensazumisho_hozonumu6"
                              vs-name="kensazumisho_hozonumu6"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="zokaichiku_sentaku == 1 || zokaichiku_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kensazumisho_hozonumu6"
                              vs-name="kensazumisho_hozonumu6"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="zokaichiku_sentaku == 1 || zokaichiku_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kensazumisho_hozonumu6.isWarning" class="text-warning ml-2">
                      {{formValidation.kensazumisho_hozonumu6.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="2">
                    <div class="flex">
                      <span class="m-auto-top-bottom">建物状況調査を実施した住宅に </span>
                      <radio-box @input="resetDataOnChange('tatemono_jokyochosa_jisshi_jutakudearu_baai'); lostFocus()"
                                v-model="tatemono_jokyochosa_jisshi_jutakudearu_baai"
                                vs-name="tatemono_jokyochosa_jisshi_jutakudearu_baai"
                                @change="handleCheck('tatemono_jokyochosa_jisshi_jutakudearu_baai')"
                                vs-value="0" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当する・</radio-box>
                      <radio-box @input="resetDataOnChange('tatemono_jokyochosa_jisshi_jutakudearu_baai'); lostFocus()"
                                v-model="tatemono_jokyochosa_jisshi_jutakudearu_baai"
                                vs-name="tatemono_jokyochosa_jisshi_jutakudearu_baai"
                                @change="handleCheck('tatemono_jokyochosa_jisshi_jutakudearu_baai')"
                                vs-value="1" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当しない</radio-box>
                      <radio-box @input="resetDataOnChange('tatemono_jokyochosa_jisshi_jutakudearu_baai'); lostFocus()"
                                v-model="tatemono_jokyochosa_jisshi_jutakudearu_baai"
                                @change="handleCheck('tatemono_jokyochosa_jisshi_jutakudearu_baai')"
                                vs-name="tatemono_jokyochosa_jisshi_jutakudearu_baai"
                                vs-value="2" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当するか否か不明</radio-box>
                    </div>
                    <div v-if="formValidation.tatemono_jokyochosa_jisshi_jutakudearu_baai.isWarning" class="text-warning" style="margin-left: 175px;">
                      {{formValidation.tatemono_jokyochosa_jisshi_jutakudearu_baai.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑦建物状況調査報告書（１年以内のものに限らない）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="tatemono_jokyochosa_hokokusho_hozonumu"
                              vs-name="tatemono_jokyochosa_hokokusho_hozonumu"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="tatemono_jokyochosa_jisshi_jutakudearu_baai == 1 || tatemono_jokyochosa_jisshi_jutakudearu_baai == 2 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="tatemono_jokyochosa_hokokusho_hozonumu"
                              vs-name="tatemono_jokyochosa_hokokusho_hozonumu"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="tatemono_jokyochosa_jisshi_jutakudearu_baai == 1 || tatemono_jokyochosa_jisshi_jutakudearu_baai == 2 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.tatemono_jokyochosa_hokokusho_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.tatemono_jokyochosa_hokokusho_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="2">
                    <div class="flex">
                      <span class="m-auto-top-bottom">建築基準法第12条の規定による定期調査報告の対象である住宅に</span>
                      <div class="flex-row">
                        <div class="flex">
                          <radio-box @input="resetDataOnChange('kenchiku_kijunhodai_12jo_sentaku'); lostFocus()"
                                    v-model="kenchiku_kijunhodai_12jo_sentaku"
                                    @change="handleCheck('kenchiku_kijunhodai_12jo_sentaku')"
                                    vs-name="kenchiku_kijunhodai_12jo_sentaku"
                                    vs-value="0" class="ml-2"
                                    :disabled="tatemono_ijihozen_gaitokubun === '0'">該当する・</radio-box>
                          <radio-box @input="resetDataOnChange('kenchiku_kijunhodai_12jo_sentaku'); lostFocus()"
                                    v-model="kenchiku_kijunhodai_12jo_sentaku"
                                    @change="handleCheck('kenchiku_kijunhodai_12jo_sentaku')"
                                    vs-name="kenchiku_kijunhodai_12jo_sentaku"
                                    vs-value="1" class="ml-2"
                                    :disabled="tatemono_ijihozen_gaitokubun === '0'">該当しない</radio-box>
                          <radio-box @input="resetDataOnChange('kenchiku_kijunhodai_12jo_sentaku'); lostFocus()"
                                    v-model="kenchiku_kijunhodai_12jo_sentaku"
                                    @change="handleCheck('kenchiku_kijunhodai_12jo_sentaku')"
                                    vs-name="kenchiku_kijunhodai_12jo_sentaku"
                                    vs-value="2" class="ml-2"
                                    :disabled="tatemono_ijihozen_gaitokubun === '0'">該当するか否か不明</radio-box>
                        </div>
                        <div v-if="formValidation.kenchiku_kijunhodai_12jo_sentaku.isWarning" class="text-warning ml-2">
                          {{formValidation.kenchiku_kijunhodai_12jo_sentaku.warningMsg}}
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑧定期調査報告書（特定建築物）・定期検査報告書（昇降機等）
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="teikichosa_teikihokokusho_hozonumu"
                              vs-name="teikichosa_teikihokokusho_hozonumu"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="kenchiku_kijunhodai_12jo_sentaku == 1 || kenchiku_kijunhodai_12jo_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="teikichosa_teikihokokusho_hozonumu"
                              vs-name="teikichosa_teikihokokusho_hozonumu"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="kenchiku_kijunhodai_12jo_sentaku == 1 || kenchiku_kijunhodai_12jo_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.teikichosa_teikihokokusho_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.teikichosa_teikihokokusho_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="2">
                    <div class="flex">
                      <span class="m-auto-top-bottom">既存住宅性能評価（建設）を受けた住宅に </span>
                      <radio-box @input="resetDataOnChange('kizonjutaku_seino_hyoka_sentaku'); lostFocus()"
                                v-model="kizonjutaku_seino_hyoka_sentaku"
                                @change="handleCheck('kizonjutaku_seino_hyoka_sentaku')"
                                vs-name="kizonjutaku_seino_hyoka_sentaku"
                                vs-value="0" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当する・</radio-box>
                      <radio-box @input="resetDataOnChange('kizonjutaku_seino_hyoka_sentaku'); lostFocus()"
                                v-model="kizonjutaku_seino_hyoka_sentaku"
                                @change="handleCheck('kizonjutaku_seino_hyoka_sentaku')"
                                vs-name="kizonjutaku_seino_hyoka_sentaku"
                                vs-value="1" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当しない</radio-box>
                      <radio-box @input="resetDataOnChange('kizonjutaku_seino_hyoka_sentaku'); lostFocus()"
                                v-model="kizonjutaku_seino_hyoka_sentaku"
                                @change="handleCheck('kizonjutaku_seino_hyoka_sentaku')"
                                vs-name="kizonjutaku_seino_hyoka_sentaku"
                                vs-value="2" class="ml-2"
                                :disabled="tatemono_ijihozen_gaitokubun === '0'">該当するか否か不明</radio-box>
                    </div>
                    <div v-if="formValidation.kizonjutaku_seino_hyoka_sentaku.isWarning" class="text-warning" style="margin-left: 235px;">
                      {{formValidation.kizonjutaku_seino_hyoka_sentaku.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑨既存住宅性能評価書（現況検査・評価書）
                  </th>
                  <th>
                    <div class="flex">
                      <radio-box @input="lostFocus" v-model="kizonjutaku_seino_hyokasho_hozonumu"
                                vs-name="kizonjutaku_seino_hyokasho_hozonumu" vs-value="1" class="ml-2"
                                :disabled="kizonjutaku_seino_hyoka_sentaku == 1 || kizonjutaku_seino_hyoka_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                      <radio-box @input="lostFocus" v-model="kizonjutaku_seino_hyokasho_hozonumu"
                                vs-name="kizonjutaku_seino_hyokasho_hozonumu" vs-value="0" class="ml-2"
                                :disabled="kizonjutaku_seino_hyoka_sentaku == 1 || kizonjutaku_seino_hyoka_sentaku == 2 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    </div>
                    <div v-if="formValidation.kizonjutaku_seino_hyokasho_hozonumu.isWarning" class="text-warning ml-2" >
                      {{formValidation.kizonjutaku_seino_hyokasho_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
              </table>
            </th>
          </tr>
          <!-- 建物の耐震診断の内容 -->
          <tr>
            <th style="border-top: none; border-bottom: none;">
              <table>
                <tr>
                  <th rowspan="7" style="width:5%;" class="col-title text-center">
                    建<br>物<br>の<br>耐<br>震<br>診<br>断<br>の<br>内<br>容
                  </th>
                  <th colspan="2">
                    <div class="flex">
                      <span class="m-auto-top-bottom">昭和５６年５月３１日以前に新築の工事に着手した既存の建物に</span>
                      <div class="flex-row">
                        <div class="flex">
                          <radio-box v-model="shinchiku_koji_chaku_tatemonodearubaai_kubun"
                                    @change="handleCheck('shinchiku_koji_chaku_tatemonodearubaai_kubun')"
                                    @input="resetDataOnChange('shinchiku_koji_chaku_tatemonodearubaai_kubun'); lostFocus()"
                                    vs-name="shinchiku_koji_chaku_tatemonodearubaai_kubun"
                                    vs-value="1" class="ml-2"
                                    :disabled="tatemono_ijihozen_gaitokubun === '0'">該当する・</radio-box>
                          <radio-box v-model="shinchiku_koji_chaku_tatemonodearubaai_kubun"
                                    @change="handleCheck('shinchiku_koji_chaku_tatemonodearubaai_kubun')"
                                    @input="resetDataOnChange('shinchiku_koji_chaku_tatemonodearubaai_kubun'); lostFocus()"
                                    vs-name="shinchiku_koji_chaku_tatemonodearubaai_kubun"
                                    vs-value="0" class="ml-2"
                                    :disabled="tatemono_ijihozen_gaitokubun === '0'">該当しないので、説明を省略します。</radio-box>
                        </div>
                        <div v-if="formValidation.shinchiku_koji_chaku_tatemonodearubaai_kubun.isWarning" class="text-warning ml-2">
                          {{formValidation.shinchiku_koji_chaku_tatemonodearubaai_kubun.warningMsg}}
                        </div>
                      </div>
                    </div>

                  </th>
                </tr>
                <tr>
                  <th style="width: 70%;">
                    既存住宅性能評価書（現況検査・評価書）記載中１-１．耐震等級の区分
                  </th>
                  <th style="width: 25%;">
                    <radio-box @input="lostFocus" v-model="kizonjutaku_seinohyokasho_umu"
                              vs-name="kizonjutaku_seinohyokasho_umu" vs-value="1"
                              class="ml-2 m-auto whitespace-nowrap"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">１以上（適）</radio-box>
                    <radio-box @input="lostFocus" v-model="kizonjutaku_seinohyokasho_umu"
                              vs-name="kizonjutaku_seinohyokasho_umu" vs-value="0"
                              class="ml-2 m-auto whitespace-nowrap"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">０（不適）</radio-box>
                    <div v-if="formValidation.kizonjutaku_seinohyokasho_umu.isWarning" class="text-warning ml-2">
                      {{formValidation.kizonjutaku_seinohyokasho_umu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑩耐震診断結果の報告書
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="taishinshindan_kekka_hokokusho_hozonumu"
                              vs-name="taishinshindan_kekka_hokokusho_hozonumu"
                              vs-value="1" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="taishinshindan_kekka_hokokusho_hozonumu"
                              vs-name="taishinshindan_kekka_hokokusho_hozonumu"
                              vs-value="0" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.taishinshindan_kekka_hokokusho_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.taishinshindan_kekka_hokokusho_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    結果報告書の記載中、新耐震基準適合性を証する記載
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="shintaishinkijun_tekigosei_hozonumu"
                              vs-name="shintaishinkijun_tekigosei_hozonumu" vs-value="1" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="shintaishinkijun_tekigosei_hozonumu"
                              vs-name="shintaishinkijun_tekigosei_hozonumu" vs-value="0" class="ml-2 m-auto"
                    :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.shintaishinkijun_tekigosei_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.shintaishinkijun_tekigosei_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑪既存住宅売買瑕疵保険の付保証明書
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kashihoken_hozonumu"
                              vs-name="kashihoken_hozonumu" vs-value="1" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kashihoken_hozonumu"
                              vs-name="kashihoken_hozonumu" vs-value="0" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.kashihoken_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.kashihoken_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ⑫耐震基準適合証明書
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="taishinkijuntekigoshomeish_hozonumu"
                              vs-name="taishinkijuntekigoshomeish_hozonumu" vs-value="1" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="taishinkijuntekigoshomeish_hozonumu"
                              vs-name="taishinkijuntekigoshomeish_hozonumu" vs-value="0" class="ml-2 m-auto"
                              :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.taishinkijuntekigoshomeish_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.taishinkijuntekigoshomeish_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    <div class="flex">
                      <span class="m-auto-top-bottom whitespace-nowrap"> ⑬その他 </span>
                      <div class="w-full ml-4">
                        <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('sonohoka_nyuryoku')" v-model="sonohoka_nyuryoku" maxlength="16" :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'"/>
                        <span class="tooltip-custom" :class="addPadding('sonohoka_nyuryoku')">{{showMaxlength(16, sonohoka_nyuryoku, 'sonohoka_nyuryoku')}}</span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="sonohoka_hozonumu" vs-name="sonohoka_hozonumu" vs-value="1" class="ml-2 m-auto"
                    :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="sonohoka_hozonumu" vs-name="sonohoka_hozonumu" vs-value="0" class="ml-2 m-auto"
                    :disabled="shinchiku_koji_chaku_tatemonodearubaai_kubun == 0 || tatemono_ijihozen_gaitokubun === '0'">無</radio-box>
                    <div v-if="formValidation.sonohoka_hozonumu.isWarning" class="text-warning ml-2">
                      {{formValidation.sonohoka_hozonumu.warningMsg}}
                    </div>
                  </th>
                </tr>
              </table>
            </th>
          </tr>
          <tr :id="`${arrayCommentId[20]}`">
            <th style="border-top:none;">
              <table>
                <tr>
                  <th class="w-1/5">
                    <div class="grid">
                      <span class="text-left">「以下余白」の表示</span>
                    </div>
                  </th>
                  <th>
                    <div class="flex items-center">
                      <vs-checkbox v-model="taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">末尾に「以下余白」を表示する</span>
                    </div>
                  </th>
                </tr>
              </table>
              <table>
                <tr>
                  <th class="w-1/5">
                    <div class="grid">
                      <span class="text-left">黒点／ナンバリング表示</span>
                    </div>
                  </th>
                  <th>
                    <div class="flex items-center">
                      <vs-checkbox v-model="taishinshindan_kekka_hokokusho_biko_numbering" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">黒点／ナンバリングを表示する</span>
                    </div>
                  </th>
                </tr>
              </table>
              <draggable v-model="taishinshindan_kekka_hokokusho_biko_inputs" handle=".handle">
                <table class="w-full" v-for="(taishinshindan_kekka_hokokusho_biko_t, index) in taishinshindan_kekka_hokokusho_biko_inputs" :key="`taishinshindan_kekka_hokokusho_biko-${index}`">
                  <tr>
                    <th class="w-1/5">
                        <div class="flex justify-center items-center">
                          <vs-checkbox v-model="taishinshindan_kekka_hokokusho_biko_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                          <div class="handle pt-3 pl-3 cursor-default w-27">
                            <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                              <DragBlackIcon />
                            </vx-tooltip>
                          </div>
                        </div>
                    </th>
                    <th>
                      <div class="flex items-center">
                        <BunshoTemplate v-model="taishinshindan_kekka_hokokusho_biko_t.naiyo" :screen="bunshoScreen(8)" />
                        <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                      </div>
                      <div class="mr-5">
                        <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`taishinshindan_kekka_hokokusho_biko_t.naiyo.${index}`)" class="mt-4 mb-0" rows="5" maxlength="3000" v-model="taishinshindan_kekka_hokokusho_biko_t.naiyo"/>
                        <span class="tooltip-custom" :class="addPadding(`taishinshindan_kekka_hokokusho_biko_t.naiyo.${index}`)">{{showMaxlength(3000, taishinshindan_kekka_hokokusho_biko_t.naiyo, `taishinshindan_kekka_hokokusho_biko_t.naiyo.${index}`)}}</span>
                      </div>
                    </th>
                  </tr>
                </table>
              </draggable>
              <div class="flex justify-end mt-2 mr-8" >
                <vs-button class="ml-4" @click="add_biko(taishinshindan_kekka_hokokusho_biko_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('taishinshindan_kekka_hokokusho_biko_inputs', taishinshindan_kekka_hokokusho_biko_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
              </div>
            </th>
          </tr>
        </table>
        <!-- 9 -->
        <table class="table-out">
          <tr :id="`${arrayCommentId[21]}`">
              <div class="part-parent-name p-2">
                <span>{{ jrb == 'jrb-02' ? '8' : '9'}}．建築確認済証等の発行年月日・番号</span>
              </div>
          </tr>
          <tr>
            <th style="border-top: none;" class="p-0">
              <table>
                <tr>
                  <th>
                    <div class="flex">
                      <vs-checkbox v-model="kakuninzumisho_umusentaku" name="kakuninzumisho_umusentaku" @input="lostFocus()">
                        確認済証（新築時）
                      </vs-checkbox>
                    </div>
                    <div v-if="formValidation.kakuninzumisho_umusentaku.isWarning" class="text-warning ml-2">
                      {{formValidation.kakuninzumisho_umusentaku.warningMsg}}
                    </div>
                  </th>
                  <th>
                    <DatePickerCustom class="mb-2" v-model="kakuninzumisho_nengappi"
                                      :date="kakuninzumisho_nengappi"
                                      :checkboxvalue="kakuninzumisho_nengappi_checkbox"
                                      v-on:change-checkbox="kakuninzumisho_nengappi_checkbox = $event"
                                      name="kakuninzumisho_nengappi"
                                      format="yyyy-MM-dd" separate="-"
                                      @lost-focus="lostFocus"/>
                    <div v-if="formValidation.kakuninzumisho_nengappi.isWarning" class="text-warning mt-2">
                      {{formValidation.kakuninzumisho_nengappi.warningMsg}}
                    </div>
                    <div class="text-danger" v-if="formValidation.kakuninzumisho_nengappi.isError">
                      {{formValidation.kakuninzumisho_nengappi.errorMsg}}
                    </div>
                    <div class="flex">
                      <div class="w-5/6">
                        <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kakuninzumisho_bango')"
                                v-model="kakuninzumisho_bango"
                                name="kakuninzumisho_bango"
                                :class="formValidation.kakuninzumisho_bango.isWarning ? 'input-warning' : ''"
                                maxlength="30"/>
                        <span class="tooltip-custom" :class="addPadding('kakuninzumisho_bango')">{{showMaxlength(30, kakuninzumisho_bango, 'kakuninzumisho_bango')}}</span>
                      </div>
                      <span class="ml-4 m-auto font-light">号</span>
                    </div>
                    <div v-if="formValidation.kakuninzumisho_bango.isWarning" class="text-warning mt-2">
                      {{formValidation.kakuninzumisho_bango.warningMsg}}
                    </div>
                  </th>
                </tr> 
                <tr>
                  <th>
                    <div class="flex">
                      <vs-checkbox v-model="kensazumisho_umusentaku" name="kensazumisho_umusentaku" @input="lostFocus()">
                        検査済証（新築時）
                      </vs-checkbox>
                    </div>
                    <div v-if="formValidation.kensazumisho_umusentaku.isWarning" class="text-warning ml-2">
                      {{formValidation.kensazumisho_umusentaku.warningMsg}}
                    </div>
                  </th>
                  <th>
                    <DatePickerCustom class="mb-2" v-model="kensazumisho_nengappi"
                                      :date="kensazumisho_nengappi"
                                      :checkboxvalue="kensazumisho_nengappi_checkbox"
                                      v-on:change-checkbox="kensazumisho_nengappi_checkbox = $event"
                                      name="kensazumisho_nengappi"
                                      format="yyyy-MM-dd" separate="-"
                                      @lost-focus="lostFocus"/>
                    <div v-if="formValidation.kensazumisho_nengappi.isWarning" class="text-warning">
                      {{formValidation.kensazumisho_nengappi.warningMsg}}
                    </div>
                    <div class="text-danger" v-if="formValidation.kensazumisho_nengappi.isError">
                      {{formValidation.kensazumisho_nengappi.errorMsg}}
                    </div>
                    <div class="flex">
                      <div class="w-5/6">
                        <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('kensazumisho_bango')"
                                v-model="kensazumisho_bango"
                                name="kensazumisho_bango"
                                :class="formValidation.kensazumisho_bango.isWarning ? 'input-warning' : ''"
                                maxlength="30"/>
                        <span class="tooltip-custom" :class="addPadding('kensazumisho_bango')">{{showMaxlength(30, kensazumisho_bango, 'kensazumisho_bango')}}</span>
                      </div>
                      <span class="ml-4 m-auto font-light">号</span>
                    </div>
                    <div v-if="formValidation.kensazumisho_bango.isWarning" class="text-warning mt-2">
                      {{formValidation.kensazumisho_bango.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <td class="w-1/5">
                    <div class="grid">
                      <span class="text-left">「以下余白」の表示</span>
                    </div>
                  </td>
                  <td>
                    <div class="flex items-center">
                      <vs-checkbox v-model="kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">末尾に「以下余白」を表示する</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="w-1/5">
                    <div class="grid">
                      <span class="text-left">黒点／ナンバリング表示</span>
                    </div>
                  </td>
                  <td>
                    <div class="flex items-center">
                      <vs-checkbox v-model="kenchiku_kakuninzumisho_biko_numbering" class="inline-flex"></vs-checkbox>
                      <span class="ml-2">黒点／ナンバリングを表示する</span>
                    </div>
                  </td>
                </tr>
              </table>
              <draggable v-model="kenchiku_kakuninzumisho_biko_inputs" handle=".handle">
                <table class="w-full" v-for="(kenchiku_kakuninzumisho_biko_t, index) in kenchiku_kakuninzumisho_biko_inputs" :key="`kenchiku_kakuninzumisho_biko-${index}`"  :id="`${arrayCommentId[22]}`">
                  <tr>
                    <td class="w-1/5">
                      <div class="flex justify-center items-center">
                        <vs-checkbox v-model="kenchiku_kakuninzumisho_biko_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                        <div class="handle pt-3 pl-3 cursor-default w-27">
                          <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                            <DragBlackIcon />
                          </vx-tooltip>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="flex items-center">
                        <BunshoTemplate v-model="kenchiku_kakuninzumisho_biko_t.naiyo" :screen="bunshoScreen(9)" />
                        <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                      </div>
                      <div class="mr-5">
                          <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`kenchiku_kakuninzumisho_biko_t.naiyo.${index}`)" class="mt-4 mb-0" rows="5" maxlength="3000" v-model="kenchiku_kakuninzumisho_biko_t.naiyo" />
                          <span class="tooltip-custom" :class="addPadding(`kenchiku_kakuninzumisho_biko_t.naiyo.${index}`)">{{showMaxlength(3000 ,kenchiku_kakuninzumisho_biko_t.naiyo , `kenchiku_kakuninzumisho_biko_t.naiyo.${index}`)}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </draggable>
              <div class="flex justify-end my-2 mr-8" >
                <vs-button class="ml-4" @click="add_biko(kenchiku_kakuninzumisho_biko_inputs)">項目追加 </vs-button>
                <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('kenchiku_kakuninzumisho_biko_inputs', kenchiku_kakuninzumisho_biko_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
              </div>
            </th>
          </tr>
        </table>
        <!-- 10 -->
        <table class="table-out" :id="`${arrayCommentId[23]}`">
          <tr>
              <div class="flex part-parent-name p-2">
                <span class="m-auto-top-bottom">{{ jrb == 'jrb-02' ? '9' : '10'}}．住宅性能評価を受けた新築住宅である場合 （</span>
                <radio-box @input="lostFocus" v-model="jutakuseinohyoka_uketa_shinchiku_sentaku" vs-name="jutakuseinohyoka_uketa_shinchiku_sentaku" vs-value="0" class="ml-2" @change="handleCheck('jutakuseinohyoka_uketa_shinchiku_sentaku')">該当する・</radio-box>
                <radio-box @input="lostFocus" v-model="jutakuseinohyoka_uketa_shinchiku_sentaku" vs-name="jutakuseinohyoka_uketa_shinchiku_sentaku" vs-value="1" class="ml-2" @change="handleCheck('jutakuseinohyoka_uketa_shinchiku_sentaku')">該当しないので、説明を省略します。）</radio-box>
              </div>
              <div v-if="formValidation.jutakuseinohyoka_uketa_shinchiku_sentaku.isWarning" class="text-warning" style="margin-left: 332px;">
                {{formValidation.jutakuseinohyoka_uketa_shinchiku_sentaku.warningMsg}}
              </div>
          </tr>
          <tr>
            <th class="border-top: none;">
              <span>登録住宅性能評価機関による住宅性能評価書の交付の有無</span>
              <table class="w-1/2 mt-2 ml-4">
                <tr>
                  <th>
                    １.設計住宅性能評価書
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="sekkeijutaku_seino_hyokasho_umu" vs-name="sekkeijutaku_seino_hyokasho_umu" vs-value="1" :disabled="jutakuseinohyoka_uketa_shinchiku_sentaku !== '0'" class="ml-2 m-auto">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="sekkeijutaku_seino_hyokasho_umu" vs-name="sekkeijutaku_seino_hyokasho_umu" vs-value="0" :disabled="jutakuseinohyoka_uketa_shinchiku_sentaku !== '0'" class="ml-2 m-auto">無</radio-box>
                    <div v-if="formValidation.sekkeijutaku_seino_hyokasho_umu.isWarning" class="text-warning ml-2">
                      {{formValidation.sekkeijutaku_seino_hyokasho_umu.warningMsg}}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ２.建設住宅性能評価書
                  </th>
                  <th>
                    <radio-box @input="lostFocus" v-model="kensetsujutaku_seino_hyokasho_umu" vs-name="kensetsujutaku_seino_hyokasho_umu" vs-value="1" :disabled="jutakuseinohyoka_uketa_shinchiku_sentaku !== '0'" class="ml-2 m-auto">有・</radio-box>
                    <radio-box @input="lostFocus" v-model="kensetsujutaku_seino_hyokasho_umu" vs-name="kensetsujutaku_seino_hyokasho_umu" vs-value="0" :disabled="jutakuseinohyoka_uketa_shinchiku_sentaku !== '0'" class="ml-2 m-auto">無</radio-box>
                    <div v-if="formValidation.kensetsujutaku_seino_hyokasho_umu.isWarning" class="text-warning ml-2">
                      {{formValidation.kensetsujutaku_seino_hyokasho_umu.warningMsg}}
                    </div>
                  </th>
                </tr>
              </table>
            </th>
          </tr>
        </table>
        <!-- 11 -->
        <table class="table-out" :id="`${arrayCommentId[24]}`">
          <tr>
              <div class="p-2 part-parent-name">
                <span>{{ jrb == 'jrb-02' ? '10' : '11'}}．石綿使用調査の内容 </span>
              </div>
          </tr>
          <tr>
            <table class="mb-2 ml-4 w-5/6 ">
              <tr>
                <th class="w-1/3">
                  石綿使用調査結果の記録の有無
                </th>
                <th class="w-2/3">
                  <radio-box @input="lostFocus" v-model="ishiwatashiyo_chosa_umu_sentaku" vs-name="ishiwatashiyo_chosa_umu_sentaku" vs-value="1" class="m-auto">有・</radio-box>
                  <radio-box @input="lostFocus" v-model="ishiwatashiyo_chosa_umu_sentaku" vs-name="ishiwatashiyo_chosa_umu_sentaku" vs-value="0" class="ml-2 m-auto">無</radio-box><br>
                  <div v-if="formValidation.ishiwatashiyo_chosa_umu_sentaku.isWarning" class="text-warning">
                    {{formValidation.ishiwatashiyo_chosa_umu_sentaku.warningMsg}}
                  </div>
                  <span>石綿使用調査結果の記録がある場合、その内容はⅤ備考に記載します。</span>
                </th>
              </tr>
            </table>
          </tr>
        </table>
      </div>
        <!-- 12 -->
      <table class="table-out" :id="`${arrayCommentId[25]}`">
        <tr> 
          <div class="part-parent-name p-2">
            <span>{{ jrb == 'jrb-02' ? '11' : (jrb == 'jrb-01' ? '6': '12')}}．当該宅地建物が造成宅地防災区域内か否か </span>
          </div>
        </tr>
        <tr>
          <table class="mb-2 ml-4" style="width: 95%">
            <tr>
              <th class="w-1/2">
                宅地造成及び特定盛土等規制法（旧宅地造成等規制法）に基づく造成宅地防災区域
              </th>
              <th>
                <radio-box @input="lostFocus" v-model="zoseitakuchi_kuiki_sentaku" vs-name="zoseitakuchi_kuiki_sentaku" vs-value="1" class="m-auto">内・</radio-box>
                <radio-box @input="lostFocus" v-model="zoseitakuchi_kuiki_sentaku" vs-name="zoseitakuchi_kuiki_sentaku" vs-value="0" class="ml-2 m-auto">外</radio-box>
                <div v-if="formValidation.zoseitakuchi_kuiki_sentaku.isWarning" class="text-warning">
                  {{formValidation.zoseitakuchi_kuiki_sentaku.warningMsg}}
                </div>
              </th>
            </tr>
          </table>
        </tr>
      </table>
       <!-- 13 -->
      <table class="table-out" :id="`${arrayCommentId[26]}`">
        <tr>
          <div class="part-parent-name p-2">
            <span>{{ jrb == 'jrb-02' ? '12' :  (jrb == 'jrb-01' ? '7': '13')}}．当該宅地建物が土砂災害警戒区域内か否か </span>
          </div>
        </tr>
        <tr>
          <table class="mb-2 ml-4" style="width: 95%">
            <tr>
              <th class="w-1/2">
                土砂災害防止対策推進方に基づく土砂災害警戒区域
              </th>
              <th>
                <radio-box @input="lostFocus" v-model="doshasaigai_kuiki_sentaku" vs-name="doshasaigai_kuiki_sentaku" vs-value="1" class="m-auto">内・</radio-box>
                <radio-box @input="lostFocus" v-model="doshasaigai_kuiki_sentaku" vs-name="doshasaigai_kuiki_sentaku" vs-value="0" class="ml-2 m-auto">外</radio-box>
                <div v-if="formValidation.doshasaigai_kuiki_sentaku.isWarning" class="text-warning">
                  {{formValidation.doshasaigai_kuiki_sentaku.warningMsg}}
                </div>
              </th>
            </tr>
          </table>
        </tr>
      </table>
       <!-- 14 -->
      <table class="table-out" :id="`${arrayCommentId[27]}`">
        <tr>
          <div class="part-parent-name p-2">
            <span>{{ jrb == 'jrb-02' ? '13' : (jrb == 'jrb-01' ? '8': '14')}}．当該宅地建物が津波災害警戒区域内か否か </span>
          </div>
        </tr>
        <tr>
          <table class="mb-2 ml-4" style="width: 95%">
            <tr>
              <th class="w-1/2">
                津波防災地域づくりに関する法律に基づく津波災害警戒区域
              </th>
              <th class="w-1/2">
                <div style="display: flex;">
                  <div class="mr-12 self-center" style="">
                    <radio-box @input="lostFocus" v-model="tsunami_kuiki_sentaku" vs-name="tsunami_kuiki_sentaku" vs-value="1" class="m-auto">内・</radio-box>
                    <radio-box @input="lostFocus" v-model="tsunami_kuiki_sentaku" vs-name="tsunami_kuiki_sentaku" vs-value="0" class="ml-2 m-auto">外</radio-box>
                    <div v-if="formValidation.tsunami_kuiki_sentaku.isWarning" class="text-warning">
                      {{formValidation.tsunami_kuiki_sentaku.warningMsg}}
                    </div>
                  </div>
                  <div class="w-3/4">
                    <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('tsunami_disaster_caution')"
                      v-model="tsunami_disaster_caution"
                      name="tsunami_disaster_caution"
                      maxlength="25"/>
                    <span class="tooltip-custom" :class="addPadding(`tsunami_disaster_caution`)">{{showMaxlength( 25 , tsunami_disaster_caution , `tsunami_disaster_caution`)}}</span>
                  </div>
                </div>  
              </th>
            </tr>
          </table>
        </tr>
      </table>
      <!-- 15 -->
      <table class="table-out">
        <tr :id="`${arrayCommentId[28]}`">
          <div class="part-parent-name p-2">
            <span>{{ jrb == 'jrb-02' ? '14' : (jrb == 'jrb-01' ? '9': '15')}}．水害ハザードマップにおける本物件の所在地</span>
          </div>
        </tr>
        <tr>
          <table class="ml-4" style="width: 95%">
            <tr>
              <th class="w-1/4">
                水害ハザードマップの有無
              </th>
              <th>
                <div class="flex">
                  <span class="m-auto-top-bottom">洪水</span>
                  <radio-box @input="lostFocus" v-model="hazadomappu_umu_kozui" vs-name="hazadomappu_umu_kozui" vs-value="1" class="ml-1">有・</radio-box>
                  <radio-box @input="lostFocus" v-model="hazadomappu_umu_kozui" vs-name="hazadomappu_umu_kozui" vs-value="0" class="ml-1">無</radio-box>
                </div>
                <div v-if="formValidation.hazadomappu_umu_kozui.isWarning" class="text-warning mt-1" style="margin-left: 28px">
                  {{formValidation.hazadomappu_umu_kozui.warningMsg}}
                </div>
              </th>
              <th>
                <div class="flex">
                  <span>雨水出水（内水） </span>
                  <radio-box @input="lostFocus" v-model="hazadomappu_umu_usuishussui" vs-name="hazadomappu_umu_usuishussui" vs-value="1" class="ml-1">有・</radio-box>
                  <radio-box @input="lostFocus" v-model="hazadomappu_umu_usuishussui" vs-name="hazadomappu_umu_usuishussui" vs-value="0" class="ml-1">無</radio-box>
                </div>
                <div v-if="formValidation.hazadomappu_umu_usuishussui.isWarning" class="text-warning mt-1" style="margin-left: 100px">
                  {{formValidation.hazadomappu_umu_usuishussui.warningMsg}}
                </div>
              </th>
              <th>
                <div class="flex">
                  <span>高潮</span>
                  <radio-box @input="lostFocus" v-model="hazadomappu_umu_takashio" vs-name="hazadomappu_umu_takashio" vs-value="1" class="ml-1">有・</radio-box>
                  <radio-box @input="lostFocus" v-model="hazadomappu_umu_takashio" vs-name="hazadomappu_umu_takashio" vs-value="0" class="ml-1">無</radio-box>
                </div>
                <div v-if="formValidation.hazadomappu_umu_takashio.isWarning" class="text-warning mt-1" style="margin-left: 28px">
                  {{formValidation.hazadomappu_umu_takashio.warningMsg}}
                </div>
              </th>
            </tr>
            <tr :id="`${arrayCommentId[29]}`">
              <td colspan="4">
                水害ハザードマップにおける宅地建物の所在地
              </td>
            </tr>
            <tr>
              <td>
                <div class="grid">
                  <span class="text-left">「以下余白」の表示</span>
                </div>
              </td>
              <td colspan="3">
                <div class="flex items-center">
                  <vs-checkbox v-model="hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">末尾に「以下余白」を表示する</span>
                </div>
              </td>
            </tr>
             <tr>
              <td>
                <div class="grid">
                  <span class="text-left">黒点／ナンバリング表示</span>
                </div>
              </td>
              <td colspan="3">
                <div class="flex items-center">
                  <vs-checkbox v-model="hazadomappu_umu_setsumei_numbering" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">黒点／ナンバリングを表示する</span>
                </div>
              </td>
            </tr>
          </table>
          <draggable v-model="hazadomappu_umu_setsumei_inputs" handle=".handle">
            <table style="width:95%" class="ml-4" v-for="(hazadomappu_umu_setsumei_t, index) in hazadomappu_umu_setsumei_inputs" :key="`hazadomappu_umu_setsumei-${index}`">
              <tr>
                <td class="w-1/4">
                  <div class="flex justify-center items-center">
                    <vs-checkbox v-model="hazadomappu_umu_setsumei_t.checkboxDelete">備考 {{index +1 }}</vs-checkbox>
                    <div class="handle pt-3 pl-3 cursor-default w-27">
                      <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                        <DragBlackIcon />
                      </vx-tooltip>
                    </div>
                  </div>
                </td>
                <td colspan="3">
                  <div class="flex items-center">
                    <BunshoTemplate v-model="hazadomappu_umu_setsumei_t.naiyo" :screen="bunshoScreen(10)" />
                    <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                  </div>
                  <div class="mr-5">
                      <vs-textarea @blur="lostFocus, focusOut()" @focus="onFocus(`hazadomappu_umu_setsumei_t.naiyo.${index}`)" class="mt-4 mb-0" rows="5" maxlength="3000" v-model="hazadomappu_umu_setsumei_t.naiyo"/>
                      <span class="tooltip-custom" :class="addPadding(`hazadomappu_umu_setsumei_t.naiyo.${index}`)">{{showMaxlength( 3000,hazadomappu_umu_setsumei_t.naiyo , `hazadomappu_umu_setsumei_t.naiyo.${index}`)}}</span>
                  </div>
                </td>
              </tr>
            </table>
          </draggable>
          <div class="flex justify-end my-2 mr-8" >
              <vs-button class="ml-4" @click="add_biko(hazadomappu_umu_setsumei_inputs)">項目追加 </vs-button>
              <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('hazadomappu_umu_setsumei_inputs', hazadomappu_umu_setsumei_inputs)" class="ml-4 btn-positive">項目削除 </vs-button>
          </div>
        </tr>
      </table>
      <!-- 10. その他 -->
      <table class="table-out" v-if="jrb == 'jrb-01'" :id="`${arrayCommentId[30]}`">
        <tr>
          <div class="part-parent-name p-2">
            <span>10. その他</span>
          </div>
        </tr>
        <tr>
          <table class="ml-4" style="width: 95%">
            <tr>
              <td class="w-1/4">
                <div class="grid">
                  <span class="text-left">「以下余白」の表示</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <vs-checkbox v-model="sonohoka_biko_matsubi_ikayohaku_hyoji1" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">末尾に「以下余白」を表示する</span>
                </div>
              </td>
            </tr>
          </table>
           <table class="ml-4" style="width: 95%">
            <tr>
              <td class="w-1/4">
                <div class="grid">
                  <span class="text-left">黒点／ナンバリング表示</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <vs-checkbox v-model="sonohoka_biko_numbering1" class="inline-flex"></vs-checkbox>
                  <span class="ml-2">黒点／ナンバリングを表示する</span>
                </div>
              </td>
            </tr>
          </table>
        </tr>
        <tr>
          <draggable v-model="takuchi_tatemono_jiko_sonohoka_inputs" handle=".handle">
            <table  class="ml-4" style="width: 95%" v-for="(takuchi_tatemono_jiko_sonohoka_t, index) in takuchi_tatemono_jiko_sonohoka_inputs" :key="`takuchi_tatemono_jiko_sonohoka-${index}`">
              <tr>
                <td class="w-1/4">
                  <div class="flex justify-center items-center">
                    <vs-checkbox v-model="takuchi_tatemono_jiko_sonohoka_t.checkboxDelete">備考 {{index + 1}}</vs-checkbox>
                    <div class="handle pt-3 pl-3 cursor-default w-27">
                      <vx-tooltip text="この入力欄を移動" position="top" delay=".3s">
                        <DragBlackIcon />
                      </vx-tooltip>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="flex items-center">
                    <BunshoTemplate v-model="takuchi_tatemono_jiko_sonohoka_t.naiyo" :screen="bunshoScreen(9)" />
                      <span class="ml-2 m-auto-top-bottom">※備考への表示状況は重要事項説明書レイアウト画面にて確認してください</span>
                  </div>
                  <div class="mr-5">
                    <vs-textarea @blur="focusOut()" @focus="onFocus(`takuchi_tatemono_jiko_sonohoka_t.naiyo.${index}`)" class="mt-2 mb-0" rows="5" maxlength="3000" v-model="takuchi_tatemono_jiko_sonohoka_t.naiyo" />
                    <span class="tooltip-custom" :class="addPadding(`takuchi_tatemono_jiko_sonohoka_t.naiyo.${index}`)">{{showMaxlength( 3000,takuchi_tatemono_jiko_sonohoka_t.naiyo , `takuchi_tatemono_jiko_sonohoka_t.naiyo.${index}`)}}</span>
                  </div>
                </td>
              </tr>
            </table>
          </draggable>
          <div class="flex justify-end my-2 mr-8" >
            <vs-button class="ml-4" @click="add_biko(takuchi_tatemono_jiko_sonohoka_inputs)">項目追加 </vs-button>
            <vs-button color="positive" type="filled" text-color="#7367F0" @click="call_popup_delete_biko('takuchi_tatemono_jiko_sonohoka_inputs', takuchi_tatemono_jiko_sonohoka_inputs)" class="ml-4 btn-positive">項目削除
            </vs-button>
          </div>
        </tr>
      </table>
      </vx-card>

      <footer-button @cancel="popupActiveCancelForm = true" @save="checkSave"></footer-button>

      <!-- Popup Delete  -->
      <vs-popup class="holamundo" title="削除" :active.sync="popupDeleteShikichi_biko" :button-close-hidden="true">
          <p class="my-4 font-bold text-lg">選択された項目を削除します。よろしいですか？</p>
          <div class="flex justify-end">
            <vs-button class="mr-8"  @click="handleDeleteBiko">はい</vs-button>
            <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupDeleteShikichi_biko = false">いいえ</vs-button>
          </div>
      </vs-popup>

      <!-- itaku Dialog  -->
      <vs-popup class="pr-fit-content" title="管理委託先" :active.sync="activeItakuDialog" :button-close-hidden="true"
      oncontextmenu="return false" >
        <div class="con-exemple-prompt" >
          検索結果 （件数: {{itaku_sample_data.data.length}}件）
           <div>
            <vs-pagination :total="pagination.totalPages" :max="7" v-model="pagination.page" @change="onPageChange" :class="pagination.totalPages === 0 ? 'diabled-no-page' : ''"></vs-pagination>
          </div>
         <table class="mt-2 itaku-dialog">
           <tr>
             <th>
               選択
             </th>
             <th>
               会社名
             </th>
             <th>
               会社名かな
             </th>
             <th>
               所在地
             </th>
             <th>
               電話番号
             </th>
             <th>
               登録番号
             </th>
           </tr>
           <tr v-for="(tempt, index) in pagination.data" :key="`itaku-${index}`">
             <td>
               <radio-box @input="lostFocus" vs-name="sentaku" vs-value="tempt.id" @change="selectSentaku(tempt)"> </radio-box>
             </td>
             <td>
               {{tempt.kaishamei}}
             </td>
             <td>
               {{tempt.kaishamei_kana}}
             </td>
             <td>
               {{tempt.shozaichi}}
             </td>
             <td>
               {{tempt.denwabango}}
             </td>
             <td>
               {{tempt.toroku_bango}}
             </td>
           </tr>
         </table>
       </div>
       <div class="flex justify-end py-4 footer-button">
            <vs-button @click="acceptAlert">選択</vs-button>
            <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="activeItakuDialog=false">キャンセル </vs-button>
        </div>
      </vs-popup>

      <!-- Popup Cancel -->
      <vs-popup
        class="holamundo"
        title="キャンセル"
        :active.sync="popupActiveCancelForm"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
          {{messageWhenCancel}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-yes" @click="handleCancelSaveJRB_I5_13"
            >はい</vs-button
          >
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveCancelForm = false"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>

      <!-- Popup Save -->
      <vs-popup
        class="holamundo"
        title="保存"
        :active.sync="popupActiveSaveForm"
        :button-close-hidden="true"
      >
        <p class="my-4 font-bold text-lg">
           {{messageWhenHanei}}
        </p>
        <div class="flex justify-end">
          <vs-button class="mr-8 btn-yes" @click="handleSaveJRBI5_13"
            >はい</vs-button
          >
          <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveSaveForm = false"
            >いいえ</vs-button
          >
        </div>
      </vs-popup>

      <!-- Popup Error -->
      <vs-popup class="holamundo"
                title="保存"
                :active.sync="popupFormError"
                :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          {{globalErrorMessage}}
        </p>
        <div class="flex justify-end">
          <vs-button class="btn-positive btn-yes" color="positive" type="filled" text-color="#7367F0" @click="popupFormError = false">はい</vs-button>
        </div>
      </vs-popup>
    </div>
    <vx-card class="vx-col comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'">
      <Comment @showHightlightInPage="handleShowHightlightInPage" @commentData="getArrayHighlight" :pattern="jrb" :screenCode="screenCode='M007-08'"/>
    </vx-card>
  </div>
</template>

<script>
import DatePickerCustom from '../components/DatePickerCustom.vue'
import BunshoTemplate from './components/BunshoTemplate.vue'
import FooterButton from './components/FooterButton.vue'
import RadioBox from './components/RadioBox.vue'
import hanyo_code from '../jsons-data/hanyo_code.json'
import itaku_sample from '../jsons-data/itaku_sample_data.json'
import json from '@/jsons-data/options.json'
import { SAVE_JRB, SAVE_JRB_M007_08, SAVE_EDIT_MODE, GET_ITAKU, SAVE_KEIYAKU } from '@/store/modules/keiyaku/actions'
import _ from 'lodash'
import { MESSAGE } from '../constant/message_code'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
import Comment from './comment'
import { M007_08_jrb01Highlight, M007_08_jrb02Highlight, M007_08_jrb03_04Highlight } from '../constant/highlight'
import highlighter from '../mixins/highlighter'
import DragBlackIcon from '@/assets/images/icons/DragBlackIcon.vue'
import draggable from 'vuedraggable'

export default {
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  name: 'JRBI-5-13',
  components: {
    DatePickerCustom,
    BunshoTemplate,
    FooterButton,
    RadioBox,
    LeftPreviewSlider,
    DragBlackIcon,
    draggable,
    Comment
  },

  data() {
    return {
      tsunami_disaster_caution: '',
      arrayCommentId: [],
      arrayHighlightId: [],
      isShowComment: true,
      isOpenPreview: true,
      // Validation status
      attentionWaringStatus: false,
      myJson: json,
      globalErrorMessage: MESSAGE.M1023,
      popupFormError: false,
      // Predified Value
      messageWhenCancel: MESSAGE.M1008,
      messageWhenHanei: MESSAGE.M1007,
      hanyo: hanyo_code,
      itaku_sample_data: itaku_sample,
      pagination: {
        totalPages: 0,
        page: 1,
        pageSize: 10,
        data: []
      },
      // data
      kanryojikeijo_kozoto_umusentaku: null,
      shikichi_jissoku_menseki: null,
      shikichi_tokibomenseki : null,
      shikichi_kenchiku_kakunin_menseki: null,
      kenrishurui_shoyuken: false,
      kenrishurui_shakuchiken: false,
      kenrishurui_chijoken: false,
      kenrishurui_chinshaku: false,
      shikichi_taisho_menseki: null,
      shikichi_tokibo_jissoku_kubun: null,
      shikichi_shakuchiken_sonzokukikan_nengappi: '',
      shikichi_shakuchiken_sonzokukikan_nengappi_checkbox: false,
      shikichi_kingaku: null,

      kyoyobubun_kyoyo_bubun: null,
      kyoyobubun_hani: '',
      kyoyobubun_kanri_kiyaku: '',
      kyoyobubun_kubun_sentaku: '',
      kyoyobubun_kubun_kisai: '',
      kyoyobubun_mochibunwariai_jorei: '',
      yotoseigen_yotoseigen: null,
      yotoseigen_seigen_naiyo: '',
      yotoseigen_kanrikiyaku: '',
      yotoseigen_shiyosaisoku: '',
      pettoseigen_yotoseigen: null,
      pettoseigen_seigen_naiyo: '',
      pettoseigen_kanrikiyaku: '',
      pettoseigen_shiyosaisoku: '',
      furoringuseigen_yotoseigen: null,
      furoringuseigen_seigen_naiyo: '',
      furoringuseigen_kanrikiyaku: '',
      furoringuseigen_shiyosaisoku: '',
      gakkishiyo_yotoseigen: null,
      gakkishiyo_seigen_naiyo: '',
      gakkishiyo_kanrikiyaku: '',
      gakkishiyo_shiyosaisoku: '',

      hosoku_kanrikiyaku: '',
      hosoku_shiyosaisoku: '',
      barukoni_umusentaku: null,
      barukoni_kubun_shoyusha: '',
      barukoni_kizokusaki_umusentaku: null,
      barukoni_senyoshiyoryo_kizokusaki_kubun: null,
      barukoni_sakikubun_setsumei: '',
      barukoni_biko: '',
      barukoni_biko2: '',
      madonado_umusentaku: null,
      madonado_kubun_shoyusha: '',
      madonado_kizokusaki_umusentaku: null,
      madonado_senyoshiyoryo_kizokusaki_kubun: null,
      madonado_sakikubun_setsumei: '',
      madonado_biko: '',
      madonado_biko2: '',
      senyotei_umusentaku: null,
      senyotei_kubun_shoyusha: '',
      senyotei_kizokusaki_umusentaku: null,
      senyotei_senyoshiyoryo_kizokusaki_kubun: null,
      senyotei_sakikubun_setsumei: '',
      senyotei_biko: '',
      senyotei_biko2: '',
      rufubarukoni_umusentaku: null,
      rufubarukoni_kubun_shoyusha: '',
      rufubarukoni_kizokusaki_umusentaku: null,
      rufubarukoni_senyoshiyoryo_kizokusaki_kubun: null,
      rufubarukoni_sakikubun_setsumei: '',
      rufubarukoni_biko: '',
      rufubarukoni_biko2: '',
      torankurumu_umusentaku: null,
      torankurumu_kubun_shoyusha: '',
      torankurumu_kizokusaki_umusentaku: null,
      torankurumu_senyoshiyoryo_kizokusaki_kubun: null,
      torankurumu_sakikubun_setsumei: '',
      torankurumu_biko: '',
      torankurumu_biko2: '',
      chushajo_umusentaku: null,
      chushajo_kubun_shoyusha: '',
      chushajo_kizokusaki_umusentaku: null,
      chushajo_senyoshiyoryo_kizokusaki_kubun: null,
      chushajo_sakikubun_setsumei: '',
      chushajo_biko: '',
      chushajo_biko2: '',
      churinjo_umusentaku: null,
      churinjo_kubun_shoyusha: '',
      churinjo_kizokusaki_umusentaku: null,
      churinjo_senyoshiyoryo_kizokusaki_kubun: null,
      churinjo_sakikubun_setsumei: '',
      churinjo_biko: '',
      churinjo_biko2: '',
      komoku1_meisho: null,
      komoku1_kubun_shoyusha: '',
      komoku1_kizokusaki_umusentaku: null,
      komoku1_senyoshiyoryo_kizokusaki_kubun: null,
      komoku1_sakikubun_setsumei: '',
      komoku1_biko: '',
      komoku2_meisho: null,
      komoku2_kubun_shoyusha: '',
      komoku2_kizokusaki_umusentaku: null,
      komoku2_senyoshiyoryo_kizokusaki_kubun: null,
      komoku2_sakikubun_setsumei: '',
      komoku2_biko: '',
      fuzuisenyo_barukoni_naiyo: '',
      fuzuisenyo_madonado_naiyo: '',
      genmenkiyaku_umusentaku: null,
      futangenmen_kanri_kiyakumei: '',
      futangenmen_kanri_kiyakujo_bango: '',
      genmenkiyaku_kiyaku_sadame_gaiyo: '',
      shuzentsumitatekin_umusentaku: null,
      shuzentsumitatekin_kanrikiyaku_joreimei: '',
      shuzentsumitatekin_kanrikiyaku_joreibango: '',
      shuzentsumitatekin_kingaku: null,
      shuzentsumitatekin_shuzen_tsumitatekin_nengappi: '', // date
      shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox: false,
      shuzentsumitatekin_hosoku: '',
      shuzentsumitatekin_taino_umu: null,
      shuzentsumitatekin_tainokingaku: null,
      shuzentsumitatekin_taino_nengappi: '', // date
      shuzentsumitatekin_taino_nengappi_checkbox: null,
      shuzentsumitatekin_tsumitategaku_kingaku: null,
      shuzentsumitatekin_tsumitategaku_nengappi: '', // date
      shuzentsumitatekin_tsumitategaku_nengappi_checkbox: null,
      shuzentsumitatekin_tsumitategaku_umusentaku: null,
      shuzentsumitatekin_tsumitategaku_tainogaku_kingaku: null,
      shuzentsumitatekin_tsumitategaku_nengappi2: '', // date
      shuzentsumitatekin_tsumitategaku_nengappi2_checkbox: null,
      kanrihi_kingaku: null,
      kanrihi_nengappi: '', // date
      kanrihi_nengappi_checkbox: null,
      kanrihi_hosoku: '',
      kanrihi_tainoumu: null,
      kanrihi_tainokingaku: null,
      kanrihi_taino_nengappi: '', // date
      kanrihi_taino_nengappi_checkbox: null,
      kanrihi_taino_johokaiji_umu: null,
      kanrihi_taino_johokaiji_tainogaku: null,
      kanrihi_taino_johokaiji_taino_nengappi: '', // date
      kanrihi_taino_johokaiji_taino_nengappi_checkbox: null,
      kanrikumiai_meisho: '',
      kanri_keitai: null,
      kanriitakusaki_meisho: '',
      kanriitakusaki_tenwabango: '',
      kanriitakusaki_tenwabango2: '',
      kanriitakusaki_tenwabango3: '',
      kanriitakusaki_shozai: '',
      kanriitakusaki_manshonkanritekiseikaho_toroku_bango: '',
      kyoyobubun_umusentaku: null,
      kyoyobubun_jisshijokyo: '',
      senyububun_umusentaku: null,
      senyububun_jisshijokyo: '',

      jokyochosa_gaito_umu: null,
      jokyochosa_jisshi_umu: null,
      tatemono_ijihozen_gaitokubun: null,
      kakunin_shinseisho_hozonumu1: null,
      kakuninzumisho_hozonumu2: null,
      kensazumisho_hozonumu3: null,
      zokaichiku_sentaku: null,
      kakunin_shinseisho_hozonumu4: null,
      kakuninzumisho_hozonumu5: null,
      kensazumisho_hozonumu6: null,
      tatemono_jokyochosa_jisshi_jutakudearu_baai: null,
      tatemono_jokyochosa_hokokusho_hozonumu: null,
      kenchiku_kijunhodai_12jo_sentaku: null,
      teikichosa_teikihokokusho_hozonumu: null,
      kizonjutaku_seino_hyoka_sentaku: null,
      kizonjutaku_seino_hyokasho_hozonumu: null,
      shinchiku_koji_chaku_tatemonodearubaai_kubun: null,
      kizonjutaku_seinohyokasho_umu: null,
      taishinshindan_kekka_hokokusho_hozonumu: null,
      shintaishinkijun_tekigosei_hozonumu: null,
      kashihoken_hozonumu: null,
      taishinkijuntekigoshomeish_hozonumu: null,
      sonohoka_nyuryoku: '',
      sonohoka_hozonumu: null,
      kakuninzumisho_umusentaku: null, // boolean
      kakuninzumisho_nengappi: '', // date
      kakuninzumisho_nengappi_checkbox: null,
      kakuninzumisho_bango: '',
      kensazumisho_umusentaku: null, // boolean
      kensazumisho_nengappi: '', // date
      kensazumisho_nengappi_checkbox: null,
      kensazumisho_bango: '',
      jutakuseinohyoka_uketa_shinchiku_sentaku: null,
      sekkeijutaku_seino_hyokasho_umu: null,
      kensetsujutaku_seino_hyokasho_umu: null,
      ishiwatashiyo_chosa_umu_sentaku: null,
      zoseitakuchi_kuiki_sentaku: null,
      doshasaigai_kuiki_sentaku: null,
      tsunami_kuiki_sentaku: null,
      hazadomappu_umu_kozui: null,
      hazadomappu_umu_usuishussui: null,
      hazadomappu_umu_takashio: null,
      // Array Inputs
      deleteArrayObjectName: '',
      // shikichi_biko
      shikichi_biko_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // kyoyobubun_biko
      kyoyobubun_biko_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // senyububun_biko1
      senyububun_biko1_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // senyoshiyoken_biko1
      senyoshiyoken_biko1_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // senyububun_biko2
      senyububun_biko2_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // sonohoka_biko
      sonohoka_biko_inputs: [
        {
          checkboxDelete: false,
          naiyo: '「建物の区分所有等に関する法律」の規定および管理規約・使用細則等により当該建物・敷地・付属施設の管理・使用方法等が定められていますので、買主はそれを売主から継承し遵守しなければなりません。'
        }, {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // takuchi_tatemono_jiko_sonohoka
      takuchi_tatemono_jiko_sonohoka_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // jokyochosa_naiyo
      jokyochosa_naiyo_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // taishinshindan_kekka_hokokusho_biko
      taishinshindan_kekka_hokokusho_biko_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // kenchiku_kakuninzumisho_biko
      kenchiku_kakuninzumisho_biko_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // hazadomappu_umu_setsumei
      hazadomappu_umu_setsumei_inputs: [
        {
          checkboxDelete: false,
          naiyo: ''
        }
      ],
      // senyoshiyoken
      senyoshiyoken_inputs: [
        {
          checkboxDelete: false,
          meisho: '',
          umusentaku: null,
          kubun_shoyusha: '',
          kizokusaki_umusentaku: null,
          senyoshiyoryo_kizokusaki_kubun: null,
          sakikubun_setsumei: '',
          biko: '',
          biko2: ''
        }
      ],
      // fuzuisenyo_shiyoken
      fuzuisenyo_shiyoken_inputs:[
        {
          checkboxDelete: false,
          meisho: '',
          naiyo: ''
        }
      ],
      // Combobox
      nengo_combobox: [],
      // Dialog
      activeItakuDialog: false,
      selected_sentaku: null,
      // Popup Hanei And Cancel
      popupDeleteShikichi_biko: false,
      popupActiveCancelForm: false,
      popupActiveSaveForm: false,
      checkValidate: false,

      formValidation: {
        kanryojikeijo_kozoto_umusentaku: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        shikichi_tokibomenseki: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        shikichi_kenchiku_kakunin_menseki: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_kyoyo_bubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_hani: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kyoyobubun_kyoyo_bubun === '1' && !this.kyoyobubun_hani
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_kanri_kiyaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kyoyobubun_kyoyo_bubun === '1' && !this.kyoyobubun_kanri_kiyaku
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_kubun_sentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kyoyobubun_kyoyo_bubun === '1' && !this.kyoyobubun_kubun_sentaku
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_mochibunwariai_jorei: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kyoyobubun_kyoyo_bubun === '1' && !this.kyoyobubun_mochibunwariai_jorei
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_kubun_kisai: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kyoyobubun_kubun_sentaku === '1' && (this.kyoyobubun_kubun_kisai === null || this.kyoyobubun_kubun_kisai === undefined || this.kyoyobubun_kubun_kisai === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        yotoseigen_yotoseigen: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        yotoseigen_seigen_naiyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.yotoseigen_yotoseigen === '1' && (this.yotoseigen_seigen_naiyo === null || this.yotoseigen_seigen_naiyo === undefined || this.yotoseigen_seigen_naiyo === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        yotoseigen_kanrikiyaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.yotoseigen_yotoseigen === '1' && (this.yotoseigen_kanrikiyaku === null || this.yotoseigen_kanrikiyaku === undefined || this.yotoseigen_kanrikiyaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        yotoseigen_shiyosaisoku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.yotoseigen_yotoseigen === '1' && (this.yotoseigen_shiyosaisoku === null || this.yotoseigen_shiyosaisoku === undefined || this.yotoseigen_shiyosaisoku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        pettoseigen_yotoseigen: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        pettoseigen_seigen_naiyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.pettoseigen_yotoseigen === '1' && (!this.pettoseigen_seigen_naiyo || !String(this.pettoseigen_seigen_naiyo).trim())
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        pettoseigen_kanrikiyaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.pettoseigen_yotoseigen === '1' && (this.pettoseigen_kanrikiyaku === null || this.pettoseigen_kanrikiyaku === undefined || this.pettoseigen_kanrikiyaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        pettoseigen_shiyosaisoku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.pettoseigen_yotoseigen === '1' && (this.pettoseigen_shiyosaisoku === null || this.pettoseigen_shiyosaisoku === undefined || this.pettoseigen_shiyosaisoku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        furoringuseigen_yotoseigen: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        furoringuseigen_seigen_naiyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.furoringuseigen_yotoseigen === '1' && (this.furoringuseigen_seigen_naiyo === null || this.furoringuseigen_seigen_naiyo === undefined || this.furoringuseigen_seigen_naiyo === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        furoringuseigen_kanrikiyaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.furoringuseigen_yotoseigen === '1' && (this.furoringuseigen_kanrikiyaku === null || this.furoringuseigen_kanrikiyaku === undefined || this.furoringuseigen_kanrikiyaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        furoringuseigen_shiyosaisoku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.furoringuseigen_yotoseigen === '1' && (this.furoringuseigen_shiyosaisoku === null || this.furoringuseigen_shiyosaisoku === undefined || this.furoringuseigen_shiyosaisoku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        gakkishiyo_yotoseigen: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        gakkishiyo_seigen_naiyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.gakkishiyo_yotoseigen === '1' && (this.gakkishiyo_seigen_naiyo === null || this.gakkishiyo_seigen_naiyo === undefined || this.gakkishiyo_seigen_naiyo === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        gakkishiyo_kanrikiyaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.gakkishiyo_yotoseigen === '1' && (this.gakkishiyo_kanrikiyaku === null || this.gakkishiyo_kanrikiyaku === undefined || this.gakkishiyo_kanrikiyaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        gakkishiyo_shiyosaisoku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.gakkishiyo_yotoseigen === '1' && (this.gakkishiyo_shiyosaisoku === null || this.gakkishiyo_shiyosaisoku === undefined || this.gakkishiyo_shiyosaisoku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        hosoku_kanrikiyaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        hosoku_shiyosaisoku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        barukoni_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        barukoni_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.barukoni_umusentaku === '1' && (this.barukoni_kizokusaki_umusentaku === null || this.barukoni_kizokusaki_umusentaku === undefined || this.barukoni_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        barukoni_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.barukoni_kizokusaki_umusentaku === '1' && (this.barukoni_senyoshiyoryo_kizokusaki_kubun === null || this.barukoni_senyoshiyoryo_kizokusaki_kubun === undefined || this.barukoni_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        madonado_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        madonado_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.madonado_umusentaku === '1' && (this.madonado_kizokusaki_umusentaku === null || this.madonado_kizokusaki_umusentaku === undefined || this.madonado_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        madonado_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.madonado_kizokusaki_umusentaku === '1' && (this.madonado_senyoshiyoryo_kizokusaki_kubun === null || this.madonado_senyoshiyoryo_kizokusaki_kubun === undefined || this.madonado_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        senyotei_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        senyotei_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.senyotei_umusentaku === '1' && (this.senyotei_kizokusaki_umusentaku === null || this.senyotei_kizokusaki_umusentaku === undefined || this.senyotei_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        senyotei_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.senyotei_kizokusaki_umusentaku === '1' && (this.senyotei_senyoshiyoryo_kizokusaki_kubun === null || this.senyotei_senyoshiyoryo_kizokusaki_kubun === undefined || this.senyotei_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        rufubarukoni_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        rufubarukoni_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.rufubarukoni_umusentaku === '1' && (this.rufubarukoni_kizokusaki_umusentaku === null || this.rufubarukoni_kizokusaki_umusentaku === undefined || this.rufubarukoni_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        rufubarukoni_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.rufubarukoni_kizokusaki_umusentaku === '1' && (this.rufubarukoni_senyoshiyoryo_kizokusaki_kubun === null || this.rufubarukoni_senyoshiyoryo_kizokusaki_kubun === undefined || this.rufubarukoni_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        torankurumu_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        torankurumu_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.torankurumu_umusentaku === '1' && (this.torankurumu_kizokusaki_umusentaku === null || this.torankurumu_kizokusaki_umusentaku === undefined || this.torankurumu_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        torankurumu_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.torankurumu_kizokusaki_umusentaku === '1' && (this.torankurumu_senyoshiyoryo_kizokusaki_kubun === null || this.torankurumu_senyoshiyoryo_kizokusaki_kubun === undefined || this.torankurumu_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        chushajo_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        chushajo_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.chushajo_umusentaku === '1' && (this.chushajo_kizokusaki_umusentaku === null || this.chushajo_kizokusaki_umusentaku === undefined || this.chushajo_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        chushajo_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.chushajo_kizokusaki_umusentaku === '1' && (this.chushajo_senyoshiyoryo_kizokusaki_kubun === null || this.chushajo_senyoshiyoryo_kizokusaki_kubun === undefined || this.chushajo_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        churinjo_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        churinjo_kizokusaki_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.churinjo_umusentaku === '1' && (this.churinjo_kizokusaki_umusentaku === null || this.churinjo_kizokusaki_umusentaku === undefined || this.churinjo_kizokusaki_umusentaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        churinjo_senyoshiyoryo_kizokusaki_kubun: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.churinjo_kizokusaki_umusentaku === '1' && (this.churinjo_senyoshiyoryo_kizokusaki_kubun === null || this.churinjo_senyoshiyoryo_kizokusaki_kubun === undefined || this.churinjo_senyoshiyoryo_kizokusaki_kubun === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        fuzuisenyo_barukoni_naiyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        fuzuisenyo_madonado_naiyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        genmenkiyaku_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        // 1 2 shuzentsumitatekin_umusentaku 
        shuzentsumitatekin_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: !this.shuzentsumitatekin_umusentaku,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        // 3 shuzentsumitatekin_kanrikiyaku_joreimei
        shuzentsumitatekin_kanrikiyaku_joreimei: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shuzentsumitatekin_umusentaku === '1' && (this.shuzentsumitatekin_kanrikiyaku_joreimei === null || this.shuzentsumitatekin_kanrikiyaku_joreimei === undefined || this.shuzentsumitatekin_kanrikiyaku_joreimei === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        //  5 shuzentsumitatekin_kingaku
        shuzentsumitatekin_kingaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shuzentsumitatekin_umusentaku === '1' && (this.shuzentsumitatekin_kingaku === null || this.shuzentsumitatekin_kingaku === undefined || this.shuzentsumitatekin_kingaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        // 6 shuzentsumitatekin_shuzen_tsumitatekin_nengappi
        shuzentsumitatekin_shuzen_tsumitatekin_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          warning: () => {
            return String(this.shuzentsumitatekin_umusentaku) === '1' && !this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => {
            return this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi && !this.isValidDate(this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi)
          }
        },

        // 7 8 shuzentsumitatekin_taino_umu
        shuzentsumitatekin_taino_umu: {
          patterns:['jrb-03', 'jrb-04'],
          warning: () => {
            return !this.shuzentsumitatekin_taino_umu === '0' || !this.shuzentsumitatekin_taino_umu === '1'
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        // 9 shuzentsumitatekin_tainokingaku
        shuzentsumitatekin_tainokingaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shuzentsumitatekin_taino_umu === '1' && (this.shuzentsumitatekin_tainokingaku === null || this.shuzentsumitatekin_tainokingaku === undefined || this.shuzentsumitatekin_tainokingaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        // 10 shuzentsumitatekin_taino_nengappi
        shuzentsumitatekin_taino_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          warning: () => {
            return String(this.shuzentsumitatekin_taino_umu) === '1' && !this.shuzentsumitatekin_taino_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => {
            return this.shuzentsumitatekin_taino_nengappi && !this.isValidDate(this.shuzentsumitatekin_taino_nengappi)
          } 
        },

        // 11 shuzentsumitatekin_tsumitategaku_kingaku
        shuzentsumitatekin_tsumitategaku_kingaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shuzentsumitatekin_umusentaku === '1' && (this.shuzentsumitatekin_tsumitategaku_kingaku === null || this.shuzentsumitatekin_tsumitategaku_kingaku === undefined || this.shuzentsumitatekin_tsumitategaku_kingaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        
        // 12 shuzentsumitatekin_tsumitategaku_nengappi
        shuzentsumitatekin_tsumitategaku_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          attentionWarning: false,
          warning: () => {
            return String(this.shuzentsumitatekin_umusentaku) === '1' && !this.shuzentsumitatekin_tsumitategaku_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.shuzentsumitatekin_tsumitategaku_nengappi && !this.isValidDate(this.shuzentsumitatekin_tsumitategaku_nengappi)
        },

        // 13 14 shuzentsumitatekin_tsumitategaku_umusentaku
        shuzentsumitatekin_tsumitategaku_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return  !this.shuzentsumitatekin_tsumitategaku_umusentaku === '0' && !this.shuzentsumitatekin_tsumitategaku_umusentaku === '1'
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        // 15 shuzentsumitatekin_tsumitategaku_tainogaku_kingaku
        shuzentsumitatekin_tsumitategaku_tainogaku_kingaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shuzentsumitatekin_umusentaku === '0' && this.shuzentsumitatekin_tsumitategaku_umusentaku === '0' && (this.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku === null || this.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku === undefined || this.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },

        // 16 shuzentsumitatekin_tsumitategaku_nengappi2
        shuzentsumitatekin_tsumitategaku_nengappi2: {
          patterns:['jrb-03', 'jrb-04'],
          warning: () => {
            return String(this.shuzentsumitatekin_umusentaku) === '0' && !this.shuzentsumitatekin_tsumitategaku_nengappi2
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.shuzentsumitatekin_tsumitategaku_nengappi2 && !this.isValidDate(this.shuzentsumitatekin_tsumitategaku_nengappi2)
        },

        kanrihi_kingaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanrihi_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.kanrihi_nengappi && !this.isValidDate(this.kanrihi_nengappi)
        },
        kanrihi_tainoumu: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanrihi_tainokingaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kanrihi_tainoumu === '1' && (this.kanrihi_tainokingaku === null || this.kanrihi_tainokingaku === undefined || this.kanrihi_tainokingaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanrihi_taino_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          warning: () => {
            return String(this.kanrihi_tainoumu) === '1' && !this.kanrihi_taino_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.kanrihi_taino_nengappi && !this.isValidDate(this.kanrihi_taino_nengappi)
        },
        kanrihi_taino_johokaiji_umu: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanrihi_taino_johokaiji_tainogaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kanrihi_taino_johokaiji_umu === '1' && (this.kanrihi_taino_johokaiji_tainogaku === null || this.kanrihi_taino_johokaiji_tainogaku === undefined || this.kanrihi_taino_johokaiji_tainogaku === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanrihi_taino_johokaiji_taino_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          attentionWarning: false,
          warning: () => {
            return String(this.kanrihi_taino_johokaiji_umu) === '1' && !this.kanrihi_taino_johokaiji_taino_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.kanrihi_taino_johokaiji_taino_nengappi && !this.isValidDate(this.kanrihi_taino_johokaiji_taino_nengappi)
        },
        kanrikumiai_meisho: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanri_keitai: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanriitakusaki_meisho: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanriitakusaki_tenwabango: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        // kanriitakusaki_tenwabango2: {
        //   patterns:['jrb-03', 'jrb-04'],
        //   warning: true,
        //   warningMsg : MESSAGE.E8051,
        //   isWarning: false
        // },
        // kanriitakusaki_tenwabango3: {
        //   patterns:['jrb-03', 'jrb-04'],
        //   warning: true,
        //   warningMsg : MESSAGE.E8051,
        //   isWarning: false
        // },
        kanriitakusaki_shozai: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kanriitakusaki_manshonkanritekiseikaho_toroku_bango: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kyoyobubun_jisshijokyo: {
          patterns:['jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kyoyobubun_umusentaku === '1' && (this.kyoyobubun_jisshijokyo === null || this.kyoyobubun_jisshijokyo === undefined || this.kyoyobubun_jisshijokyo === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        senyububun_umusentaku: {
          patterns:['jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        senyububun_jisshijokyo: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.senyububun_umusentaku === '1' && (this.senyububun_jisshijokyo === null || this.senyububun_jisshijokyo === undefined || this.senyububun_jisshijokyo === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        jokyochosa_gaito_umu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        jokyochosa_jisshi_umu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          warning: () => {
            return this.jokyochosa_gaito_umu === '1' && this.jokyochosa_jisshi_umu === null
          }
        },
        tatemono_ijihozen_gaitokubun: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kakunin_shinseisho_hozonumu1: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && (this.kakunin_shinseisho_hozonumu1 === null || this.kakunin_shinseisho_hozonumu1 === undefined || this.kakunin_shinseisho_hozonumu1 === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kakuninzumisho_hozonumu2: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && (this.kakuninzumisho_hozonumu2 === null || this.kakuninzumisho_hozonumu2 === undefined || this.kakuninzumisho_hozonumu2 === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kensazumisho_hozonumu3: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && (this.kensazumisho_hozonumu3 === null || this.kensazumisho_hozonumu3 === undefined || this.kensazumisho_hozonumu3 === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        zokaichiku_sentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && !this.zokaichiku_sentaku 
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kakunin_shinseisho_hozonumu4: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.zokaichiku_sentaku === '0' && (this.kakunin_shinseisho_hozonumu4 === null || this.kakunin_shinseisho_hozonumu4 === undefined || this.kakunin_shinseisho_hozonumu4 === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kakuninzumisho_hozonumu5: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.zokaichiku_sentaku === '0' && (this.kakuninzumisho_hozonumu5 === null || this.kakuninzumisho_hozonumu5 === undefined || this.kakuninzumisho_hozonumu5 === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kensazumisho_hozonumu6: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.zokaichiku_sentaku === '0' && (this.kensazumisho_hozonumu6 === null || this.kensazumisho_hozonumu6 === undefined || this.kensazumisho_hozonumu6 === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        tatemono_jokyochosa_jisshi_jutakudearu_baai: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && !this.tatemono_jokyochosa_jisshi_jutakudearu_baai 
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        tatemono_jokyochosa_hokokusho_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_jokyochosa_jisshi_jutakudearu_baai === '0' && (this.tatemono_jokyochosa_hokokusho_hozonumu === null || this.tatemono_jokyochosa_hokokusho_hozonumu === undefined || this.tatemono_jokyochosa_hokokusho_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kenchiku_kijunhodai_12jo_sentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && !this.kenchiku_kijunhodai_12jo_sentaku 
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        teikichosa_teikihokokusho_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kenchiku_kijunhodai_12jo_sentaku === '0' && (this.teikichosa_teikihokokusho_hozonumu === null || this.teikichosa_teikihokokusho_hozonumu === undefined || this.teikichosa_teikihokokusho_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kizonjutaku_seino_hyoka_sentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && !this.kizonjutaku_seino_hyoka_sentaku 
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kizonjutaku_seino_hyokasho_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.kizonjutaku_seino_hyoka_sentaku === '0' && (this.kizonjutaku_seino_hyokasho_hozonumu === null || this.kizonjutaku_seino_hyokasho_hozonumu === undefined || this.kizonjutaku_seino_hyokasho_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        shinchiku_koji_chaku_tatemonodearubaai_kubun: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.tatemono_ijihozen_gaitokubun === '1' && !this.shinchiku_koji_chaku_tatemonodearubaai_kubun 
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kizonjutaku_seinohyokasho_umu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '1' && (this.kizonjutaku_seinohyokasho_umu === null || this.kizonjutaku_seinohyokasho_umu === undefined || this.kizonjutaku_seinohyokasho_umu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        taishinshindan_kekka_hokokusho_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '1' && (this.taishinshindan_kekka_hokokusho_hozonumu === null || this.taishinshindan_kekka_hokokusho_hozonumu === undefined || this.taishinshindan_kekka_hokokusho_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        shintaishinkijun_tekigosei_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '1' && (this.shintaishinkijun_tekigosei_hozonumu === null || this.shintaishinkijun_tekigosei_hozonumu === undefined || this.shintaishinkijun_tekigosei_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kashihoken_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '1' && (this.kashihoken_hozonumu === null || this.kashihoken_hozonumu === undefined || this.kashihoken_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        taishinkijuntekigoshomeish_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '1' && (this.taishinkijuntekigoshomeish_hozonumu === null || this.taishinkijuntekigoshomeish_hozonumu === undefined || this.taishinkijuntekigoshomeish_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        sonohoka_hozonumu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '1' && (this.sonohoka_hozonumu === null || this.sonohoka_hozonumu === undefined || this.sonohoka_hozonumu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kakuninzumisho_umusentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          warning: false
        },
        kensazumisho_umusentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          warning: false
        },
        kakuninzumisho_nengappi: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning: () => {
            return !this.kakuninzumisho_umusentaku && !this.kakuninzumisho_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => {
            return this.kakuninzumisho_nengappi && !this.isValidDate(this.kakuninzumisho_nengappi)
          }
        },
        kakuninzumisho_bango: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return !this.kakuninzumisho_umusentaku && !this.kakuninzumisho_bango
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kensazumisho_nengappi: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          attentionWarning: false,
          warning: () => {
            return !this.kensazumisho_umusentaku && !this.kensazumisho_nengappi
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.kensazumisho_nengappi && !this.isValidDate(this.kensazumisho_nengappi)
        },
        kensazumisho_bango: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return !this.kensazumisho_umusentaku && !this.kensazumisho_bango
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        jutakuseinohyoka_uketa_shinchiku_sentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        sekkeijutaku_seino_hyokasho_umu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.jutakuseinohyoka_uketa_shinchiku_sentaku === '0' && (this.sekkeijutaku_seino_hyokasho_umu === null || this.sekkeijutaku_seino_hyokasho_umu === undefined || this.sekkeijutaku_seino_hyokasho_umu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        kensetsujutaku_seino_hyokasho_umu: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning:  () => {
            return this.jutakuseinohyoka_uketa_shinchiku_sentaku === '0' && (this.kensetsujutaku_seino_hyokasho_umu === null || this.kensetsujutaku_seino_hyokasho_umu === undefined || this.kensetsujutaku_seino_hyokasho_umu === '')
          },
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        ishiwatashiyo_chosa_umu_sentaku: {
          patterns:['jrb-02', 'jrb-03', 'jrb-04'],
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        zoseitakuchi_kuiki_sentaku: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        doshasaigai_kuiki_sentaku: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        tsunami_kuiki_sentaku: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        hazadomappu_umu_kozui: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        hazadomappu_umu_usuishussui: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        },
        hazadomappu_umu_takashio: {
          warning: true,
          warningMsg : MESSAGE.E8051,
          isWarning: false
        }, 
        shikichi_shakuchiken_sonzokukikan_nengappi: {
          patterns:['jrb-03', 'jrb-04'],
          warningMsg: MESSAGE.W4001,
          isWarning: false,
          warning: false,
          errorMsg: MESSAGE.E8066,
          isError: false,
          error: () => this.shikichi_shakuchiken_sonzokukikan_nengappi && !this.isValidDate(this.shikichi_shakuchiken_sonzokukikan_nengappi)
        }
      },
      senyoshiyokenFormValidation: [],
      fuzuisenyoShiyokenFormValidation: [],

      jokyochosa_naiyo_matsubi_ikayohaku_hyoji: true,
      jokyochosa_naiyo_numbering: true,
      taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji: true,
      taishinshindan_kekka_hokokusho_biko_numbering: true,
      kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji: true,
      kenchiku_kakuninzumisho_biko_numbering: true,
      hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji: true,
      hazadomappu_umu_setsumei_numbering: true,
      shikichi_biko_matsubi_ikayohaku_hyoji: true,
      shikichi_biko_numbering: true,
      kyoyobubun_biko_matsubi_ikayohaku_hyoji: true,
      kyoyobubun_biko_numbering: true,
      senyububun_biko1_matsubi_ikayohaku_hyoji: true,
      senyububun_biko1_numbering: true,
      senyoshiyoken_biko1_matsubi_ikayohaku_hyoji: true,
      senyoshiyoken_biko1_numbering: true,
      senyububun_biko2_matsubi_ikayohaku_hyoji: true,
      senyububun_biko2_numbering: true,
      sonohoka_biko_matsubi_ikayohaku_hyoji1: true,
      sonohoka_biko_numbering1: true,
      sonohoka_biko_matsubi_ikayohaku_hyoji2: true,
      sonohoka_biko_numbering2: true
    }
  },
  computed: {
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    // get JRB Pattern
    jrb() {
      try {
        return this.$store.getters.pattern.jusetsu.jrb
      } catch (e) {
        return null
      }
    },
    jrbi5to13Data() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_08', null))
    },
    // validate if Sentaku is selected
    validItakuSentaku() {
      return (this.selected_sentaku !== null)
    },
    shikichi_biko() {
      return this.shikichi_biko_inputs.map(element => element.naiyo)
    },
    kyoyobubun_biko() {
      return this.kyoyobubun_biko_inputs.map(element => element.naiyo)
    },
    senyububun_biko1() {
      return this.senyububun_biko1_inputs.map(element => element.naiyo)
    },
    senyoshiyoken() {
      return this.senyoshiyoken_inputs.map(function (element) {
        return {
          meisho: element.meisho,
          umusentaku: element.umusentaku,
          kubun_shoyusha: element.kubun_shoyusha,
          kizokusaki_umusentaku: element.kizokusaki_umusentaku,
          senyoshiyoryo_kizokusaki_kubun: element.senyoshiyoryo_kizokusaki_kubun,
          sakikubun_setsumei: element.sakikubun_setsumei,
          biko: element.biko,
          biko2: element.biko2
        }
      })
    },
    fuzuisenyo_shiyoken() {
      return this.fuzuisenyo_shiyoken_inputs.map(function(element) {
        return {
          meisho: element.meisho,
          naiyo: element.naiyo
        }
      })
    },
    senyoshiyoken_biko1() {
      return this.senyoshiyoken_biko1_inputs.map(element => element.naiyo)
    },
    senyububun_biko2() {
      return this.senyububun_biko2_inputs.map(element => element.naiyo)
    },
    sonohoka_biko() {
      return this.sonohoka_biko_inputs.map(element => element.naiyo)
    },
    takuchi_tatemono_jiko_sonohoka() {
      return this.takuchi_tatemono_jiko_sonohoka_inputs.map(element => element.naiyo)
    },
    jokyochosa_naiyo() {
      return this.jokyochosa_naiyo_inputs.map(element => element.naiyo)
    },
    taishinshindan_kekka_hokokusho_biko() {
      return this.taishinshindan_kekka_hokokusho_biko_inputs.map(element => element.naiyo)
    },
    kenchiku_kakuninzumisho_biko() {
      return this.kenchiku_kakuninzumisho_biko_inputs.map(element => element.naiyo)
    },
    hazadomappu_umu_setsumei() {
      return this.hazadomappu_umu_setsumei_inputs.map(element => element.naiyo)
    }
  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    //get itaku data
    this.getItakuData()
    // get value for combobox Nengo
    this.nengo_combobox = this.myJson._300.values
    // Get data from Local storage
    if(this.jrbi5to13Data !== null) {
      const jrb_i5_13 = this.jrbi5to13Data

      this.jokyochosa_naiyo_matsubi_ikayohaku_hyoji = jrb_i5_13.jokyochosa_naiyo_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.jokyochosa_naiyo_matsubi_ikayohaku_hyoji
      this.jokyochosa_naiyo_numbering = jrb_i5_13.jokyochosa_naiyo_numbering === undefined ? true : jrb_i5_13.jokyochosa_naiyo_numbering
      this.taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji = jrb_i5_13.taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji
      this.taishinshindan_kekka_hokokusho_biko_numbering = jrb_i5_13.taishinshindan_kekka_hokokusho_biko_numbering === undefined ? true : jrb_i5_13.taishinshindan_kekka_hokokusho_biko_numbering
      this.kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji = jrb_i5_13.kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji
      this.kenchiku_kakuninzumisho_biko_numbering = jrb_i5_13.kenchiku_kakuninzumisho_biko_numbering === undefined ? true : jrb_i5_13.kenchiku_kakuninzumisho_biko_numbering
      this.hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji = jrb_i5_13.hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji
      this.hazadomappu_umu_setsumei_numbering = jrb_i5_13.hazadomappu_umu_setsumei_numbering === undefined ? true : jrb_i5_13.hazadomappu_umu_setsumei_numbering
      this.shikichi_biko_matsubi_ikayohaku_hyoji = jrb_i5_13.shikichi_biko_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.shikichi_biko_matsubi_ikayohaku_hyoji
      this.shikichi_biko_numbering = jrb_i5_13.shikichi_biko_numbering === undefined ? true : jrb_i5_13.shikichi_biko_numbering
      this.kyoyobubun_biko_matsubi_ikayohaku_hyoji = jrb_i5_13.kyoyobubun_biko_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.kyoyobubun_biko_matsubi_ikayohaku_hyoji
      this.kyoyobubun_biko_numbering = jrb_i5_13.kyoyobubun_biko_numbering === undefined ? true : jrb_i5_13.kyoyobubun_biko_numbering
      this.senyububun_biko1_matsubi_ikayohaku_hyoji = jrb_i5_13.senyububun_biko1_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.senyububun_biko1_matsubi_ikayohaku_hyoji
      this.senyububun_biko1_numbering = jrb_i5_13.senyububun_biko1_numbering === undefined ? true : jrb_i5_13.senyububun_biko1_numbering
      this.senyoshiyoken_biko1_matsubi_ikayohaku_hyoji = jrb_i5_13.senyoshiyoken_biko1_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.senyoshiyoken_biko1_matsubi_ikayohaku_hyoji
      this.senyoshiyoken_biko1_numbering = jrb_i5_13.senyoshiyoken_biko1_numbering === undefined ? true : jrb_i5_13.senyoshiyoken_biko1_numbering
      this.senyububun_biko2_matsubi_ikayohaku_hyoji = jrb_i5_13.senyububun_biko2_matsubi_ikayohaku_hyoji === undefined ? true : jrb_i5_13.senyububun_biko2_matsubi_ikayohaku_hyoji
      this.senyububun_biko2_numbering = jrb_i5_13.senyububun_biko2_numbering === undefined ? true : jrb_i5_13.senyububun_biko2_numbering
      this.sonohoka_biko_matsubi_ikayohaku_hyoji1 = jrb_i5_13.sonohoka_biko_matsubi_ikayohaku_hyoji1 === undefined ? true : jrb_i5_13.sonohoka_biko_matsubi_ikayohaku_hyoji1
      this.sonohoka_biko_numbering1 = jrb_i5_13.sonohoka_biko_numbering1 === undefined ? true : jrb_i5_13.sonohoka_biko_numbering1
      this.sonohoka_biko_matsubi_ikayohaku_hyoji2 = jrb_i5_13.sonohoka_biko_matsubi_ikayohaku_hyoji2 === undefined ? true : jrb_i5_13.sonohoka_biko_matsubi_ikayohaku_hyoji2
      this.sonohoka_biko_numbering2 = jrb_i5_13.sonohoka_biko_numbering2 === undefined ? true : jrb_i5_13.sonohoka_biko_numbering2

      this.kanryojikeijo_kozoto_umusentaku = jrb_i5_13.kanryojikeijo_kozoto_umusentaku
      this.shikichi_jissoku_menseki = jrb_i5_13.shikichi_jissoku_menseki
      this.shikichi_tokibomenseki  = jrb_i5_13.shikichi_tokibomenseki
      this.shikichi_kenchiku_kakunin_menseki = jrb_i5_13.shikichi_kenchiku_kakunin_menseki
      this.kenrishurui_shoyuken = jrb_i5_13.kenrishurui_shoyuken
      this.kenrishurui_shakuchiken = jrb_i5_13.kenrishurui_shakuchiken
      this.kenrishurui_chijoken = jrb_i5_13.kenrishurui_chijoken
      this.kenrishurui_chinshaku = jrb_i5_13.kenrishurui_chinshaku
      this.shikichi_taisho_menseki = jrb_i5_13.shikichi_taisho_menseki
      this.shikichi_tokibo_jissoku_kubun = jrb_i5_13.shikichi_tokibo_jissoku_kubun
      this.shikichi_shakuchiken_sonzokukikan_nengappi = jrb_i5_13.shikichi_shakuchiken_sonzokukikan_nengappi
      this.shikichi_shakuchiken_sonzokukikan_nengappi_checkbox = jrb_i5_13.shikichi_shakuchiken_sonzokukikan_nengappi_checkbox
      this.shikichi_kingaku = jrb_i5_13.shikichi_kingaku
      this.kyoyobubun_kyoyo_bubun = jrb_i5_13.kyoyobubun_kyoyo_bubun
      this.kyoyobubun_hani = jrb_i5_13.kyoyobubun_hani
      this.kyoyobubun_kanri_kiyaku = jrb_i5_13.kyoyobubun_kanri_kiyaku
      this.kyoyobubun_kubun_sentaku = jrb_i5_13.kyoyobubun_kubun_sentaku
      this.kyoyobubun_kubun_kisai = jrb_i5_13.kyoyobubun_kubun_kisai
      this.kyoyobubun_mochibunwariai_jorei = jrb_i5_13.kyoyobubun_mochibunwariai_jorei
      this.yotoseigen_yotoseigen = jrb_i5_13.yotoseigen_yotoseigen
      this.yotoseigen_seigen_naiyo = jrb_i5_13.yotoseigen_seigen_naiyo
      this.yotoseigen_kanrikiyaku = jrb_i5_13.yotoseigen_kanrikiyaku
      this.yotoseigen_shiyosaisoku = jrb_i5_13.yotoseigen_shiyosaisoku
      this.pettoseigen_yotoseigen = jrb_i5_13.pettoseigen_yotoseigen
      this.pettoseigen_seigen_naiyo = jrb_i5_13.pettoseigen_seigen_naiyo
      this.pettoseigen_kanrikiyaku = jrb_i5_13.pettoseigen_kanrikiyaku
      this.pettoseigen_shiyosaisoku = jrb_i5_13.pettoseigen_shiyosaisoku
      this.furoringuseigen_yotoseigen = jrb_i5_13.furoringuseigen_yotoseigen
      this.furoringuseigen_seigen_naiyo = jrb_i5_13.furoringuseigen_seigen_naiyo
      this.furoringuseigen_kanrikiyaku = jrb_i5_13.furoringuseigen_kanrikiyaku
      this.furoringuseigen_shiyosaisoku = jrb_i5_13.furoringuseigen_shiyosaisoku
      this.gakkishiyo_yotoseigen = jrb_i5_13.gakkishiyo_yotoseigen
      this.gakkishiyo_seigen_naiyo = jrb_i5_13.gakkishiyo_seigen_naiyo
      this.gakkishiyo_kanrikiyaku = jrb_i5_13.gakkishiyo_kanrikiyaku
      this.gakkishiyo_shiyosaisoku = jrb_i5_13.gakkishiyo_shiyosaisoku
      this.hosoku_kanrikiyaku = jrb_i5_13.hosoku_kanrikiyaku
      this.hosoku_shiyosaisoku = jrb_i5_13.hosoku_shiyosaisoku
      this.barukoni_umusentaku = jrb_i5_13.barukoni_umusentaku
      this.barukoni_kubun_shoyusha = jrb_i5_13.barukoni_kubun_shoyusha
      this.barukoni_kizokusaki_umusentaku = jrb_i5_13.barukoni_kizokusaki_umusentaku
      this.barukoni_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.barukoni_senyoshiyoryo_kizokusaki_kubun
      this.barukoni_sakikubun_setsumei = jrb_i5_13.barukoni_sakikubun_setsumei
      this.barukoni_biko = jrb_i5_13.barukoni_biko
      this.barukoni_biko2 = jrb_i5_13.barukoni_biko2
      this.madonado_umusentaku = jrb_i5_13.madonado_umusentaku
      this.madonado_kubun_shoyusha = jrb_i5_13.madonado_kubun_shoyusha
      this.madonado_kizokusaki_umusentaku = jrb_i5_13.madonado_kizokusaki_umusentaku
      this.madonado_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.madonado_senyoshiyoryo_kizokusaki_kubun
      this.madonado_sakikubun_setsumei = jrb_i5_13.madonado_sakikubun_setsumei
      this.madonado_biko = jrb_i5_13.madonado_biko
      this.madonado_biko2 = jrb_i5_13.madonado_biko2
      this.senyotei_umusentaku = jrb_i5_13.senyotei_umusentaku
      this.senyotei_kubun_shoyusha = jrb_i5_13.senyotei_kubun_shoyusha
      this.senyotei_kizokusaki_umusentaku = jrb_i5_13.senyotei_kizokusaki_umusentaku
      this.senyotei_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.senyotei_senyoshiyoryo_kizokusaki_kubun
      this.senyotei_sakikubun_setsumei = jrb_i5_13.senyotei_sakikubun_setsumei
      this.senyotei_biko = jrb_i5_13.senyotei_biko
      this.senyotei_biko2 = jrb_i5_13.senyotei_biko2
      this.rufubarukoni_umusentaku = jrb_i5_13.rufubarukoni_umusentaku
      this.rufubarukoni_kubun_shoyusha = jrb_i5_13.rufubarukoni_kubun_shoyusha
      this.rufubarukoni_kizokusaki_umusentaku = jrb_i5_13.rufubarukoni_kizokusaki_umusentaku
      this.rufubarukoni_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.rufubarukoni_senyoshiyoryo_kizokusaki_kubun
      this.rufubarukoni_sakikubun_setsumei = jrb_i5_13.rufubarukoni_sakikubun_setsumei
      this.rufubarukoni_biko = jrb_i5_13.rufubarukoni_biko
      this.rufubarukoni_biko2 = jrb_i5_13.rufubarukoni_biko2
      this.torankurumu_umusentaku = jrb_i5_13.torankurumu_umusentaku
      this.torankurumu_kubun_shoyusha = jrb_i5_13.torankurumu_kubun_shoyusha
      this.torankurumu_kizokusaki_umusentaku = jrb_i5_13.torankurumu_kizokusaki_umusentaku
      this.torankurumu_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.torankurumu_senyoshiyoryo_kizokusaki_kubun
      this.torankurumu_sakikubun_setsumei = jrb_i5_13.torankurumu_sakikubun_setsumei
      this.torankurumu_biko = jrb_i5_13.torankurumu_biko
      this.torankurumu_biko2 = jrb_i5_13.torankurumu_biko2
      this.chushajo_umusentaku = jrb_i5_13.chushajo_umusentaku
      this.chushajo_kubun_shoyusha = jrb_i5_13.chushajo_kubun_shoyusha
      this.chushajo_kizokusaki_umusentaku = jrb_i5_13.chushajo_kizokusaki_umusentaku
      this.chushajo_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.chushajo_senyoshiyoryo_kizokusaki_kubun
      this.chushajo_sakikubun_setsumei = jrb_i5_13.chushajo_sakikubun_setsumei
      this.chushajo_biko = jrb_i5_13.chushajo_biko
      this.chushajo_biko2 = jrb_i5_13.chushajo_biko2
      this.churinjo_umusentaku = jrb_i5_13.churinjo_umusentaku
      this.churinjo_kubun_shoyusha = jrb_i5_13.churinjo_kubun_shoyusha
      this.churinjo_kizokusaki_umusentaku = jrb_i5_13.churinjo_kizokusaki_umusentaku
      this.churinjo_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.churinjo_senyoshiyoryo_kizokusaki_kubun
      this.churinjo_sakikubun_setsumei = jrb_i5_13.churinjo_sakikubun_setsumei
      this.churinjo_biko = jrb_i5_13.churinjo_biko
      this.churinjo_biko2 = jrb_i5_13.churinjo_biko2
      this.komoku1_meisho = jrb_i5_13.komoku1_meisho
      this.komoku1_kubun_shoyusha = jrb_i5_13.komoku1_kubun_shoyusha
      this.komoku1_kubun_shoyusha = jrb_i5_13.komoku1_kubun_shoyusha
      this.komoku1_kizokusaki_umusentaku = jrb_i5_13.komoku1_kizokusaki_umusentaku
      this.komoku1_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.komoku1_senyoshiyoryo_kizokusaki_kubun
      this.komoku1_sakikubun_setsumei = jrb_i5_13.komoku1_sakikubun_setsumei
      this.komoku1_biko = jrb_i5_13.komoku1_biko
      this.komoku2_meisho = jrb_i5_13.komoku2_meisho
      this.komoku2_kubun_shoyusha = jrb_i5_13.komoku2_kubun_shoyusha
      this.komoku2_kubun_shoyusha = jrb_i5_13.komoku2_kubun_shoyusha
      this.komoku2_kizokusaki_umusentaku = jrb_i5_13.komoku2_kizokusaki_umusentaku
      this.komoku2_senyoshiyoryo_kizokusaki_kubun = jrb_i5_13.komoku2_senyoshiyoryo_kizokusaki_kubun
      this.komoku2_sakikubun_setsumei = jrb_i5_13.komoku2_sakikubun_setsumei
      this.komoku2_biko = jrb_i5_13.komoku2_biko
      this.fuzuisenyo_barukoni_naiyo = jrb_i5_13.fuzuisenyo_barukoni_naiyo
      this.fuzuisenyo_madonado_naiyo = jrb_i5_13.fuzuisenyo_madonado_naiyo
      this.genmenkiyaku_umusentaku = jrb_i5_13.genmenkiyaku_umusentaku
      this.futangenmen_kanri_kiyakumei = jrb_i5_13.futangenmen_kanri_kiyakumei
      this.futangenmen_kanri_kiyakujo_bango = jrb_i5_13.futangenmen_kanri_kiyakujo_bango
      this.genmenkiyaku_kiyaku_sadame_gaiyo = jrb_i5_13.genmenkiyaku_kiyaku_sadame_gaiyo
      this.shuzentsumitatekin_umusentaku = jrb_i5_13.shuzentsumitatekin_umusentaku
      this.shuzentsumitatekin_kanrikiyaku_joreimei = jrb_i5_13.shuzentsumitatekin_kanrikiyaku_joreimei
      this.shuzentsumitatekin_kanrikiyaku_joreibango = jrb_i5_13.shuzentsumitatekin_kanrikiyaku_joreibango
      this.shuzentsumitatekin_kingaku = jrb_i5_13.shuzentsumitatekin_kingaku
      this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi = jrb_i5_13.shuzentsumitatekin_shuzen_tsumitatekin_nengappi
      this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox = jrb_i5_13.shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox
      this.shuzentsumitatekin_hosoku = jrb_i5_13.shuzentsumitatekin_hosoku
      this.shuzentsumitatekin_taino_umu = jrb_i5_13.shuzentsumitatekin_taino_umu
      this.shuzentsumitatekin_tainokingaku = jrb_i5_13.shuzentsumitatekin_tainokingaku
      this.shuzentsumitatekin_taino_nengappi = jrb_i5_13.shuzentsumitatekin_taino_nengappi
      this.shuzentsumitatekin_taino_nengappi_checkbox = jrb_i5_13.shuzentsumitatekin_taino_nengappi_checkbox
      this.shuzentsumitatekin_tsumitategaku_kingaku = jrb_i5_13.shuzentsumitatekin_tsumitategaku_kingaku
      this.shuzentsumitatekin_tsumitategaku_nengappi = jrb_i5_13.shuzentsumitatekin_tsumitategaku_nengappi
      this.shuzentsumitatekin_tsumitategaku_nengappi_checkbox = jrb_i5_13.shuzentsumitatekin_tsumitategaku_nengappi_checkbox
      this.shuzentsumitatekin_tsumitategaku_umusentaku = jrb_i5_13.shuzentsumitatekin_tsumitategaku_umusentaku
      this.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku = jrb_i5_13.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku
      this.shuzentsumitatekin_tsumitategaku_nengappi2 = jrb_i5_13.shuzentsumitatekin_tsumitategaku_nengappi2
      this.shuzentsumitatekin_tsumitategaku_nengappi2_checkbox = jrb_i5_13.shuzentsumitatekin_tsumitategaku_nengappi2_checkbox
      this.kanrihi_kingaku = jrb_i5_13.kanrihi_kingaku
      this.kanrihi_nengappi = jrb_i5_13.kanrihi_nengappi
      this.kanrihi_nengappi_checkbox = jrb_i5_13.kanrihi_nengappi_checkbox
      this.kanrihi_hosoku = jrb_i5_13.kanrihi_hosoku
      this.kanrihi_tainoumu = jrb_i5_13.kanrihi_tainoumu
      this.kanrihi_tainokingaku = jrb_i5_13.kanrihi_tainokingaku
      this.kanrihi_taino_nengappi = jrb_i5_13.kanrihi_taino_nengappi
      this.kanrihi_taino_nengappi_checkbox = jrb_i5_13.kanrihi_taino_nengappi_checkbox
      this.kanrihi_taino_johokaiji_umu = jrb_i5_13.kanrihi_taino_johokaiji_umu
      this.kanrihi_taino_johokaiji_tainogaku = jrb_i5_13.kanrihi_taino_johokaiji_tainogaku
      this.kanrihi_taino_johokaiji_taino_nengappi = jrb_i5_13.kanrihi_taino_johokaiji_taino_nengappi
      this.kanrihi_taino_johokaiji_taino_nengappi_checkbox = jrb_i5_13.kanrihi_taino_johokaiji_taino_nengappi_checkbox
      this.kanrikumiai_meisho = jrb_i5_13.kanrikumiai_meisho
      this.kanri_keitai = jrb_i5_13.kanri_keitai
      this.kanriitakusaki_meisho = jrb_i5_13.kanriitakusaki_meisho
      this.kanriitakusaki_tenwabango = jrb_i5_13.kanriitakusaki_tenwabango
      // this.kanriitakusaki_tenwabango2 = jrb_i5_13.kanriitakusaki_tenwabango2
      // this.kanriitakusaki_tenwabango3 = jrb_i5_13.kanriitakusaki_tenwabango3
      this.kanriitakusaki_shozai = jrb_i5_13.kanriitakusaki_shozai
      this.kanriitakusaki_manshonkanritekiseikaho_toroku_bango = jrb_i5_13.kanriitakusaki_manshonkanritekiseikaho_toroku_bango
      this.kyoyobubun_umusentaku = jrb_i5_13.kyoyobubun_umusentaku
      this.kyoyobubun_jisshijokyo = jrb_i5_13.kyoyobubun_jisshijokyo
      this.senyububun_umusentaku = jrb_i5_13.senyububun_umusentaku
      this.senyububun_jisshijokyo = jrb_i5_13.senyububun_jisshijokyo
      this.jokyochosa_gaito_umu = jrb_i5_13.jokyochosa_gaito_umu
      this.jokyochosa_jisshi_umu = jrb_i5_13.jokyochosa_jisshi_umu
      this.tatemono_ijihozen_gaitokubun = jrb_i5_13.tatemono_ijihozen_gaitokubun
      this.kakunin_shinseisho_hozonumu1 = jrb_i5_13.kakunin_shinseisho_hozonumu1
      this.kakuninzumisho_hozonumu2 = jrb_i5_13.kakuninzumisho_hozonumu2
      this.kensazumisho_hozonumu3 = jrb_i5_13.kensazumisho_hozonumu3
      this.zokaichiku_sentaku = jrb_i5_13.zokaichiku_sentaku
      this.kakunin_shinseisho_hozonumu4 = jrb_i5_13.kakunin_shinseisho_hozonumu4
      this.kakuninzumisho_hozonumu5 = jrb_i5_13.kakuninzumisho_hozonumu5
      this.kensazumisho_hozonumu6 = jrb_i5_13.kensazumisho_hozonumu6
      this.tatemono_jokyochosa_jisshi_jutakudearu_baai = jrb_i5_13.tatemono_jokyochosa_jisshi_jutakudearu_baai
      this.tatemono_jokyochosa_hokokusho_hozonumu = jrb_i5_13.tatemono_jokyochosa_hokokusho_hozonumu
      this.kenchiku_kijunhodai_12jo_sentaku = jrb_i5_13.kenchiku_kijunhodai_12jo_sentaku
      this.teikichosa_teikihokokusho_hozonumu = jrb_i5_13.teikichosa_teikihokokusho_hozonumu
      this.kizonjutaku_seino_hyoka_sentaku = jrb_i5_13.kizonjutaku_seino_hyoka_sentaku
      this.kizonjutaku_seino_hyokasho_hozonumu = jrb_i5_13.kizonjutaku_seino_hyokasho_hozonumu
      this.shinchiku_koji_chaku_tatemonodearubaai_kubun = jrb_i5_13.shinchiku_koji_chaku_tatemonodearubaai_kubun
      this.kizonjutaku_seinohyokasho_umu = jrb_i5_13.kizonjutaku_seinohyokasho_umu
      this.taishinshindan_kekka_hokokusho_hozonumu = jrb_i5_13.taishinshindan_kekka_hokokusho_hozonumu
      this.shintaishinkijun_tekigosei_hozonumu = jrb_i5_13.shintaishinkijun_tekigosei_hozonumu
      this.kashihoken_hozonumu = jrb_i5_13.kashihoken_hozonumu
      this.taishinkijuntekigoshomeish_hozonumu = jrb_i5_13.taishinkijuntekigoshomeish_hozonumu
      this.sonohoka_nyuryoku = jrb_i5_13.sonohoka_nyuryoku
      this.sonohoka_hozonumu = jrb_i5_13.sonohoka_hozonumu
      this.kakuninzumisho_umusentaku = jrb_i5_13.kakuninzumisho_umusentaku
      this.kakuninzumisho_nengappi = jrb_i5_13.kakuninzumisho_nengappi
      this.kakuninzumisho_nengappi_checkbox = jrb_i5_13.kakuninzumisho_nengappi_checkbox
      this.kakuninzumisho_bango = jrb_i5_13.kakuninzumisho_bango
      this.kensazumisho_umusentaku = jrb_i5_13.kensazumisho_umusentaku
      this.kensazumisho_nengappi = jrb_i5_13.kensazumisho_nengappi
      this.kensazumisho_nengappi_checkbox = jrb_i5_13.kensazumisho_nengappi_checkbox
      this.kensazumisho_bango = jrb_i5_13.kensazumisho_bango
      this.jutakuseinohyoka_uketa_shinchiku_sentaku = jrb_i5_13.jutakuseinohyoka_uketa_shinchiku_sentaku
      this.sekkeijutaku_seino_hyokasho_umu = jrb_i5_13.sekkeijutaku_seino_hyokasho_umu
      this.kensetsujutaku_seino_hyokasho_umu = jrb_i5_13.kensetsujutaku_seino_hyokasho_umu
      this.ishiwatashiyo_chosa_umu_sentaku = jrb_i5_13.ishiwatashiyo_chosa_umu_sentaku
      this.zoseitakuchi_kuiki_sentaku = jrb_i5_13.zoseitakuchi_kuiki_sentaku
      this.doshasaigai_kuiki_sentaku = jrb_i5_13.doshasaigai_kuiki_sentaku
      this.tsunami_kuiki_sentaku = jrb_i5_13.tsunami_kuiki_sentaku
      this.hazadomappu_umu_kozui = jrb_i5_13.hazadomappu_umu_kozui
      this.hazadomappu_umu_usuishussui = jrb_i5_13.hazadomappu_umu_usuishussui
      this.hazadomappu_umu_takashio = jrb_i5_13.hazadomappu_umu_takashio
      this.tsunami_disaster_caution = jrb_i5_13.tsunami_disaster_caution
      // Initiate for array
      if (Array.isArray(jrb_i5_13.shikichi_biko)) {
        this.shikichi_biko_inputs = jrb_i5_13.shikichi_biko.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.hazadomappu_umu_setsumei)) {
        this.hazadomappu_umu_setsumei_inputs = jrb_i5_13.hazadomappu_umu_setsumei.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.kyoyobubun_biko)) {
        this.kyoyobubun_biko_inputs = jrb_i5_13.kyoyobubun_biko.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.senyububun_biko1)) {
        this.senyububun_biko1_inputs = jrb_i5_13.senyububun_biko1.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.senyoshiyoken_biko1)) {
        this.senyoshiyoken_biko1_inputs = jrb_i5_13.senyoshiyoken_biko1.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.senyububun_biko2)) {
        this.senyububun_biko2_inputs = jrb_i5_13.senyububun_biko2.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.sonohoka_biko)) {
        this.sonohoka_biko_inputs = jrb_i5_13.sonohoka_biko.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.takuchi_tatemono_jiko_sonohoka)) {
        this.takuchi_tatemono_jiko_sonohoka_inputs = jrb_i5_13.takuchi_tatemono_jiko_sonohoka.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.jokyochosa_naiyo)) {
        this.jokyochosa_naiyo_inputs = jrb_i5_13.jokyochosa_naiyo.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.taishinshindan_kekka_hokokusho_biko)) {
        this.taishinshindan_kekka_hokokusho_biko_inputs = jrb_i5_13.taishinshindan_kekka_hokokusho_biko.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.kenchiku_kakuninzumisho_biko)) {
        this.kenchiku_kakuninzumisho_biko_inputs = jrb_i5_13.kenchiku_kakuninzumisho_biko.map(
          ele => ({
            checkboxDelete: false,
            naiyo: ele
          })
        )
      }
      if (Array.isArray(jrb_i5_13.senyoshiyoken)) {
        this.senyoshiyoken_inputs = jrb_i5_13.senyoshiyoken.map(element => {
          return {
            checkboxDelete: false,
            meisho: element.meisho,
            umusentaku: element.umusentaku,
            kubun_shoyusha: element.kubun_shoyusha,
            kizokusaki_umusentaku: element.kizokusaki_umusentaku,
            senyoshiyoryo_kizokusaki_kubun: element.senyoshiyoryo_kizokusaki_kubun,
            sakikubun_setsumei: element.sakikubun_setsumei,
            biko: element.biko,
            biko2: element.biko2
          }
        })
      }
      if (Array.isArray(jrb_i5_13.fuzuisenyo_shiyoken)) {
        this.fuzuisenyo_shiyoken_inputs = jrb_i5_13.fuzuisenyo_shiyoken.map(element => {
          element.checkboxDelete = false
          return element
        })
      }
    }
    const editMode = _.get(this.$store.getters.editMode, 'jrb07_08', false)
    if (editMode) {
      setTimeout(() => { this.validateWarning() }, 100) 
    }
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    }
  },
  methods: {
    handleCheck(type) {
      switch (type) {
      case 'tatemono_ijihozen_gaitokubun' : 
        if(this.tatemono_ijihozen_gaitokubun === '0') {
          this.zokaichiku_sentaku = null
          this.tatemono_jokyochosa_jisshi_jutakudearu_baai = null
          this.kenchiku_kijunhodai_12jo_sentaku = null
          this.kizonjutaku_seino_hyoka_sentaku = null
          this.shinchiku_koji_chaku_tatemonodearubaai_kubun = null
          this.jutakuseinohyoka_uketa_shinchiku_sentaku = null
          this.kakunin_shinseisho_hozonumu4 = null
          this.kakuninzumisho_hozonumu5 = null
          this.kensazumisho_hozonumu6 = null
          this.tatemono_jokyochosa_hokokusho_hozonumu = null
          this.teikichosa_teikihokokusho_hozonumu = null
          this.kizonjutaku_seino_hyokasho_hozonumu = null
          this.kizonjutaku_seinohyokasho_umu = null
          this.taishinshindan_kekka_hokokusho_hozonumu = null
          this.shintaishinkijun_tekigosei_hozonumu = null
          this.kashihoken_hozonumu = null
          this.taishinkijuntekigoshomeish_hozonumu = null
          this.sonohoka_nyuryoku = ''
          this.sonohoka_hozonumu = null
          this.sekkeijutaku_seino_hyokasho_umu = null
          this.kensetsujutaku_seino_hyokasho_umu = null
        }
        break
      case 'zokaichiku_sentaku':
        if(this.zokaichiku_sentaku === '1' || this.zokaichiku_sentaku === '2') {
          this.kakunin_shinseisho_hozonumu4 = null
          this.kakuninzumisho_hozonumu5 = null
          this.kensazumisho_hozonumu6 = null
        }
        break
      case 'tatemono_jokyochosa_jisshi_jutakudearu_baai':
        if (this.tatemono_jokyochosa_jisshi_jutakudearu_baai === '1' || this.tatemono_jokyochosa_jisshi_jutakudearu_baai === '2') {
          this.tatemono_jokyochosa_hokokusho_hozonumu = null
        }
        break
      case 'kenchiku_kijunhodai_12jo_sentaku':
        if (this.kenchiku_kijunhodai_12jo_sentaku === '1' || this.kenchiku_kijunhodai_12jo_sentaku === '2') {
          this.teikichosa_teikihokokusho_hozonumu = null
        }
        break
      case 'kizonjutaku_seino_hyoka_sentaku':
        if (this.kizonjutaku_seino_hyoka_sentaku === '1' || this.kizonjutaku_seino_hyoka_sentaku === '2') {
          this.kizonjutaku_seino_hyokasho_hozonumu = null
        }
        break
      case 'shinchiku_koji_chaku_tatemonodearubaai_kubun':
        if (this.shinchiku_koji_chaku_tatemonodearubaai_kubun === '0') {
          this.kizonjutaku_seinohyokasho_umu = null
          this.taishinshindan_kekka_hokokusho_hozonumu = null
          this.shintaishinkijun_tekigosei_hozonumu = null
          this.kashihoken_hozonumu = null
          this.taishinkijuntekigoshomeish_hozonumu = null
          this.sonohoka_nyuryoku = ''
          this.sonohoka_hozonumu = null
        }
        break
      case 'jutakuseinohyoka_uketa_shinchiku_sentaku':
        if (this.jutakuseinohyoka_uketa_shinchiku_sentaku !== '0') {
          this.sekkeijutaku_seino_hyokasho_umu = null
          this.kensetsujutaku_seino_hyokasho_umu = null
        }
        break
      }
    },
    // change check kenrishurui_shakuchiken
    change_check_kenrishurui_shakuchiken() {
      if(!this.kenrishurui_shakuchiken) {
        this.kenrishurui_chijoken = false
        this.kenrishurui_chinshaku = false
      }
    },
    // Add shikichi_biko
    add_biko(biko_inputs) {
      biko_inputs.push({
        checkboxDelete: false,
        naiyo: ''
      }
      )
    },
    // Call pop delete biko
    call_popup_delete_biko(name, arrays) {
      let flag = true
      arrays.forEach((element) =>  {
        if(element.checkboxDelete) {
          this.popupDeleteShikichi_biko = true
          this.deleteArrayObjectName = name
          flag = false
        }
      })
      if(flag) {
        this.$toasted.error('項目が選択されていません。')
      }
    },
    // delete biko
    handleDeleteBiko() {
      if(this.deleteArrayObjectName === 'shikichi_biko_inputs') {
        this.shikichi_biko_inputs = this.shikichi_biko_inputs.filter(v => v.checkboxDelete === false)
        if(this.shikichi_biko_inputs.length === 0) {
          this.add_biko(this.shikichi_biko_inputs)
        }
      } else if(this.deleteArrayObjectName === 'kyoyobubun_biko_inputs') {
        this.kyoyobubun_biko_inputs = this.kyoyobubun_biko_inputs.filter(v => v.checkboxDelete === false)
        if(this.kyoyobubun_biko_inputs.length === 0) {
          this.add_biko(this.kyoyobubun_biko_inputs)
        }
      } else if(this.deleteArrayObjectName === 'senyububun_biko1_inputs') {
        this.senyububun_biko1_inputs = this.senyububun_biko1_inputs.filter(v => v.checkboxDelete === false)
        if(this.senyububun_biko1_inputs.length === 0) {
          this.add_biko(this.senyububun_biko1_inputs)
        }
      } else if(this.deleteArrayObjectName === 'senyoshiyoken_biko1_inputs') {
        this.senyoshiyoken_biko1_inputs = this.senyoshiyoken_biko1_inputs.filter(v => v.checkboxDelete === false)
        if(this.senyoshiyoken_biko1_inputs.length === 0) {
          this.add_biko(this.senyoshiyoken_biko1_inputs)
        }
      } else if(this.deleteArrayObjectName === 'senyububun_biko2_inputs') {
        this.senyububun_biko2_inputs = this.senyububun_biko2_inputs.filter(v => v.checkboxDelete === false)
        if(this.senyububun_biko2_inputs.length === 0) {
          this.add_biko(this.senyububun_biko2_inputs)
        }
      } else if(this.deleteArrayObjectName === 'sonohoka_biko_inputs') {
        this.sonohoka_biko_inputs = this.sonohoka_biko_inputs.filter(v => v.checkboxDelete === false)
        if(this.sonohoka_biko_inputs.length === 0) {
          this.add_biko(this.sonohoka_biko_inputs)
        }
      } else if(this.deleteArrayObjectName === 'takuchi_tatemono_jiko_sonohoka_inputs') {
        this.takuchi_tatemono_jiko_sonohoka_inputs = this.takuchi_tatemono_jiko_sonohoka_inputs.filter(v => v.checkboxDelete === false)
        if(this.takuchi_tatemono_jiko_sonohoka_inputs.length === 0) {
          this.add_biko(this.takuchi_tatemono_jiko_sonohoka_inputs)
        }
      } else if(this.deleteArrayObjectName === 'jokyochosa_naiyo_inputs') {
        this.jokyochosa_naiyo_inputs = this.jokyochosa_naiyo_inputs.filter(v => v.checkboxDelete === false)
        if(this.jokyochosa_naiyo_inputs.length === 0) {
          this.add_biko(this.jokyochosa_naiyo_inputs)
        }
      } else if(this.deleteArrayObjectName === 'taishinshindan_kekka_hokokusho_biko_inputs') {
        this.taishinshindan_kekka_hokokusho_biko_inputs = this.taishinshindan_kekka_hokokusho_biko_inputs.filter(v => v.checkboxDelete === false)
        if(this.taishinshindan_kekka_hokokusho_biko_inputs.length === 0) {
          this.add_biko(this.taishinshindan_kekka_hokokusho_biko_inputs)
        }
      } else if(this.deleteArrayObjectName === 'kenchiku_kakuninzumisho_biko_inputs') {
        this.kenchiku_kakuninzumisho_biko_inputs = this.kenchiku_kakuninzumisho_biko_inputs.filter(v => v.checkboxDelete === false)
        if(this.kenchiku_kakuninzumisho_biko_inputs.length === 0) {
          this.add_biko(this.kenchiku_kakuninzumisho_biko_inputs)
        }
      } else if(this.deleteArrayObjectName === 'senyoshiyoken_inputs') {
        this.senyoshiyoken_inputs = this.senyoshiyoken_inputs.filter(v => v.checkboxDelete === false)
        if(this.senyoshiyoken_inputs.length === 0) {
          this.add_senyoshiyoken_inputs()
        }
      } else if(this.deleteArrayObjectName === 'fuzuisenyo_shiyoken_inputs') {
        this.fuzuisenyo_shiyoken_inputs = this.fuzuisenyo_shiyoken_inputs.filter(v => v.checkboxDelete === false)
        if(this.fuzuisenyo_shiyoken_inputs.length === 0) {
          this.add_biko(this.fuzuisenyo_shiyoken_inputs)
        }
      } else if(this.deleteArrayObjectName === 'hazadomappu_umu_setsumei_inputs') {
        this.hazadomappu_umu_setsumei_inputs = this.hazadomappu_umu_setsumei_inputs.filter(v => v.checkboxDelete === false)
        if(this.hazadomappu_umu_setsumei_inputs.length === 0) {
          this.add_biko(this.hazadomappu_umu_setsumei_inputs)
        }
      }
      this.popupDeleteShikichi_biko = false
    },
    // Add add_senyoshiyoken_inputs
    add_senyoshiyoken_inputs() {
      this.senyoshiyoken_inputs.push(
        {
          checkboxDelete: false,
          meisho: '',
          umusentaku: null,
          kubun_shoyusha: '',
          kizokusaki_umusentaku: null,
          senyoshiyoryo_kizokusaki_kubun: null,
          sakikubun_setsumei: '',
          biko: '',
          biko2: ''
        }
      )
    },
    // Add add_fuzuisenyo_shiyoken_inputs
    add_fuzuisenyo_shiyoken_inputs() {
      this.fuzuisenyo_shiyoken_inputs.push(
        {
          checkboxDelete: false,
          meisho: '',
          naiyo: ''
        }
      )
    },
    // 面積反映をクリック
    hanei_menseki() {
      const bes = _.get(this.$store.getters.pattern, 'baikei.bes', null)
      const besData = _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bes', null))
      if (bes === 'bes-08') {
        if(besData === null || besData.shikikentochi_menseki === null || besData.shikikentochi_menseki === '') {
          this.$toasted.error('売買契約書に土地の情報がまだ入力されていません')
        }else{
          this.shikichi_tokibomenseki = besData.shikikentochi_menseki
        }
      }
      if (bes === 'bes-09') {
        if(besData === null || besData.tochi_gokeimenseki === null || besData.tochi_gokeimenseki === '') {
          this.$toasted.error('売買契約書に土地の情報がまだ入力されていません')
        }else{
          this.shikichi_tokibomenseki = besData.tochi_gokeimenseki
        }
      }
      if (bes === 'bes-10') {
        if(besData === null || besData.shikikentochi_menseki === null || besData.shikikentochi_menseki === '') {
          this.$toasted.error('売買契約書に土地の情報がまだ入力されていません')
        }else{
          this.shikichi_tokibomenseki = besData.shikikentochi_menseki
        }
      }
    },
    // Itaku Dialog
    acceptAlert() {
      this.kanriitakusaki_meisho = this.selected_sentaku.kaishamei
      const res = this.selected_sentaku.denwabango.split('-')
      this.kanriitakusaki_tenwabango = res[0]
      // this.kanriitakusaki_tenwabango2 = res[1]
      // this.kanriitakusaki_tenwabango3 = res[2]
      this.kanriitakusaki_shozai = this.selected_sentaku.shozaichi
      this.kanriitakusaki_manshonkanritekiseikaho_toroku_bango = this.selected_sentaku.toroku_bango
      this.activeItakuDialog = false
    },
    getItakuData() {
      this.$store.dispatch(GET_ITAKU).then((data) => {
        const minIndex = (this.pagination.page - 1) * this.pagination.pageSize
        this.pagination.data = data.filter((item, index) => index >= minIndex && index < (minIndex + this.pagination.pageSize))
        this.pagination.totalPages = Math.ceil(data.length / this.pagination.pageSize)
      })
    },
    onPageChange() {
      const minIndex = (this.pagination.page - 1) * this.pagination.pageSize
      this.pagination.data = this.itaku_sample_data.data.filter((item, index) => index >= minIndex && index < (minIndex + this.pagination.pageSize))
    },
    // Click Radiobutton to choose itakukaisha
    selectSentaku(selectedSentaku) {
      this.selected_sentaku = selectedSentaku
    },
    isNumber(value) {
      return value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/\D/g, '')
    },
    // Handle Hanei Event
    handleSaveJRBI5_13() {
      const handle = () => {
        const jrb_i5_13 = {
          jokyochosa_naiyo_matsubi_ikayohaku_hyoji: this.jokyochosa_naiyo_matsubi_ikayohaku_hyoji,
          jokyochosa_naiyo_numbering: this.jokyochosa_naiyo_numbering,
          taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji: this.taishinshindan_kekka_hokokusho_biko_matsubi_ikayohaku_hyoji,
          taishinshindan_kekka_hokokusho_biko_numbering: this.taishinshindan_kekka_hokokusho_biko_numbering,
          kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji: this.kenchiku_kakuninzumisho_biko_matsubi_ikayohaku_hyoji,
          kenchiku_kakuninzumisho_biko_numbering: this.kenchiku_kakuninzumisho_biko_numbering,
          hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji: this.hazadomappu_umu_setsumei_matsubi_ikayohaku_hyoji,
          hazadomappu_umu_setsumei_numbering: this.hazadomappu_umu_setsumei_numbering,
          shikichi_biko_matsubi_ikayohaku_hyoji: this.shikichi_biko_matsubi_ikayohaku_hyoji,
          shikichi_biko_numbering: this.shikichi_biko_numbering,
          kyoyobubun_biko_matsubi_ikayohaku_hyoji: this.kyoyobubun_biko_matsubi_ikayohaku_hyoji,
          kyoyobubun_biko_numbering: this.kyoyobubun_biko_numbering,
          senyububun_biko1_matsubi_ikayohaku_hyoji: this.senyububun_biko1_matsubi_ikayohaku_hyoji,
          senyububun_biko1_numbering: this.senyububun_biko1_numbering,
          senyoshiyoken_biko1_matsubi_ikayohaku_hyoji: this.senyoshiyoken_biko1_matsubi_ikayohaku_hyoji,
          senyoshiyoken_biko1_numbering: this.senyoshiyoken_biko1_numbering,
          senyububun_biko2_matsubi_ikayohaku_hyoji: this.senyububun_biko2_matsubi_ikayohaku_hyoji,
          senyububun_biko2_numbering: this.senyububun_biko2_numbering,
          sonohoka_biko_matsubi_ikayohaku_hyoji1: this.sonohoka_biko_matsubi_ikayohaku_hyoji1,
          sonohoka_biko_numbering1: this.sonohoka_biko_numbering1,
          sonohoka_biko_matsubi_ikayohaku_hyoji2: this.sonohoka_biko_matsubi_ikayohaku_hyoji2,
          sonohoka_biko_numbering2: this.sonohoka_biko_numbering2,

          kanryojikeijo_kozoto_umusentaku: this.kanryojikeijo_kozoto_umusentaku,
          shikichi_jissoku_menseki: this.shikichi_jissoku_menseki,
          shikichi_tokibomenseki : this.shikichi_tokibomenseki,
          shikichi_kenchiku_kakunin_menseki: this.shikichi_kenchiku_kakunin_menseki,
          kenrishurui_shoyuken: this.kenrishurui_shoyuken,
          kenrishurui_shakuchiken: this.kenrishurui_shakuchiken,
          kenrishurui_chijoken: this.kenrishurui_chijoken,
          kenrishurui_chinshaku: this.kenrishurui_chinshaku,
          shikichi_taisho_menseki: this.shikichi_taisho_menseki,
          shikichi_tokibo_jissoku_kubun: this.shikichi_tokibo_jissoku_kubun,
          shikichi_shakuchiken_sonzokukikan_nengappi: this.shikichi_shakuchiken_sonzokukikan_nengappi,
          shikichi_shakuchiken_sonzokukikan_nengappi_checkbox: this.shikichi_shakuchiken_sonzokukikan_nengappi_checkbox,
          shikichi_kingaku: this.shikichi_kingaku,
          shikichi_biko: this.shikichi_biko,
          kyoyobubun_kyoyo_bubun: this.kyoyobubun_kyoyo_bubun,
          kyoyobubun_hani: this.kyoyobubun_hani,
          kyoyobubun_kanri_kiyaku: this.kyoyobubun_kanri_kiyaku,
          kyoyobubun_kubun_sentaku: this.kyoyobubun_kubun_sentaku,
          kyoyobubun_kubun_kisai: this.kyoyobubun_kubun_kisai,
          kyoyobubun_mochibunwariai_jorei: this.kyoyobubun_mochibunwariai_jorei,
          kyoyobubun_biko: this.kyoyobubun_biko,
          yotoseigen_yotoseigen: this.yotoseigen_yotoseigen,
          yotoseigen_seigen_naiyo: this.yotoseigen_seigen_naiyo,
          yotoseigen_kanrikiyaku: this.yotoseigen_kanrikiyaku,
          yotoseigen_shiyosaisoku: this.yotoseigen_shiyosaisoku,
          pettoseigen_yotoseigen: this.pettoseigen_yotoseigen,
          pettoseigen_seigen_naiyo: this.pettoseigen_seigen_naiyo,
          pettoseigen_kanrikiyaku: this.pettoseigen_kanrikiyaku,
          pettoseigen_shiyosaisoku: this.pettoseigen_shiyosaisoku,
          furoringuseigen_yotoseigen: this.furoringuseigen_yotoseigen,
          furoringuseigen_seigen_naiyo: this.furoringuseigen_seigen_naiyo,
          furoringuseigen_kanrikiyaku: this.furoringuseigen_kanrikiyaku,
          furoringuseigen_shiyosaisoku: this.furoringuseigen_shiyosaisoku,
          gakkishiyo_yotoseigen: this.gakkishiyo_yotoseigen,
          gakkishiyo_seigen_naiyo: this.gakkishiyo_seigen_naiyo,
          gakkishiyo_kanrikiyaku: this.gakkishiyo_kanrikiyaku,
          gakkishiyo_shiyosaisoku: this.gakkishiyo_shiyosaisoku,
          senyububun_biko1: this.senyububun_biko1,
          hosoku_kanrikiyaku: this.hosoku_kanrikiyaku,
          hosoku_shiyosaisoku: this.hosoku_shiyosaisoku,
          barukoni_umusentaku: this.barukoni_umusentaku,
          barukoni_kubun_shoyusha: this.barukoni_kubun_shoyusha,
          barukoni_kizokusaki_umusentaku: this.barukoni_kizokusaki_umusentaku,
          barukoni_senyoshiyoryo_kizokusaki_kubun: this.barukoni_senyoshiyoryo_kizokusaki_kubun,
          barukoni_sakikubun_setsumei: this.barukoni_sakikubun_setsumei,
          barukoni_biko: this.barukoni_biko,
          barukoni_biko2: this.barukoni_biko2,
          madonado_umusentaku: this.madonado_umusentaku,
          madonado_kubun_shoyusha: this.madonado_kubun_shoyusha,
          madonado_kizokusaki_umusentaku: this.madonado_kizokusaki_umusentaku,
          madonado_senyoshiyoryo_kizokusaki_kubun: this.madonado_senyoshiyoryo_kizokusaki_kubun,
          madonado_sakikubun_setsumei: this.madonado_sakikubun_setsumei,
          madonado_biko: this.madonado_biko,
          madonado_biko2: this.madonado_biko2,
          senyotei_umusentaku: this.senyotei_umusentaku,
          senyotei_kubun_shoyusha: this.senyotei_kubun_shoyusha,
          senyotei_kizokusaki_umusentaku: this.senyotei_kizokusaki_umusentaku,
          senyotei_senyoshiyoryo_kizokusaki_kubun: this.senyotei_senyoshiyoryo_kizokusaki_kubun,
          senyotei_sakikubun_setsumei: this.senyotei_sakikubun_setsumei,
          senyotei_biko: this.senyotei_biko,
          senyotei_biko2: this.senyotei_biko2,
          rufubarukoni_umusentaku: this.rufubarukoni_umusentaku,
          rufubarukoni_kubun_shoyusha: this.rufubarukoni_kubun_shoyusha,
          rufubarukoni_kizokusaki_umusentaku: this.rufubarukoni_kizokusaki_umusentaku,
          rufubarukoni_senyoshiyoryo_kizokusaki_kubun: this.rufubarukoni_senyoshiyoryo_kizokusaki_kubun,
          rufubarukoni_sakikubun_setsumei: this.rufubarukoni_sakikubun_setsumei,
          rufubarukoni_biko: this.rufubarukoni_biko,
          rufubarukoni_biko2: this.rufubarukoni_biko2,
          torankurumu_umusentaku: this.torankurumu_umusentaku,
          torankurumu_kubun_shoyusha: this.torankurumu_kubun_shoyusha,
          torankurumu_kizokusaki_umusentaku: this.torankurumu_kizokusaki_umusentaku,
          torankurumu_senyoshiyoryo_kizokusaki_kubun: this.torankurumu_senyoshiyoryo_kizokusaki_kubun,
          torankurumu_sakikubun_setsumei: this.torankurumu_sakikubun_setsumei,
          torankurumu_biko: this.torankurumu_biko,
          torankurumu_biko2: this.torankurumu_biko2,
          chushajo_umusentaku: this.chushajo_umusentaku,
          chushajo_kubun_shoyusha: this.chushajo_kubun_shoyusha,
          chushajo_kizokusaki_umusentaku: this.chushajo_kizokusaki_umusentaku,
          chushajo_senyoshiyoryo_kizokusaki_kubun: this.chushajo_senyoshiyoryo_kizokusaki_kubun,
          chushajo_sakikubun_setsumei: this.chushajo_sakikubun_setsumei,
          chushajo_biko: this.chushajo_biko,
          chushajo_biko2: this.chushajo_biko2,
          churinjo_umusentaku: this.churinjo_umusentaku,
          churinjo_kubun_shoyusha: this.churinjo_kubun_shoyusha,
          churinjo_kizokusaki_umusentaku: this.churinjo_kizokusaki_umusentaku,
          churinjo_senyoshiyoryo_kizokusaki_kubun: this.churinjo_senyoshiyoryo_kizokusaki_kubun,
          churinjo_sakikubun_setsumei: this.churinjo_sakikubun_setsumei,
          churinjo_biko: this.churinjo_biko,
          churinjo_biko2: this.churinjo_biko2,
          komoku1_meisho: this.komoku1_meisho,
          komoku1_kubun_shoyusha: this.komoku1_kubun_shoyusha,
          komoku1_kizokusaki_umusentaku: this.komoku1_kizokusaki_umusentaku,
          komoku1_senyoshiyoryo_kizokusaki_kubun: this.komoku1_senyoshiyoryo_kizokusaki_kubun,
          komoku1_sakikubun_setsumei: this.komoku1_sakikubun_setsumei,
          komoku1_biko: this.komoku1_biko,
          komoku2_meisho: this.komoku2_meisho,
          komoku2_kubun_shoyusha: this.komoku2_kubun_shoyusha,
          komoku2_kizokusaki_umusentaku: this.komoku2_kizokusaki_umusentaku,
          komoku2_senyoshiyoryo_kizokusaki_kubun: this.komoku2_senyoshiyoryo_kizokusaki_kubun,
          komoku2_sakikubun_setsumei: this.komoku2_sakikubun_setsumei,
          komoku2_biko: this.komoku2_biko,
          senyoshiyoken_biko1: this.senyoshiyoken_biko1,
          fuzuisenyo_barukoni_naiyo: this.fuzuisenyo_barukoni_naiyo,
          fuzuisenyo_madonado_naiyo: this.fuzuisenyo_madonado_naiyo,
          fuzuisenyo_shiyoken: this.fuzuisenyo_shiyoken,
          senyububun_biko2: this.senyububun_biko2,
          genmenkiyaku_umusentaku: this.genmenkiyaku_umusentaku,
          futangenmen_kanri_kiyakumei: this.futangenmen_kanri_kiyakumei,
          futangenmen_kanri_kiyakujo_bango: this.futangenmen_kanri_kiyakujo_bango,
          genmenkiyaku_kiyaku_sadame_gaiyo: this.genmenkiyaku_kiyaku_sadame_gaiyo,
          shuzentsumitatekin_umusentaku: this.shuzentsumitatekin_umusentaku,
          shuzentsumitatekin_kanrikiyaku_joreimei: this.shuzentsumitatekin_kanrikiyaku_joreimei,
          shuzentsumitatekin_kanrikiyaku_joreibango: this.shuzentsumitatekin_kanrikiyaku_joreibango,
          shuzentsumitatekin_kingaku: this.shuzentsumitatekin_kingaku,
          shuzentsumitatekin_shuzen_tsumitatekin_nengappi: this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi,
          shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox: this.shuzentsumitatekin_shuzen_tsumitatekin_nengappi_checkbox,
          shuzentsumitatekin_hosoku: this.shuzentsumitatekin_hosoku,
          shuzentsumitatekin_taino_umu: this.shuzentsumitatekin_taino_umu,
          shuzentsumitatekin_tainokingaku: this.shuzentsumitatekin_tainokingaku,
          shuzentsumitatekin_taino_nengappi: this.shuzentsumitatekin_taino_nengappi,
          shuzentsumitatekin_taino_nengappi_checkbox: this.shuzentsumitatekin_taino_nengappi_checkbox,
          shuzentsumitatekin_tsumitategaku_kingaku: this.shuzentsumitatekin_tsumitategaku_kingaku,
          shuzentsumitatekin_tsumitategaku_nengappi: this.shuzentsumitatekin_tsumitategaku_nengappi,
          shuzentsumitatekin_tsumitategaku_nengappi_checkbox: this.shuzentsumitatekin_tsumitategaku_nengappi_checkbox,
          shuzentsumitatekin_tsumitategaku_umusentaku: this.shuzentsumitatekin_tsumitategaku_umusentaku,
          shuzentsumitatekin_tsumitategaku_tainogaku_kingaku: this.shuzentsumitatekin_tsumitategaku_tainogaku_kingaku,
          shuzentsumitatekin_tsumitategaku_nengappi2: this.shuzentsumitatekin_tsumitategaku_nengappi2,
          shuzentsumitatekin_tsumitategaku_nengappi2_checkbox: this.shuzentsumitatekin_tsumitategaku_nengappi2_checkbox,
          kanrihi_kingaku: this.kanrihi_kingaku,
          kanrihi_nengappi: this.kanrihi_nengappi,
          kanrihi_nengappi_checkbox: this.kanrihi_nengappi_checkbox,
          kanrihi_hosoku: this.kanrihi_hosoku,
          kanrihi_tainoumu: this.kanrihi_tainoumu,
          kanrihi_tainokingaku: this.kanrihi_tainokingaku,
          kanrihi_taino_nengappi: this.kanrihi_taino_nengappi,
          kanrihi_taino_nengappi_checkbox: this.kanrihi_taino_nengappi_checkbox,
          kanrihi_taino_johokaiji_umu: this.kanrihi_taino_johokaiji_umu,
          kanrihi_taino_johokaiji_tainogaku: this.kanrihi_taino_johokaiji_tainogaku,
          kanrihi_taino_johokaiji_taino_nengappi: this.kanrihi_taino_johokaiji_taino_nengappi,
          kanrihi_taino_johokaiji_taino_nengappi_checkbox: this.kanrihi_taino_johokaiji_taino_nengappi_checkbox,
          kanrikumiai_meisho: this.kanrikumiai_meisho,
          kanri_keitai: this.kanri_keitai,
          kanriitakusaki_meisho: this.kanriitakusaki_meisho,
          kanriitakusaki_tenwabango: this.kanriitakusaki_tenwabango,
          // kanriitakusaki_tenwabango2: this.kanriitakusaki_tenwabango2,
          // kanriitakusaki_tenwabango3: this.kanriitakusaki_tenwabango3,
          kanriitakusaki_shozai: this.kanriitakusaki_shozai,
          kanriitakusaki_manshonkanritekiseikaho_toroku_bango: this.kanriitakusaki_manshonkanritekiseikaho_toroku_bango,
          kyoyobubun_umusentaku: this.kyoyobubun_umusentaku,
          kyoyobubun_jisshijokyo: this.kyoyobubun_jisshijokyo,
          senyububun_umusentaku: this.senyububun_umusentaku,
          senyububun_jisshijokyo: this.senyububun_jisshijokyo,
          sonohoka_biko: this.sonohoka_biko,
          takuchi_tatemono_jiko_sonohoka: this.takuchi_tatemono_jiko_sonohoka,
          jokyochosa_gaito_umu: this.jokyochosa_gaito_umu,
          jokyochosa_jisshi_umu: this.jokyochosa_jisshi_umu,
          jokyochosa_naiyo: this.jokyochosa_naiyo,
          tatemono_ijihozen_gaitokubun: this.tatemono_ijihozen_gaitokubun,
          kakunin_shinseisho_hozonumu1: this.kakunin_shinseisho_hozonumu1,
          kakuninzumisho_hozonumu2: this.kakuninzumisho_hozonumu2,
          kensazumisho_hozonumu3: this.kensazumisho_hozonumu3,
          zokaichiku_sentaku: this.zokaichiku_sentaku,
          kakunin_shinseisho_hozonumu4: this.kakunin_shinseisho_hozonumu4,
          kakuninzumisho_hozonumu5: this.kakuninzumisho_hozonumu5,
          kensazumisho_hozonumu6: this.kensazumisho_hozonumu6,
          tatemono_jokyochosa_jisshi_jutakudearu_baai: this.tatemono_jokyochosa_jisshi_jutakudearu_baai,
          tatemono_jokyochosa_hokokusho_hozonumu: this.tatemono_jokyochosa_hokokusho_hozonumu,
          kenchiku_kijunhodai_12jo_sentaku: this.kenchiku_kijunhodai_12jo_sentaku,
          teikichosa_teikihokokusho_hozonumu: this.teikichosa_teikihokokusho_hozonumu,
          kizonjutaku_seino_hyoka_sentaku: this.kizonjutaku_seino_hyoka_sentaku,
          kizonjutaku_seino_hyokasho_hozonumu: this.kizonjutaku_seino_hyokasho_hozonumu,
          shinchiku_koji_chaku_tatemonodearubaai_kubun: this.shinchiku_koji_chaku_tatemonodearubaai_kubun,
          kizonjutaku_seinohyokasho_umu: this.kizonjutaku_seinohyokasho_umu,
          taishinshindan_kekka_hokokusho_hozonumu: this.taishinshindan_kekka_hokokusho_hozonumu,
          shintaishinkijun_tekigosei_hozonumu: this.shintaishinkijun_tekigosei_hozonumu,
          kashihoken_hozonumu: this.kashihoken_hozonumu,
          taishinkijuntekigoshomeish_hozonumu: this.taishinkijuntekigoshomeish_hozonumu,
          sonohoka_nyuryoku: this.sonohoka_nyuryoku,
          sonohoka_hozonumu: this.sonohoka_hozonumu,
          taishinshindan_kekka_hokokusho_biko: this.taishinshindan_kekka_hokokusho_biko,
          kakuninzumisho_umusentaku: this.kakuninzumisho_umusentaku,
          kakuninzumisho_nengappi: this.kakuninzumisho_nengappi,
          kakuninzumisho_nengappi_checkbox: this.kakuninzumisho_nengappi_checkbox,
          kakuninzumisho_bango: this.kakuninzumisho_bango,
          kensazumisho_umusentaku: this.kensazumisho_umusentaku,
          kensazumisho_nengappi: this.kensazumisho_nengappi,
          kensazumisho_nengappi_checkbox: this.kensazumisho_nengappi_checkbox,
          kensazumisho_bango: this.kensazumisho_bango,
          kenchiku_kakuninzumisho_biko: this.kenchiku_kakuninzumisho_biko,
          jutakuseinohyoka_uketa_shinchiku_sentaku: this.jutakuseinohyoka_uketa_shinchiku_sentaku,
          sekkeijutaku_seino_hyokasho_umu: this.sekkeijutaku_seino_hyokasho_umu,
          kensetsujutaku_seino_hyokasho_umu: this.kensetsujutaku_seino_hyokasho_umu,
          ishiwatashiyo_chosa_umu_sentaku: this.ishiwatashiyo_chosa_umu_sentaku,
          zoseitakuchi_kuiki_sentaku: this.zoseitakuchi_kuiki_sentaku,
          doshasaigai_kuiki_sentaku: this.doshasaigai_kuiki_sentaku,
          tsunami_kuiki_sentaku: this.tsunami_kuiki_sentaku,
          hazadomappu_umu_kozui: this.hazadomappu_umu_kozui,
          hazadomappu_umu_usuishussui: this.hazadomappu_umu_usuishussui,
          hazadomappu_umu_takashio: this.hazadomappu_umu_takashio,
          hazadomappu_umu_setsumei: this.hazadomappu_umu_setsumei,
          senyoshiyoken: this.senyoshiyoken,
          tsunami_disaster_caution: this.tsunami_disaster_caution
        }
        this.$store.dispatch(SAVE_JRB_M007_08, jrb_i5_13).then(() => {
          this.$store.dispatch(SAVE_JRB, jrb_i5_13)
          this.$store.dispatch(SAVE_EDIT_MODE, {'jrb07_08': true})
          this.$store.dispatch(SAVE_KEIYAKU).then(() => {
            this.popupActiveSaveForm = false
            setTimeout(() => {
              this.$router.push({name: 'jusetsu-m006-01'})
            }, 200)
          })
        })
      }
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },
    // Handle cancel event
    handleCancelSaveJRB_I5_13() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      setTimeout(() => {
        this.$router.push({name: 'jusetsu-m006-01'})
      }, 200)
    },

    resetDataOnChange(key) {
      switch (key) {
      case 'tatemono_ijihozen_gaitokubun':
        if (this.tatemono_ijihozen_gaitokubun !== '1') {
          this.kakunin_shinseisho_hozonumu1 = null
          this.kakuninzumisho_hozonumu2 = null
          this.kensazumisho_hozonumu3 = null
        }
        break
      case 'zokaichiku_sentaku':
        if (this.zokaichiku_sentaku !== '0') {
          this.kakunin_shinseisho_hozonumu4 = null
          this.kakuninzumisho_hozonumu5 = null
          this.kensazumisho_hozonumu6 = null
        }
        break
      case 'tatemono_jokyochosa_jisshi_jutakudearu_baai':
        if (this.tatemono_jokyochosa_jisshi_jutakudearu_baai !== '0') {
          this.tatemono_jokyochosa_hokokusho_hozonumu = null
        }
        break
      case 'kenchiku_kijunhodai_12jo_sentaku':
        if (this.kenchiku_kijunhodai_12jo_sentaku !== '0') {
          this.teikichosa_teikihokokusho_hozonumu = null
        }
        break
      case 'kizonjutaku_seino_hyoka_sentaku':
        if (this.kizonjutaku_seino_hyoka_sentaku !== '0') {
          this.kizonjutaku_seino_hyokasho_hozonumu = null
        }
        break
      // case 'shinchiku_koji_chaku_tatemonodearubaai_kubun':
      //   if (this.shinchiku_koji_chaku_tatemonodearubaai_kubun !== '0') {
      //     this.kizonjutaku_seinohyokasho_umu = null
      //     this.taishinshindan_kekka_hokokusho_hozonumu = null
      //     this.shintaishinkijun_tekigosei_hozonumu = null
      //     this.kashihoken_hozonumu = null
      //     this.taishinkijuntekigoshomeish_hozonumu = null
      //     this.sonohoka_nyuryoku = ''
      //     this.sonohoka_hozonumu = null
      //   }
      //   break
      }
    },
    bunshoScreen(num) {
      if (this.jrb !== 'jrb-01') {
        switch (+num) {
        case 1:
          return 'M007-08-1'
        case 2:
          return 'M007-08-2'
        case 3:
          return 'M007-08-3'
        case 4:
          return 'M007-08-4'
        case 5:
          return 'M007-08-5'
        case 6:
          return 'M007-08-6'
        case 7:
          return 'M007-08-7'
        }
      }
      if (this.jrb) {
        switch (+num) {
        case 8:
          return 'M007-08-8'
        case 9:
          if (this.jrb === 'jrb-01' || this.jrb === 'jrb-02') {
            return 'M007-08-9'
          }
          if (this.jrb === 'jrb-03' || this.jrb === 'jrb-04') {
            return 'M007-08-10'
          }
        }
      }
      if(+num === 10) {
        return 'M007-08-11'
      }
    },
    validateWarning() {
      const context = this
      this.hasWarning = false
      this.attentionWaringStatus = false
      Object.keys(this.formValidation).forEach(key => {
        this.formValidation[key].isWarning = false
        if (!this.formValidation[key].patterns || !this.formValidation[key].patterns.length
          || this.formValidation[key].patterns.includes(this.jrb)) {
          // ARRAY
          if (this.formValidation[key].elements) {
            this.formValidation[key].elements.forEach((child, idx) => {
              Object.keys(child).forEach(childKey => {
                if (typeof (context.formValidation[key].elements[idx][childKey].warning) === 'function' && this.formValidation[key].elements[idx][childKey].warning(idx)) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                } else if (typeof (context.formValidation[key].elements[idx][childKey].warning) !== 'function'
                  && (context[key][idx][childKey] === null || context[key][idx][childKey] === undefined
                  || context[key][idx][childKey] === '' || context[key][idx][childKey] === false
                  || context[key][idx][childKey] === '　')) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                } else {
                  context.formValidation[key].elements[idx][childKey].isWarning = false
                  context.highlight(childKey, false, idx)
                }
              })
            })
          } else if (typeof (this.formValidation[key].warning) === 'function' && this.formValidation[key].warning()) {
            this.formValidation[key].isWarning = true
            if(this.formValidation[key].attentionWarning) {
              this.attentionWaringStatus = true
            }else{
              this.hasWarning = true
            }
            this.highlight(key)
          } else if (typeof (this.formValidation[key].warning) !== 'function' && this.formValidation[key].warning
            && (this[key] === null || this[key] === undefined || this[key] === '' || this[key] === false || this[key] === '　')) {
            this.formValidation[key].isWarning = true
            this.highlight(key)
            this.hasWarning = true
          } else {
            this.highlight(key, false)
          }
        }
      })
      if(this.validateSenyoshiyokenArray() === true) {
        this.hasWarning = true
      }
      if(this.validateFuzuisenyoShiyokenArray() === true) {
        this.hasWarning = true
      }
      this.checkValidate = true
      return this.hasWarning
    },
    validateSenyoshiyokenArray() {
      for (let i = 0; i < this.senyoshiyoken_inputs.length; i++) {
        const element = this.senyoshiyoken_inputs[i]
        if(!(element.meisho === null || element.meisho === undefined || element.meisho === '')) {
          this.senyoshiyokenFormValidation[i] = {
            umusentaku : {
              warningMsg : MESSAGE.E8051,
              isWarning: true
            },
            kizokusaki_umusentaku : {
              warningMsg : MESSAGE.E8051,
              isWarning: true
            },
            senyoshiyoryo_kizokusaki_kubun : {
              warningMsg : MESSAGE.E8051,
              isWarning: true
            }
          }
          if(element.umusentaku === null || element.umusentaku === undefined || element.umusentaku === '') {
            this.highlight(`senyoshiyoken_t.umusentaku-${i}`)
            this.senyoshiyokenFormValidation[i].umusentaku.isWarning = false
          }else{
            this.unhighlight(`senyoshiyoken_t.umusentaku-${i}`)
            this.senyoshiyokenFormValidation[i].umusentaku.isWarning = true
          }
          if(element.umusentaku === '1'  && (element.kizokusaki_umusentaku === null || element.kizokusaki_umusentaku === undefined || element.kizokusaki_umusentaku === '')) {
            this.highlight(`senyoshiyoken_t.kizokusaki_umusentaku-${i}`)
            this.senyoshiyokenFormValidation[i].kizokusaki_umusentaku.isWarning = false
          }else{
            this.unhighlight(`senyoshiyoken_t.kizokusaki_umusentaku-${i}`)
            this.senyoshiyokenFormValidation[i].kizokusaki_umusentaku.isWarning = true
          }
          if(element.kizokusaki_umusentaku === '1'  && (element.senyoshiyoryo_kizokusaki_kubun === null || element.senyoshiyoryo_kizokusaki_kubun === undefined || element.senyoshiyoryo_kizokusaki_kubun === '')) {
            this.highlight(`senyoshiyoken_t.senyoshiyoryo_kizokusaki_kubun-${i}`)
            this.senyoshiyokenFormValidation[i].senyoshiyoryo_kizokusaki_kubun.isWarning = false
          }else{
            this.unhighlight(`senyoshiyoken_t.senyoshiyoryo_kizokusaki_kubun-${i}`)
            this.senyoshiyokenFormValidation[i].senyoshiyoryo_kizokusaki_kubun.isWarning = true
          }
        }
      }
    },
    validateFuzuisenyoShiyokenArray() {
      for (let i = 0; i < this.fuzuisenyo_shiyoken_inputs.length; i++) {
        const element = this.fuzuisenyo_shiyoken_inputs[i]
        if(!(element.meisho === null || element.meisho === undefined || element.meisho === '')) {
          this.fuzuisenyoShiyokenFormValidation[i] = {
            naiyo : {
              warningMsg : MESSAGE.E8051,
              isWarning: true
            }
          }
          if(element.naiyo === null || element.naiyo === undefined || element.naiyo === '') {
            this.highlight(`fuzuisenyo_shiyoken_t.naiyo-${i}`)
            this.fuzuisenyoShiyokenFormValidation[i].naiyo.isWarning = false
          }else{
            this.unhighlight(`fuzuisenyo_shiyoken_t.naiyo-${i}`)
            this.fuzuisenyoShiyokenFormValidation[i].naiyo.isWarning = true
          }
        }
      }
    },

    validateError() {
      this.hasError = false
      const filterErrorKeys = Object.keys(this.formValidation).filter(key => this.formValidation[key].error)
      filterErrorKeys.forEach(key => {
        if (this.formValidation[key].error()) {
          this.formValidation[key].isError = true
          this.hasError = true
        } else {
          this.formValidation[key].isError = false
        }
      })
      this.checkValidate = true
      return this.hasError
    },
    async checkSave() {
      const hasError = await this.validateError()
      if (hasError) {
        this.popupFormError = true
        return false
      }
      await this.validateWarning()
      if(this.hasWarning && this.attentionWaringStatus) {
        this.messageWhenHanei = MESSAGE.M1019
      } else if(this.hasWarning) {
        this.messageWhenHanei = MESSAGE.M1017
      } else if(this.attentionWaringStatus) {
        this.messageWhenHanei = MESSAGE.M1018
      } else {
        this.messageWhenHanei = MESSAGE.M1007
      }
      this.popupActiveSaveForm = true
    },
    highlight(key, isHighlight = true, eleIndex = null) {
      if (eleIndex === null) {
        // selectbox
        if (isHighlight) {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // checkbox
        $('.con-vs-checkbox').each((idx, el) => {
          if ($(el).find(`input[vs-name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          } else if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (isHighlight) {
          inputEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          inputEl.css({'background-color': 'inherit'})
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (isHighlight) {
          textareaEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          textareaEl.css({'background-color': 'inherit'})
        }
        // datepicker
        const selectEl = $(`div[datepicker='${key}']`).find('.vs__dropdown-toggle')
        const yearEl = $(`div[datepicker='${key}']`).find('input[name="year"]')
        const monthEl = $(`div[datepicker='${key}']`).find('input[name="month"]')
        const dayEl = $(`div[datepicker='${key}']`).find('input[name="day"]')
        if (isHighlight) {
          selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          selectEl.css({'background-color': 'inherit'})
          yearEl.css({'background-color': 'inherit'})
          monthEl.css({'background-color': 'inherit'})
          dayEl.css({'background-color': 'inherit'})
        }
      } else {
        // selectbox
        const selectboxEl = $(`.v-select[name='${key}']`)
        if (selectboxEl.length) {
          if (isHighlight) {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
          }
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          const radioEl = $(el).find(`input[name='${key}']`)
          if (radioEl.length && $(radioEl[eleIndex]).length) {
            if (isHighlight) {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (inputEl.length) {
          if (isHighlight) {
            $(inputEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(inputEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (textareaEl.length) {
          if (isHighlight) {
            $(textareaEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(textareaEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }

        // datepicker
        if ($(`div[datepicker='${key}']`).length) {
          const selectEl = $(`div[datepicker='${key}']`)[eleIndex].find('.vs__dropdown-toggle')
          const yearEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="year"]')
          const monthEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="month"]')
          const dayEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="day"]')
          if (isHighlight) {
            selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            selectEl.css({'background-color': 'inherit'})
            yearEl.css({'background-color': 'inherit'})
            monthEl.css({'background-color': 'inherit'})
            dayEl.css({'background-color': 'inherit'})
          }
        }
      }
    },
    unhighlight(key) {
      // radiobox
      $('.con-vs-radio').each((idx, el) => {
        if ($(el).find(`input[name='${key}']`).length) {
          $(el).find('span.vs-radio--borde').css({'border-color': 'rgb(200, 200, 200)'})
        }
      })

      // vs-input
      $(`input[name='${key}']`).css({'background-color': '#ffffff'})

      // vs-textarea
      $(`textarea[name='${key}']`).css({'background-color': '#ffffff'})

      // datepicker
      const selectEl = $(`div[datepicker='${key}']`).find('.vs__selected-options input')
      const yearEl = $(`div[datepicker='${key}']`).find('input[name="year"]')
      const monthEl = $(`div[datepicker='${key}']`).find('input[name="month"]')
      const dayEl = $(`div[datepicker='${key}']`).find('input[name="day"]')

      selectEl.css({'background-color': '#ffffff'})
      yearEl.css({'background-color': '#ffffff'})
      monthEl.css({'background-color': '#ffffff'})
      dayEl.css({'background-color': '#ffffff'})
    },
    lostFocus() {
      if (this.checkValidate === true) {
        setTimeout(() => {
          this.validateError()
          this.validateWarning()
        }, 200)
      }
    },
    focusOut() {
      this.currentFocus = 0
      this.lostFocus()
    },
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          if(!ele.label_flg) {
            idElement.push(ele.id_element)
          }
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('jrb'))
    },
    handleGetCommentId() {
      let jrbPatternHighlight = []
      switch (this.jrb) {
      case 'jrb-01':
        jrbPatternHighlight = M007_08_jrb01Highlight
        this.index = 41
        break
      case 'jrb-02':
        jrbPatternHighlight = M007_08_jrb02Highlight
        this.index = 42
        break
      case 'jrb-03':
        jrbPatternHighlight = M007_08_jrb03_04Highlight
        this.index = 38
        break
      case 'jrb-04':
        jrbPatternHighlight = M007_08_jrb03_04Highlight
        this.index = 38
        break
      default:
        break
      }
      const jrbHighlight = jrbPatternHighlight.map(item => {
        if(item) {
          this.index = this.index + 1
          item = `${this.jrb}-${this.index}`
        }
        return item
      })
      this.arrayCommentId = jrbHighlight
    },
    handleShowHightlightInPage(highlight) {
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    }
  }
}
</script>

<style scoped>
.jrb {
  font-weight: bold;
}
.input1-width {
  width: 50px;
}
.jrb /deep/ .input-warning input {
  background-color: rgb(255 197 54 / 60%) !important;
}
.input2-width {
  width: 90px;
}

.sytle-button {
  display: flex;
  justify-content: flex-end;
  margin: 30px;
  gap: 30px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  border-radius:0px ;
}
td {
  font-size: 0.85rem;
  font-weight: 750;
}

.table-out {
  margin: 10px 0px;
  border: 2px solid rgb(201, 198, 198);
  border-radius: 5px;
  border-collapse: collapse;
}

.m-auto-top-bottom {
  margin: auto 0 ;
}

.col-title {
  color: white;
  background-color: #80808069;
  border-radius: 0px;
}

.con-exemple-prompt{
  padding: 10px;
  padding-bottom: 0px;
}

.itaku-dialog td {
  font-weight: 400;
}

.itaku-dialog th {
  text-align: center;
}

.mtb-10{
  margin: 10px 0;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.footer-button{
  gap: 30px;
}
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;
}
.comment-frame {
  overflow: scroll;
  height: 620px;
  margin-top: 0.75rem;

}
.w-57 {
  width: 56%;
}
.w-65 {
  width: 65%;
}
.mr-7px {
  margin-right: 7px;
}
.mt-8px {
  margin-top: 8px;
}
</style>
